import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  bigint: any;
  date: any;
  json: any;
  jsonb: any;
  numeric: any;
  point: any;
  timestamp: any;
  timestamptz: any;
  uuid: any;
};

export type AddressValidationInput = {
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type AddressValidationOutput = {
  __typename?: 'AddressValidationOutput';
  address1: Maybe<Scalars['String']>;
  address2: Maybe<Scalars['String']>;
  city: Maybe<Scalars['String']>;
  error: Maybe<Scalars['String']>;
  state: Maybe<Scalars['String']>;
  zip: Maybe<Scalars['String']>;
  zip4: Maybe<Scalars['String']>;
};

export type AffiliateMetrics = {
  __typename?: 'AffiliateMetrics';
  leads: Maybe<Scalars['Int']>;
  purchases: Maybe<Scalars['Int']>;
  visitors: Maybe<Scalars['Int']>;
};

export type ApproveOutput = {
  __typename?: 'ApproveOutput';
  isSuccessful: Scalars['Boolean'];
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

export type EmailOutput = {
  __typename?: 'EmailOutput';
  status: Scalars['String'];
};

export type GetDigitalProductForCustomerOrderOutput = {
  __typename?: 'GetDigitalProductForCustomerOrderOutput';
  createdAt: Scalars['timestamp'];
  description: Maybe<Scalars['String']>;
  groups: Scalars['json'];
  name: Maybe<Scalars['String']>;
  sku: Scalars['String'];
  updatedAt: Maybe<Scalars['timestamp']>;
};

export type HubspotBlogOutput = {
  __typename?: 'HubspotBlogOutput';
  archived: Scalars['Boolean'];
  archivedInDashboard: Scalars['Boolean'];
  attachedStylesheets: Maybe<Scalars['String']>;
  authorName: Scalars['String'];
  blogAuthorId: Scalars['String'];
  campaign: Maybe<Scalars['String']>;
  categoryId: Scalars['Int'];
  contentGroupId: Scalars['String'];
  contentTypeCategory: Scalars['Int'];
  created: Maybe<Scalars['timestamptz']>;
  createdById: Scalars['String'];
  currentState: Scalars['String'];
  currentlyPublished: Scalars['Boolean'];
  deletedAt: Scalars['timestamptz'];
  domain: Maybe<Scalars['String']>;
  featuredImage: Scalars['String'];
  featuredImageAltText: Maybe<Scalars['String']>;
  htmlTitle: Scalars['String'];
  id: Scalars['String'];
  language: Scalars['String'];
  layoutSections: Maybe<Scalars['String']>;
  metaDescription: Scalars['String'];
  name: Scalars['String'];
  pageExpiryEnabled: Maybe<Scalars['Boolean']>;
  postBody: Scalars['String'];
  postSummary: Scalars['String'];
  publishDate: Scalars['timestamptz'];
  publishImmediately: Maybe<Scalars['Boolean']>;
  rssBody: Scalars['String'];
  rssSummary: Scalars['String'];
  slug: Scalars['String'];
  state: Scalars['String'];
  tagIds: Maybe<Scalars['Int']>;
  updated: Scalars['timestamptz'];
  updatedById: Scalars['String'];
  url: Scalars['String'];
  useFeaturedImage: Scalars['Boolean'];
  widgetContainers: Maybe<Scalars['String']>;
  widgets: Maybe<Scalars['String']>;
};

export type InsertRolesOneForUserOutput = {
  __typename?: 'InsertRolesOneForUserOutput';
  id: Scalars['uuid'];
  /** An object relationship */
  userRoles: UserRoles;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

export type MagentoOrdersOutput = {
  __typename?: 'MagentoOrdersOutput';
  orders: Scalars['json'];
};

export type MagentoToken = {
  __typename?: 'MagentoToken';
  token: Scalars['String'];
};

export type RegisterAndLoginOutput = {
  __typename?: 'RegisterAndLoginOutput';
  token: Scalars['String'];
  userId: Scalars['String'];
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/**
 * API Keys are used for Auth0 Applications to give them a role when they authenticate.
 *
 *
 * columns and relationships of "apiKeys"
 */
export type ApiKeys = {
  __typename?: 'apiKeys';
  auth0ClientId: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  exchange: Maybe<Exchanges>;
  exchangeId: Maybe<Scalars['uuid']>;
  key: Scalars['uuid'];
  name: Scalars['String'];
  /** An object relationship */
  owner: Users;
  /** An object relationship */
  role: Maybe<Roles>;
  roleId: Maybe<Scalars['uuid']>;
  updatedAt: Scalars['timestamptz'];
  userId: Scalars['uuid'];
};

/** aggregated selection of "apiKeys" */
export type ApiKeys_Aggregate = {
  __typename?: 'apiKeys_aggregate';
  aggregate: Maybe<ApiKeys_Aggregate_Fields>;
  nodes: Array<ApiKeys>;
};

/** aggregate fields of "apiKeys" */
export type ApiKeys_Aggregate_Fields = {
  __typename?: 'apiKeys_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<ApiKeys_Max_Fields>;
  min: Maybe<ApiKeys_Min_Fields>;
};


/** aggregate fields of "apiKeys" */
export type ApiKeys_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<ApiKeys_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "apiKeys" */
export type ApiKeys_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ApiKeys_Max_Order_By>;
  min?: InputMaybe<ApiKeys_Min_Order_By>;
};

/** input type for inserting array relation for remote table "apiKeys" */
export type ApiKeys_Arr_Rel_Insert_Input = {
  data: Array<ApiKeys_Insert_Input>;
  /** on conflict condition */
  on_conflict?: InputMaybe<ApiKeys_On_Conflict>;
};

/** Boolean expression to filter rows from the table "apiKeys". All fields are combined with a logical 'AND'. */
export type ApiKeys_Bool_Exp = {
  _and?: InputMaybe<Array<ApiKeys_Bool_Exp>>;
  _not?: InputMaybe<ApiKeys_Bool_Exp>;
  _or?: InputMaybe<Array<ApiKeys_Bool_Exp>>;
  auth0ClientId?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  exchange?: InputMaybe<Exchanges_Bool_Exp>;
  exchangeId?: InputMaybe<Uuid_Comparison_Exp>;
  key?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<Users_Bool_Exp>;
  role?: InputMaybe<Roles_Bool_Exp>;
  roleId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "apiKeys" */
export enum ApiKeys_Constraint {
  /** unique or primary key constraint */
  ApiKeyPkey = 'apiKey_pkey',
  /** unique or primary key constraint */
  ApiKeysNameAuth0ClientIdKey = 'apiKeys_name_auth0ClientId_key'
}

/** input type for inserting data into table "apiKeys" */
export type ApiKeys_Insert_Input = {
  auth0ClientId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  exchange?: InputMaybe<Exchanges_Obj_Rel_Insert_Input>;
  exchangeId?: InputMaybe<Scalars['uuid']>;
  key?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  role?: InputMaybe<Roles_Obj_Rel_Insert_Input>;
  roleId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ApiKeys_Max_Fields = {
  __typename?: 'apiKeys_max_fields';
  auth0ClientId: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['timestamptz']>;
  exchangeId: Maybe<Scalars['uuid']>;
  key: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  roleId: Maybe<Scalars['uuid']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
  userId: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "apiKeys" */
export type ApiKeys_Max_Order_By = {
  auth0ClientId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  exchangeId?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  roleId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ApiKeys_Min_Fields = {
  __typename?: 'apiKeys_min_fields';
  auth0ClientId: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['timestamptz']>;
  exchangeId: Maybe<Scalars['uuid']>;
  key: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  roleId: Maybe<Scalars['uuid']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
  userId: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "apiKeys" */
export type ApiKeys_Min_Order_By = {
  auth0ClientId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  exchangeId?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  roleId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "apiKeys" */
export type ApiKeys_Mutation_Response = {
  __typename?: 'apiKeys_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ApiKeys>;
};

/** on conflict condition type for table "apiKeys" */
export type ApiKeys_On_Conflict = {
  constraint: ApiKeys_Constraint;
  update_columns: Array<ApiKeys_Update_Column>;
  where?: InputMaybe<ApiKeys_Bool_Exp>;
};

/** Ordering options when selecting data from "apiKeys". */
export type ApiKeys_Order_By = {
  auth0ClientId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  exchange?: InputMaybe<Exchanges_Order_By>;
  exchangeId?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner?: InputMaybe<Users_Order_By>;
  role?: InputMaybe<Roles_Order_By>;
  roleId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: apiKeys */
export type ApiKeys_Pk_Columns_Input = {
  key: Scalars['uuid'];
};

/** select columns of table "apiKeys" */
export enum ApiKeys_Select_Column {
  /** column name */
  Auth0ClientId = 'auth0ClientId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExchangeId = 'exchangeId',
  /** column name */
  Key = 'key',
  /** column name */
  Name = 'name',
  /** column name */
  RoleId = 'roleId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "apiKeys" */
export type ApiKeys_Set_Input = {
  auth0ClientId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  exchangeId?: InputMaybe<Scalars['uuid']>;
  key?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  roleId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "apiKeys" */
export enum ApiKeys_Update_Column {
  /** column name */
  Auth0ClientId = 'auth0ClientId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExchangeId = 'exchangeId',
  /** column name */
  Key = 'key',
  /** column name */
  Name = 'name',
  /** column name */
  RoleId = 'roleId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']>;
  _gt?: InputMaybe<Scalars['bigint']>;
  _gte?: InputMaybe<Scalars['bigint']>;
  _in?: InputMaybe<Array<Scalars['bigint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['bigint']>;
  _lte?: InputMaybe<Scalars['bigint']>;
  _neq?: InputMaybe<Scalars['bigint']>;
  _nin?: InputMaybe<Array<Scalars['bigint']>>;
};

/** columns and relationships of "callToActionConfigs" */
export type CallToActionConfigs = {
  __typename?: 'callToActionConfigs';
  contactEmail: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  cs_url1: Maybe<Scalars['String']>;
  cs_url2: Maybe<Scalars['String']>;
  cs_url3: Maybe<Scalars['String']>;
  cs_url4: Maybe<Scalars['String']>;
  environmentId: Maybe<Scalars['uuid']>;
  faq_url: Maybe<Scalars['String']>;
  /** An array relationship */
  fields: Array<CallToActionFields>;
  /** An aggregate relationship */
  fields_aggregate: CallToActionFields_Aggregate;
  id: Scalars['uuid'];
  skuProduct1: Maybe<Scalars['String']>;
  skuProduct2: Maybe<Scalars['String']>;
  skuProduct3: Maybe<Scalars['String']>;
  skuProduct4: Maybe<Scalars['String']>;
  storeSku: Maybe<Scalars['String']>;
  template: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  url: Scalars['String'];
  /** An object relationship */
  user: UserData;
  userId: Scalars['uuid'];
};


/** columns and relationships of "callToActionConfigs" */
export type CallToActionConfigsFieldsArgs = {
  distinct_on: InputMaybe<Array<CallToActionFields_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<CallToActionFields_Order_By>>;
  where: InputMaybe<CallToActionFields_Bool_Exp>;
};


/** columns and relationships of "callToActionConfigs" */
export type CallToActionConfigsFields_AggregateArgs = {
  distinct_on: InputMaybe<Array<CallToActionFields_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<CallToActionFields_Order_By>>;
  where: InputMaybe<CallToActionFields_Bool_Exp>;
};

/** aggregated selection of "callToActionConfigs" */
export type CallToActionConfigs_Aggregate = {
  __typename?: 'callToActionConfigs_aggregate';
  aggregate: Maybe<CallToActionConfigs_Aggregate_Fields>;
  nodes: Array<CallToActionConfigs>;
};

/** aggregate fields of "callToActionConfigs" */
export type CallToActionConfigs_Aggregate_Fields = {
  __typename?: 'callToActionConfigs_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<CallToActionConfigs_Max_Fields>;
  min: Maybe<CallToActionConfigs_Min_Fields>;
};


/** aggregate fields of "callToActionConfigs" */
export type CallToActionConfigs_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<CallToActionConfigs_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "callToActionConfigs". All fields are combined with a logical 'AND'. */
export type CallToActionConfigs_Bool_Exp = {
  _and?: InputMaybe<Array<CallToActionConfigs_Bool_Exp>>;
  _not?: InputMaybe<CallToActionConfigs_Bool_Exp>;
  _or?: InputMaybe<Array<CallToActionConfigs_Bool_Exp>>;
  contactEmail?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  cs_url1?: InputMaybe<String_Comparison_Exp>;
  cs_url2?: InputMaybe<String_Comparison_Exp>;
  cs_url3?: InputMaybe<String_Comparison_Exp>;
  cs_url4?: InputMaybe<String_Comparison_Exp>;
  environmentId?: InputMaybe<Uuid_Comparison_Exp>;
  faq_url?: InputMaybe<String_Comparison_Exp>;
  fields?: InputMaybe<CallToActionFields_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  skuProduct1?: InputMaybe<String_Comparison_Exp>;
  skuProduct2?: InputMaybe<String_Comparison_Exp>;
  skuProduct3?: InputMaybe<String_Comparison_Exp>;
  skuProduct4?: InputMaybe<String_Comparison_Exp>;
  storeSku?: InputMaybe<String_Comparison_Exp>;
  template?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<UserData_Bool_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "callToActionConfigs" */
export enum CallToActionConfigs_Constraint {
  /** unique or primary key constraint */
  CallToActionConfigPkey = 'callToActionConfig_pkey'
}

/** input type for inserting data into table "callToActionConfigs" */
export type CallToActionConfigs_Insert_Input = {
  contactEmail?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  cs_url1?: InputMaybe<Scalars['String']>;
  cs_url2?: InputMaybe<Scalars['String']>;
  cs_url3?: InputMaybe<Scalars['String']>;
  cs_url4?: InputMaybe<Scalars['String']>;
  environmentId?: InputMaybe<Scalars['uuid']>;
  faq_url?: InputMaybe<Scalars['String']>;
  fields?: InputMaybe<CallToActionFields_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  skuProduct1?: InputMaybe<Scalars['String']>;
  skuProduct2?: InputMaybe<Scalars['String']>;
  skuProduct3?: InputMaybe<Scalars['String']>;
  skuProduct4?: InputMaybe<Scalars['String']>;
  storeSku?: InputMaybe<Scalars['String']>;
  template?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<UserData_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type CallToActionConfigs_Max_Fields = {
  __typename?: 'callToActionConfigs_max_fields';
  contactEmail: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['timestamptz']>;
  cs_url1: Maybe<Scalars['String']>;
  cs_url2: Maybe<Scalars['String']>;
  cs_url3: Maybe<Scalars['String']>;
  cs_url4: Maybe<Scalars['String']>;
  environmentId: Maybe<Scalars['uuid']>;
  faq_url: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  skuProduct1: Maybe<Scalars['String']>;
  skuProduct2: Maybe<Scalars['String']>;
  skuProduct3: Maybe<Scalars['String']>;
  skuProduct4: Maybe<Scalars['String']>;
  storeSku: Maybe<Scalars['String']>;
  template: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
  url: Maybe<Scalars['String']>;
  userId: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type CallToActionConfigs_Min_Fields = {
  __typename?: 'callToActionConfigs_min_fields';
  contactEmail: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['timestamptz']>;
  cs_url1: Maybe<Scalars['String']>;
  cs_url2: Maybe<Scalars['String']>;
  cs_url3: Maybe<Scalars['String']>;
  cs_url4: Maybe<Scalars['String']>;
  environmentId: Maybe<Scalars['uuid']>;
  faq_url: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  skuProduct1: Maybe<Scalars['String']>;
  skuProduct2: Maybe<Scalars['String']>;
  skuProduct3: Maybe<Scalars['String']>;
  skuProduct4: Maybe<Scalars['String']>;
  storeSku: Maybe<Scalars['String']>;
  template: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
  url: Maybe<Scalars['String']>;
  userId: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "callToActionConfigs" */
export type CallToActionConfigs_Mutation_Response = {
  __typename?: 'callToActionConfigs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CallToActionConfigs>;
};

/** input type for inserting object relation for remote table "callToActionConfigs" */
export type CallToActionConfigs_Obj_Rel_Insert_Input = {
  data: CallToActionConfigs_Insert_Input;
  /** on conflict condition */
  on_conflict?: InputMaybe<CallToActionConfigs_On_Conflict>;
};

/** on conflict condition type for table "callToActionConfigs" */
export type CallToActionConfigs_On_Conflict = {
  constraint: CallToActionConfigs_Constraint;
  update_columns: Array<CallToActionConfigs_Update_Column>;
  where?: InputMaybe<CallToActionConfigs_Bool_Exp>;
};

/** Ordering options when selecting data from "callToActionConfigs". */
export type CallToActionConfigs_Order_By = {
  contactEmail?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  cs_url1?: InputMaybe<Order_By>;
  cs_url2?: InputMaybe<Order_By>;
  cs_url3?: InputMaybe<Order_By>;
  cs_url4?: InputMaybe<Order_By>;
  environmentId?: InputMaybe<Order_By>;
  faq_url?: InputMaybe<Order_By>;
  fields_aggregate?: InputMaybe<CallToActionFields_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  skuProduct1?: InputMaybe<Order_By>;
  skuProduct2?: InputMaybe<Order_By>;
  skuProduct3?: InputMaybe<Order_By>;
  skuProduct4?: InputMaybe<Order_By>;
  storeSku?: InputMaybe<Order_By>;
  template?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  user?: InputMaybe<UserData_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: callToActionConfigs */
export type CallToActionConfigs_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "callToActionConfigs" */
export enum CallToActionConfigs_Select_Column {
  /** column name */
  ContactEmail = 'contactEmail',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CsUrl1 = 'cs_url1',
  /** column name */
  CsUrl2 = 'cs_url2',
  /** column name */
  CsUrl3 = 'cs_url3',
  /** column name */
  CsUrl4 = 'cs_url4',
  /** column name */
  EnvironmentId = 'environmentId',
  /** column name */
  FaqUrl = 'faq_url',
  /** column name */
  Id = 'id',
  /** column name */
  SkuProduct1 = 'skuProduct1',
  /** column name */
  SkuProduct2 = 'skuProduct2',
  /** column name */
  SkuProduct3 = 'skuProduct3',
  /** column name */
  SkuProduct4 = 'skuProduct4',
  /** column name */
  StoreSku = 'storeSku',
  /** column name */
  Template = 'template',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Url = 'url',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "callToActionConfigs" */
export type CallToActionConfigs_Set_Input = {
  contactEmail?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  cs_url1?: InputMaybe<Scalars['String']>;
  cs_url2?: InputMaybe<Scalars['String']>;
  cs_url3?: InputMaybe<Scalars['String']>;
  cs_url4?: InputMaybe<Scalars['String']>;
  environmentId?: InputMaybe<Scalars['uuid']>;
  faq_url?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  skuProduct1?: InputMaybe<Scalars['String']>;
  skuProduct2?: InputMaybe<Scalars['String']>;
  skuProduct3?: InputMaybe<Scalars['String']>;
  skuProduct4?: InputMaybe<Scalars['String']>;
  storeSku?: InputMaybe<Scalars['String']>;
  template?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "callToActionConfigs" */
export enum CallToActionConfigs_Update_Column {
  /** column name */
  ContactEmail = 'contactEmail',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CsUrl1 = 'cs_url1',
  /** column name */
  CsUrl2 = 'cs_url2',
  /** column name */
  CsUrl3 = 'cs_url3',
  /** column name */
  CsUrl4 = 'cs_url4',
  /** column name */
  EnvironmentId = 'environmentId',
  /** column name */
  FaqUrl = 'faq_url',
  /** column name */
  Id = 'id',
  /** column name */
  SkuProduct1 = 'skuProduct1',
  /** column name */
  SkuProduct2 = 'skuProduct2',
  /** column name */
  SkuProduct3 = 'skuProduct3',
  /** column name */
  SkuProduct4 = 'skuProduct4',
  /** column name */
  StoreSku = 'storeSku',
  /** column name */
  Template = 'template',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Url = 'url',
  /** column name */
  UserId = 'userId'
}

/** columns and relationships of "callToActionFields" */
export type CallToActionFields = {
  __typename?: 'callToActionFields';
  /** An object relationship */
  config: CallToActionConfigs;
  configId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  value: Scalars['String'];
};

/** aggregated selection of "callToActionFields" */
export type CallToActionFields_Aggregate = {
  __typename?: 'callToActionFields_aggregate';
  aggregate: Maybe<CallToActionFields_Aggregate_Fields>;
  nodes: Array<CallToActionFields>;
};

/** aggregate fields of "callToActionFields" */
export type CallToActionFields_Aggregate_Fields = {
  __typename?: 'callToActionFields_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<CallToActionFields_Max_Fields>;
  min: Maybe<CallToActionFields_Min_Fields>;
};


/** aggregate fields of "callToActionFields" */
export type CallToActionFields_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<CallToActionFields_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "callToActionFields" */
export type CallToActionFields_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<CallToActionFields_Max_Order_By>;
  min?: InputMaybe<CallToActionFields_Min_Order_By>;
};

/** input type for inserting array relation for remote table "callToActionFields" */
export type CallToActionFields_Arr_Rel_Insert_Input = {
  data: Array<CallToActionFields_Insert_Input>;
  /** on conflict condition */
  on_conflict?: InputMaybe<CallToActionFields_On_Conflict>;
};

/** Boolean expression to filter rows from the table "callToActionFields". All fields are combined with a logical 'AND'. */
export type CallToActionFields_Bool_Exp = {
  _and?: InputMaybe<Array<CallToActionFields_Bool_Exp>>;
  _not?: InputMaybe<CallToActionFields_Bool_Exp>;
  _or?: InputMaybe<Array<CallToActionFields_Bool_Exp>>;
  config?: InputMaybe<CallToActionConfigs_Bool_Exp>;
  configId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "callToActionFields" */
export enum CallToActionFields_Constraint {
  /** unique or primary key constraint */
  CallToActionFieldPkey = 'callToActionField_pkey'
}

/** input type for inserting data into table "callToActionFields" */
export type CallToActionFields_Insert_Input = {
  config?: InputMaybe<CallToActionConfigs_Obj_Rel_Insert_Input>;
  configId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type CallToActionFields_Max_Fields = {
  __typename?: 'callToActionFields_max_fields';
  configId: Maybe<Scalars['uuid']>;
  createdAt: Maybe<Scalars['timestamptz']>;
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
  value: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "callToActionFields" */
export type CallToActionFields_Max_Order_By = {
  configId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type CallToActionFields_Min_Fields = {
  __typename?: 'callToActionFields_min_fields';
  configId: Maybe<Scalars['uuid']>;
  createdAt: Maybe<Scalars['timestamptz']>;
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
  value: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "callToActionFields" */
export type CallToActionFields_Min_Order_By = {
  configId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "callToActionFields" */
export type CallToActionFields_Mutation_Response = {
  __typename?: 'callToActionFields_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CallToActionFields>;
};

/** on conflict condition type for table "callToActionFields" */
export type CallToActionFields_On_Conflict = {
  constraint: CallToActionFields_Constraint;
  update_columns: Array<CallToActionFields_Update_Column>;
  where?: InputMaybe<CallToActionFields_Bool_Exp>;
};

/** Ordering options when selecting data from "callToActionFields". */
export type CallToActionFields_Order_By = {
  config?: InputMaybe<CallToActionConfigs_Order_By>;
  configId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: callToActionFields */
export type CallToActionFields_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "callToActionFields" */
export enum CallToActionFields_Select_Column {
  /** column name */
  ConfigId = 'configId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "callToActionFields" */
export type CallToActionFields_Set_Input = {
  configId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "callToActionFields" */
export enum CallToActionFields_Update_Column {
  /** column name */
  ConfigId = 'configId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Value = 'value'
}

/** columns and relationships of "callToActionGlobalSettings" */
export type CallToActionGlobalSettings = {
  __typename?: 'callToActionGlobalSettings';
  createdAt: Scalars['timestamptz'];
  environmentId: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  value: Scalars['String'];
};

/** aggregated selection of "callToActionGlobalSettings" */
export type CallToActionGlobalSettings_Aggregate = {
  __typename?: 'callToActionGlobalSettings_aggregate';
  aggregate: Maybe<CallToActionGlobalSettings_Aggregate_Fields>;
  nodes: Array<CallToActionGlobalSettings>;
};

/** aggregate fields of "callToActionGlobalSettings" */
export type CallToActionGlobalSettings_Aggregate_Fields = {
  __typename?: 'callToActionGlobalSettings_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<CallToActionGlobalSettings_Max_Fields>;
  min: Maybe<CallToActionGlobalSettings_Min_Fields>;
};


/** aggregate fields of "callToActionGlobalSettings" */
export type CallToActionGlobalSettings_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<CallToActionGlobalSettings_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "callToActionGlobalSettings". All fields are combined with a logical 'AND'. */
export type CallToActionGlobalSettings_Bool_Exp = {
  _and?: InputMaybe<Array<CallToActionGlobalSettings_Bool_Exp>>;
  _not?: InputMaybe<CallToActionGlobalSettings_Bool_Exp>;
  _or?: InputMaybe<Array<CallToActionGlobalSettings_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  environmentId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "callToActionGlobalSettings" */
export enum CallToActionGlobalSettings_Constraint {
  /** unique or primary key constraint */
  CallToActionGlobalSettingsPkey = 'callToActionGlobalSettings_pkey'
}

/** input type for inserting data into table "callToActionGlobalSettings" */
export type CallToActionGlobalSettings_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  environmentId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type CallToActionGlobalSettings_Max_Fields = {
  __typename?: 'callToActionGlobalSettings_max_fields';
  createdAt: Maybe<Scalars['timestamptz']>;
  environmentId: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
  value: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type CallToActionGlobalSettings_Min_Fields = {
  __typename?: 'callToActionGlobalSettings_min_fields';
  createdAt: Maybe<Scalars['timestamptz']>;
  environmentId: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
  value: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "callToActionGlobalSettings" */
export type CallToActionGlobalSettings_Mutation_Response = {
  __typename?: 'callToActionGlobalSettings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CallToActionGlobalSettings>;
};

/** on conflict condition type for table "callToActionGlobalSettings" */
export type CallToActionGlobalSettings_On_Conflict = {
  constraint: CallToActionGlobalSettings_Constraint;
  update_columns: Array<CallToActionGlobalSettings_Update_Column>;
  where?: InputMaybe<CallToActionGlobalSettings_Bool_Exp>;
};

/** Ordering options when selecting data from "callToActionGlobalSettings". */
export type CallToActionGlobalSettings_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  environmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: callToActionGlobalSettings */
export type CallToActionGlobalSettings_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "callToActionGlobalSettings" */
export enum CallToActionGlobalSettings_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EnvironmentId = 'environmentId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "callToActionGlobalSettings" */
export type CallToActionGlobalSettings_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  environmentId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "callToActionGlobalSettings" */
export enum CallToActionGlobalSettings_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EnvironmentId = 'environmentId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Value = 'value'
}

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']>;
  _gt?: InputMaybe<Scalars['date']>;
  _gte?: InputMaybe<Scalars['date']>;
  _in?: InputMaybe<Array<Scalars['date']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['date']>;
  _lte?: InputMaybe<Scalars['date']>;
  _neq?: InputMaybe<Scalars['date']>;
  _nin?: InputMaybe<Array<Scalars['date']>>;
};

/** columns and relationships of "devicePublicIps" */
export type DevicePublicIps = {
  __typename?: 'devicePublicIps';
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  device: Devices;
  deviceId: Scalars['uuid'];
  id: Scalars['uuid'];
  publicIp: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "devicePublicIps" */
export type DevicePublicIps_Aggregate = {
  __typename?: 'devicePublicIps_aggregate';
  aggregate: Maybe<DevicePublicIps_Aggregate_Fields>;
  nodes: Array<DevicePublicIps>;
};

/** aggregate fields of "devicePublicIps" */
export type DevicePublicIps_Aggregate_Fields = {
  __typename?: 'devicePublicIps_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<DevicePublicIps_Max_Fields>;
  min: Maybe<DevicePublicIps_Min_Fields>;
};


/** aggregate fields of "devicePublicIps" */
export type DevicePublicIps_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<DevicePublicIps_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "devicePublicIps" */
export type DevicePublicIps_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<DevicePublicIps_Max_Order_By>;
  min?: InputMaybe<DevicePublicIps_Min_Order_By>;
};

/** input type for inserting array relation for remote table "devicePublicIps" */
export type DevicePublicIps_Arr_Rel_Insert_Input = {
  data: Array<DevicePublicIps_Insert_Input>;
  /** on conflict condition */
  on_conflict?: InputMaybe<DevicePublicIps_On_Conflict>;
};

/** Boolean expression to filter rows from the table "devicePublicIps". All fields are combined with a logical 'AND'. */
export type DevicePublicIps_Bool_Exp = {
  _and?: InputMaybe<Array<DevicePublicIps_Bool_Exp>>;
  _not?: InputMaybe<DevicePublicIps_Bool_Exp>;
  _or?: InputMaybe<Array<DevicePublicIps_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  device?: InputMaybe<Devices_Bool_Exp>;
  deviceId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  publicIp?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "devicePublicIps" */
export enum DevicePublicIps_Constraint {
  /** unique or primary key constraint */
  DevicePublicIpsPkey = 'device_public_ips_pkey'
}

/** input type for inserting data into table "devicePublicIps" */
export type DevicePublicIps_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  device?: InputMaybe<Devices_Obj_Rel_Insert_Input>;
  deviceId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  publicIp?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type DevicePublicIps_Max_Fields = {
  __typename?: 'devicePublicIps_max_fields';
  createdAt: Maybe<Scalars['timestamptz']>;
  deviceId: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  publicIp: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "devicePublicIps" */
export type DevicePublicIps_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deviceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  publicIp?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type DevicePublicIps_Min_Fields = {
  __typename?: 'devicePublicIps_min_fields';
  createdAt: Maybe<Scalars['timestamptz']>;
  deviceId: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  publicIp: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "devicePublicIps" */
export type DevicePublicIps_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deviceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  publicIp?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "devicePublicIps" */
export type DevicePublicIps_Mutation_Response = {
  __typename?: 'devicePublicIps_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DevicePublicIps>;
};

/** on conflict condition type for table "devicePublicIps" */
export type DevicePublicIps_On_Conflict = {
  constraint: DevicePublicIps_Constraint;
  update_columns: Array<DevicePublicIps_Update_Column>;
  where?: InputMaybe<DevicePublicIps_Bool_Exp>;
};

/** Ordering options when selecting data from "devicePublicIps". */
export type DevicePublicIps_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  device?: InputMaybe<Devices_Order_By>;
  deviceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  publicIp?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: devicePublicIps */
export type DevicePublicIps_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "devicePublicIps" */
export enum DevicePublicIps_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeviceId = 'deviceId',
  /** column name */
  Id = 'id',
  /** column name */
  PublicIp = 'publicIp',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "devicePublicIps" */
export type DevicePublicIps_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deviceId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  publicIp?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "devicePublicIps" */
export enum DevicePublicIps_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeviceId = 'deviceId',
  /** column name */
  Id = 'id',
  /** column name */
  PublicIp = 'publicIp',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** columns and relationships of "devices" */
export type Devices = {
  __typename?: 'devices';
  createdAt: Maybe<Scalars['timestamptz']>;
  /** Unique system UUID, usually generated by OS. */
  deviceKey: Maybe<Scalars['String']>;
  /** An array relationship */
  devicePublicIps: Array<DevicePublicIps>;
  /** An aggregate relationship */
  devicePublicIps_aggregate: DevicePublicIps_Aggregate;
  id: Scalars['uuid'];
  metadata: Scalars['jsonb'];
  metadataastext: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  /** Sp Saner token */
  token: Maybe<Scalars['String']>;
  type: Scalars['String'];
  updatedAt: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  user: Maybe<Users>;
  userId: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "devices" */
export type DevicesDevicePublicIpsArgs = {
  distinct_on: InputMaybe<Array<DevicePublicIps_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<DevicePublicIps_Order_By>>;
  where: InputMaybe<DevicePublicIps_Bool_Exp>;
};


/** columns and relationships of "devices" */
export type DevicesDevicePublicIps_AggregateArgs = {
  distinct_on: InputMaybe<Array<DevicePublicIps_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<DevicePublicIps_Order_By>>;
  where: InputMaybe<DevicePublicIps_Bool_Exp>;
};


/** columns and relationships of "devices" */
export type DevicesMetadataArgs = {
  path: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "devices" */
export type Devices_Aggregate = {
  __typename?: 'devices_aggregate';
  aggregate: Maybe<Devices_Aggregate_Fields>;
  nodes: Array<Devices>;
};

/** aggregate fields of "devices" */
export type Devices_Aggregate_Fields = {
  __typename?: 'devices_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Devices_Max_Fields>;
  min: Maybe<Devices_Min_Fields>;
};


/** aggregate fields of "devices" */
export type Devices_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Devices_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "devices" */
export type Devices_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Devices_Max_Order_By>;
  min?: InputMaybe<Devices_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Devices_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "devices" */
export type Devices_Arr_Rel_Insert_Input = {
  data: Array<Devices_Insert_Input>;
  /** on conflict condition */
  on_conflict?: InputMaybe<Devices_On_Conflict>;
};

/** Boolean expression to filter rows from the table "devices". All fields are combined with a logical 'AND'. */
export type Devices_Bool_Exp = {
  _and?: InputMaybe<Array<Devices_Bool_Exp>>;
  _not?: InputMaybe<Devices_Bool_Exp>;
  _or?: InputMaybe<Array<Devices_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deviceKey?: InputMaybe<String_Comparison_Exp>;
  devicePublicIps?: InputMaybe<DevicePublicIps_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  metadataastext?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  token?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "devices" */
export enum Devices_Constraint {
  /** unique or primary key constraint */
  DevicesDeviceKeyKey = 'devices_deviceKey_key',
  /** unique or primary key constraint */
  DevicesPkey = 'devices_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Devices_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Devices_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Devices_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "devices" */
export type Devices_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** Unique system UUID, usually generated by OS. */
  deviceKey?: InputMaybe<Scalars['String']>;
  devicePublicIps?: InputMaybe<DevicePublicIps_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  metadataastext?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  /** Sp Saner token */
  token?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Devices_Max_Fields = {
  __typename?: 'devices_max_fields';
  createdAt: Maybe<Scalars['timestamptz']>;
  /** Unique system UUID, usually generated by OS. */
  deviceKey: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  metadataastext: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  /** Sp Saner token */
  token: Maybe<Scalars['String']>;
  type: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
  userId: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "devices" */
export type Devices_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  /** Unique system UUID, usually generated by OS. */
  deviceKey?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metadataastext?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  /** Sp Saner token */
  token?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Devices_Min_Fields = {
  __typename?: 'devices_min_fields';
  createdAt: Maybe<Scalars['timestamptz']>;
  /** Unique system UUID, usually generated by OS. */
  deviceKey: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  metadataastext: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  /** Sp Saner token */
  token: Maybe<Scalars['String']>;
  type: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
  userId: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "devices" */
export type Devices_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  /** Unique system UUID, usually generated by OS. */
  deviceKey?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metadataastext?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  /** Sp Saner token */
  token?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "devices" */
export type Devices_Mutation_Response = {
  __typename?: 'devices_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Devices>;
};

/** input type for inserting object relation for remote table "devices" */
export type Devices_Obj_Rel_Insert_Input = {
  data: Devices_Insert_Input;
  /** on conflict condition */
  on_conflict?: InputMaybe<Devices_On_Conflict>;
};

/** on conflict condition type for table "devices" */
export type Devices_On_Conflict = {
  constraint: Devices_Constraint;
  update_columns: Array<Devices_Update_Column>;
  where?: InputMaybe<Devices_Bool_Exp>;
};

/** Ordering options when selecting data from "devices". */
export type Devices_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deviceKey?: InputMaybe<Order_By>;
  devicePublicIps_aggregate?: InputMaybe<DevicePublicIps_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  metadataastext?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: devices */
export type Devices_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Devices_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "devices" */
export enum Devices_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeviceKey = 'deviceKey',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Metadataastext = 'metadataastext',
  /** column name */
  Name = 'name',
  /** column name */
  Token = 'token',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "devices" */
export type Devices_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** Unique system UUID, usually generated by OS. */
  deviceKey?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  metadataastext?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  /** Sp Saner token */
  token?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "devices" */
export enum Devices_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeviceKey = 'deviceKey',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Metadataastext = 'metadataastext',
  /** column name */
  Name = 'name',
  /** column name */
  Token = 'token',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** columns and relationships of "digitalProducts" */
export type DigitalProducts = {
  __typename?: 'digitalProducts';
  createdAt: Scalars['timestamptz'];
  groups: Scalars['jsonb'];
  sku: Scalars['String'];
  updatedAt: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "digitalProducts" */
export type DigitalProductsGroupsArgs = {
  path: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "digitalProducts" */
export type DigitalProducts_Aggregate = {
  __typename?: 'digitalProducts_aggregate';
  aggregate: Maybe<DigitalProducts_Aggregate_Fields>;
  nodes: Array<DigitalProducts>;
};

/** aggregate fields of "digitalProducts" */
export type DigitalProducts_Aggregate_Fields = {
  __typename?: 'digitalProducts_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<DigitalProducts_Max_Fields>;
  min: Maybe<DigitalProducts_Min_Fields>;
};


/** aggregate fields of "digitalProducts" */
export type DigitalProducts_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<DigitalProducts_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type DigitalProducts_Append_Input = {
  groups?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "digitalProducts". All fields are combined with a logical 'AND'. */
export type DigitalProducts_Bool_Exp = {
  _and?: InputMaybe<Array<DigitalProducts_Bool_Exp>>;
  _not?: InputMaybe<DigitalProducts_Bool_Exp>;
  _or?: InputMaybe<Array<DigitalProducts_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  groups?: InputMaybe<Jsonb_Comparison_Exp>;
  sku?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "digitalProducts" */
export enum DigitalProducts_Constraint {
  /** unique or primary key constraint */
  DigitalProductsPkey = 'digitalProducts_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type DigitalProducts_Delete_At_Path_Input = {
  groups?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type DigitalProducts_Delete_Elem_Input = {
  groups?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type DigitalProducts_Delete_Key_Input = {
  groups?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "digitalProducts" */
export type DigitalProducts_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  groups?: InputMaybe<Scalars['jsonb']>;
  sku?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type DigitalProducts_Max_Fields = {
  __typename?: 'digitalProducts_max_fields';
  createdAt: Maybe<Scalars['timestamptz']>;
  sku: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type DigitalProducts_Min_Fields = {
  __typename?: 'digitalProducts_min_fields';
  createdAt: Maybe<Scalars['timestamptz']>;
  sku: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "digitalProducts" */
export type DigitalProducts_Mutation_Response = {
  __typename?: 'digitalProducts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DigitalProducts>;
};

/** on conflict condition type for table "digitalProducts" */
export type DigitalProducts_On_Conflict = {
  constraint: DigitalProducts_Constraint;
  update_columns: Array<DigitalProducts_Update_Column>;
  where?: InputMaybe<DigitalProducts_Bool_Exp>;
};

/** Ordering options when selecting data from "digitalProducts". */
export type DigitalProducts_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  groups?: InputMaybe<Order_By>;
  sku?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: digitalProducts */
export type DigitalProducts_Pk_Columns_Input = {
  sku: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type DigitalProducts_Prepend_Input = {
  groups?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "digitalProducts" */
export enum DigitalProducts_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Groups = 'groups',
  /** column name */
  Sku = 'sku',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "digitalProducts" */
export type DigitalProducts_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  groups?: InputMaybe<Scalars['jsonb']>;
  sku?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "digitalProducts" */
export enum DigitalProducts_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Groups = 'groups',
  /** column name */
  Sku = 'sku',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** columns and relationships of "documents" */
export type Documents = {
  __typename?: 'documents';
  createdAt: Scalars['timestamptz'];
  data: Scalars['jsonb'];
  /** An object relationship */
  exchange: Maybe<Exchanges>;
  exchangeId: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  required: Scalars['Boolean'];
  type: Scalars['String'];
  updatedAt: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  userDocuments: Array<UserDocuments>;
  /** An aggregate relationship */
  userDocuments_aggregate: UserDocuments_Aggregate;
};


/** columns and relationships of "documents" */
export type DocumentsDataArgs = {
  path: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "documents" */
export type DocumentsUserDocumentsArgs = {
  distinct_on: InputMaybe<Array<UserDocuments_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserDocuments_Order_By>>;
  where: InputMaybe<UserDocuments_Bool_Exp>;
};


/** columns and relationships of "documents" */
export type DocumentsUserDocuments_AggregateArgs = {
  distinct_on: InputMaybe<Array<UserDocuments_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserDocuments_Order_By>>;
  where: InputMaybe<UserDocuments_Bool_Exp>;
};

/** aggregated selection of "documents" */
export type Documents_Aggregate = {
  __typename?: 'documents_aggregate';
  aggregate: Maybe<Documents_Aggregate_Fields>;
  nodes: Array<Documents>;
};

/** aggregate fields of "documents" */
export type Documents_Aggregate_Fields = {
  __typename?: 'documents_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Documents_Max_Fields>;
  min: Maybe<Documents_Min_Fields>;
};


/** aggregate fields of "documents" */
export type Documents_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Documents_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "documents" */
export type Documents_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Documents_Max_Order_By>;
  min?: InputMaybe<Documents_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Documents_Append_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "documents" */
export type Documents_Arr_Rel_Insert_Input = {
  data: Array<Documents_Insert_Input>;
  /** on conflict condition */
  on_conflict?: InputMaybe<Documents_On_Conflict>;
};

/** Boolean expression to filter rows from the table "documents". All fields are combined with a logical 'AND'. */
export type Documents_Bool_Exp = {
  _and?: InputMaybe<Array<Documents_Bool_Exp>>;
  _not?: InputMaybe<Documents_Bool_Exp>;
  _or?: InputMaybe<Array<Documents_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  exchange?: InputMaybe<Exchanges_Bool_Exp>;
  exchangeId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  required?: InputMaybe<Boolean_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userDocuments?: InputMaybe<UserDocuments_Bool_Exp>;
};

/** unique or primary key constraints on table "documents" */
export enum Documents_Constraint {
  /** unique or primary key constraint */
  DocumentsPkey = 'documents_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Documents_Delete_At_Path_Input = {
  data?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Documents_Delete_Elem_Input = {
  data?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Documents_Delete_Key_Input = {
  data?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "documents" */
export type Documents_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  data?: InputMaybe<Scalars['jsonb']>;
  exchange?: InputMaybe<Exchanges_Obj_Rel_Insert_Input>;
  exchangeId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  required?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userDocuments?: InputMaybe<UserDocuments_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Documents_Max_Fields = {
  __typename?: 'documents_max_fields';
  createdAt: Maybe<Scalars['timestamptz']>;
  exchangeId: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  type: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "documents" */
export type Documents_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  exchangeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Documents_Min_Fields = {
  __typename?: 'documents_min_fields';
  createdAt: Maybe<Scalars['timestamptz']>;
  exchangeId: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  type: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "documents" */
export type Documents_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  exchangeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "documents" */
export type Documents_Mutation_Response = {
  __typename?: 'documents_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Documents>;
};

/** input type for inserting object relation for remote table "documents" */
export type Documents_Obj_Rel_Insert_Input = {
  data: Documents_Insert_Input;
  /** on conflict condition */
  on_conflict?: InputMaybe<Documents_On_Conflict>;
};

/** on conflict condition type for table "documents" */
export type Documents_On_Conflict = {
  constraint: Documents_Constraint;
  update_columns: Array<Documents_Update_Column>;
  where?: InputMaybe<Documents_Bool_Exp>;
};

/** Ordering options when selecting data from "documents". */
export type Documents_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  exchange?: InputMaybe<Exchanges_Order_By>;
  exchangeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  required?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userDocuments_aggregate?: InputMaybe<UserDocuments_Aggregate_Order_By>;
};

/** primary key columns input for table: documents */
export type Documents_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Documents_Prepend_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "documents" */
export enum Documents_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Data = 'data',
  /** column name */
  ExchangeId = 'exchangeId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Required = 'required',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "documents" */
export type Documents_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  data?: InputMaybe<Scalars['jsonb']>;
  exchangeId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  required?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "documents" */
export enum Documents_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Data = 'data',
  /** column name */
  ExchangeId = 'exchangeId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Required = 'required',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/**
 * Table to have data for exchange site
 *
 *
 * columns and relationships of "exchangeContent"
 */
export type ExchangeContent = {
  __typename?: 'exchangeContent';
  about_page: Maybe<Scalars['json']>;
  contactus_page: Maybe<Scalars['json']>;
  exchange_id: Scalars['uuid'];
  home_page: Maybe<Scalars['json']>;
  id: Scalars['uuid'];
  joinOurCause_page: Maybe<Scalars['json']>;
  marketplace_page: Maybe<Scalars['json']>;
  navigation_items: Maybe<Scalars['json']>;
  ourClients_page: Maybe<Scalars['json']>;
  ourMember_page: Maybe<Scalars['json']>;
  portfolio_page: Maybe<Scalars['json']>;
};


/**
 * Table to have data for exchange site
 *
 *
 * columns and relationships of "exchangeContent"
 */
export type ExchangeContentAbout_PageArgs = {
  path: InputMaybe<Scalars['String']>;
};


/**
 * Table to have data for exchange site
 *
 *
 * columns and relationships of "exchangeContent"
 */
export type ExchangeContentContactus_PageArgs = {
  path: InputMaybe<Scalars['String']>;
};


/**
 * Table to have data for exchange site
 *
 *
 * columns and relationships of "exchangeContent"
 */
export type ExchangeContentHome_PageArgs = {
  path: InputMaybe<Scalars['String']>;
};


/**
 * Table to have data for exchange site
 *
 *
 * columns and relationships of "exchangeContent"
 */
export type ExchangeContentJoinOurCause_PageArgs = {
  path: InputMaybe<Scalars['String']>;
};


/**
 * Table to have data for exchange site
 *
 *
 * columns and relationships of "exchangeContent"
 */
export type ExchangeContentMarketplace_PageArgs = {
  path: InputMaybe<Scalars['String']>;
};


/**
 * Table to have data for exchange site
 *
 *
 * columns and relationships of "exchangeContent"
 */
export type ExchangeContentNavigation_ItemsArgs = {
  path: InputMaybe<Scalars['String']>;
};


/**
 * Table to have data for exchange site
 *
 *
 * columns and relationships of "exchangeContent"
 */
export type ExchangeContentOurClients_PageArgs = {
  path: InputMaybe<Scalars['String']>;
};


/**
 * Table to have data for exchange site
 *
 *
 * columns and relationships of "exchangeContent"
 */
export type ExchangeContentOurMember_PageArgs = {
  path: InputMaybe<Scalars['String']>;
};


/**
 * Table to have data for exchange site
 *
 *
 * columns and relationships of "exchangeContent"
 */
export type ExchangeContentPortfolio_PageArgs = {
  path: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "exchangeContent" */
export type ExchangeContent_Aggregate = {
  __typename?: 'exchangeContent_aggregate';
  aggregate: Maybe<ExchangeContent_Aggregate_Fields>;
  nodes: Array<ExchangeContent>;
};

/** aggregate fields of "exchangeContent" */
export type ExchangeContent_Aggregate_Fields = {
  __typename?: 'exchangeContent_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<ExchangeContent_Max_Fields>;
  min: Maybe<ExchangeContent_Min_Fields>;
};


/** aggregate fields of "exchangeContent" */
export type ExchangeContent_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<ExchangeContent_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "exchangeContent". All fields are combined with a logical 'AND'. */
export type ExchangeContent_Bool_Exp = {
  _and?: InputMaybe<Array<ExchangeContent_Bool_Exp>>;
  _not?: InputMaybe<ExchangeContent_Bool_Exp>;
  _or?: InputMaybe<Array<ExchangeContent_Bool_Exp>>;
  about_page?: InputMaybe<Json_Comparison_Exp>;
  contactus_page?: InputMaybe<Json_Comparison_Exp>;
  exchange_id?: InputMaybe<Uuid_Comparison_Exp>;
  home_page?: InputMaybe<Json_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  joinOurCause_page?: InputMaybe<Json_Comparison_Exp>;
  marketplace_page?: InputMaybe<Json_Comparison_Exp>;
  navigation_items?: InputMaybe<Json_Comparison_Exp>;
  ourClients_page?: InputMaybe<Json_Comparison_Exp>;
  ourMember_page?: InputMaybe<Json_Comparison_Exp>;
  portfolio_page?: InputMaybe<Json_Comparison_Exp>;
};

/** unique or primary key constraints on table "exchangeContent" */
export enum ExchangeContent_Constraint {
  /** unique or primary key constraint */
  ExchangeContentExchangeIdKey = 'exchangeContent_exchange_id_key',
  /** unique or primary key constraint */
  ExchangeContentPkey = 'exchangeContent_pkey'
}

/** input type for inserting data into table "exchangeContent" */
export type ExchangeContent_Insert_Input = {
  about_page?: InputMaybe<Scalars['json']>;
  contactus_page?: InputMaybe<Scalars['json']>;
  exchange_id?: InputMaybe<Scalars['uuid']>;
  home_page?: InputMaybe<Scalars['json']>;
  id?: InputMaybe<Scalars['uuid']>;
  joinOurCause_page?: InputMaybe<Scalars['json']>;
  marketplace_page?: InputMaybe<Scalars['json']>;
  navigation_items?: InputMaybe<Scalars['json']>;
  ourClients_page?: InputMaybe<Scalars['json']>;
  ourMember_page?: InputMaybe<Scalars['json']>;
  portfolio_page?: InputMaybe<Scalars['json']>;
};

/** aggregate max on columns */
export type ExchangeContent_Max_Fields = {
  __typename?: 'exchangeContent_max_fields';
  exchange_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type ExchangeContent_Min_Fields = {
  __typename?: 'exchangeContent_min_fields';
  exchange_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "exchangeContent" */
export type ExchangeContent_Mutation_Response = {
  __typename?: 'exchangeContent_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ExchangeContent>;
};

/** input type for inserting object relation for remote table "exchangeContent" */
export type ExchangeContent_Obj_Rel_Insert_Input = {
  data: ExchangeContent_Insert_Input;
  /** on conflict condition */
  on_conflict?: InputMaybe<ExchangeContent_On_Conflict>;
};

/** on conflict condition type for table "exchangeContent" */
export type ExchangeContent_On_Conflict = {
  constraint: ExchangeContent_Constraint;
  update_columns: Array<ExchangeContent_Update_Column>;
  where?: InputMaybe<ExchangeContent_Bool_Exp>;
};

/** Ordering options when selecting data from "exchangeContent". */
export type ExchangeContent_Order_By = {
  about_page?: InputMaybe<Order_By>;
  contactus_page?: InputMaybe<Order_By>;
  exchange_id?: InputMaybe<Order_By>;
  home_page?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  joinOurCause_page?: InputMaybe<Order_By>;
  marketplace_page?: InputMaybe<Order_By>;
  navigation_items?: InputMaybe<Order_By>;
  ourClients_page?: InputMaybe<Order_By>;
  ourMember_page?: InputMaybe<Order_By>;
  portfolio_page?: InputMaybe<Order_By>;
};

/** primary key columns input for table: exchangeContent */
export type ExchangeContent_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "exchangeContent" */
export enum ExchangeContent_Select_Column {
  /** column name */
  AboutPage = 'about_page',
  /** column name */
  ContactusPage = 'contactus_page',
  /** column name */
  ExchangeId = 'exchange_id',
  /** column name */
  HomePage = 'home_page',
  /** column name */
  Id = 'id',
  /** column name */
  JoinOurCausePage = 'joinOurCause_page',
  /** column name */
  MarketplacePage = 'marketplace_page',
  /** column name */
  NavigationItems = 'navigation_items',
  /** column name */
  OurClientsPage = 'ourClients_page',
  /** column name */
  OurMemberPage = 'ourMember_page',
  /** column name */
  PortfolioPage = 'portfolio_page'
}

/** input type for updating data in table "exchangeContent" */
export type ExchangeContent_Set_Input = {
  about_page?: InputMaybe<Scalars['json']>;
  contactus_page?: InputMaybe<Scalars['json']>;
  exchange_id?: InputMaybe<Scalars['uuid']>;
  home_page?: InputMaybe<Scalars['json']>;
  id?: InputMaybe<Scalars['uuid']>;
  joinOurCause_page?: InputMaybe<Scalars['json']>;
  marketplace_page?: InputMaybe<Scalars['json']>;
  navigation_items?: InputMaybe<Scalars['json']>;
  ourClients_page?: InputMaybe<Scalars['json']>;
  ourMember_page?: InputMaybe<Scalars['json']>;
  portfolio_page?: InputMaybe<Scalars['json']>;
};

/** update columns of table "exchangeContent" */
export enum ExchangeContent_Update_Column {
  /** column name */
  AboutPage = 'about_page',
  /** column name */
  ContactusPage = 'contactus_page',
  /** column name */
  ExchangeId = 'exchange_id',
  /** column name */
  HomePage = 'home_page',
  /** column name */
  Id = 'id',
  /** column name */
  JoinOurCausePage = 'joinOurCause_page',
  /** column name */
  MarketplacePage = 'marketplace_page',
  /** column name */
  NavigationItems = 'navigation_items',
  /** column name */
  OurClientsPage = 'ourClients_page',
  /** column name */
  OurMemberPage = 'ourMember_page',
  /** column name */
  PortfolioPage = 'portfolio_page'
}

/** columns and relationships of "exchanges" */
export type Exchanges = {
  __typename?: 'exchanges';
  /** An array relationship */
  documents: Array<Documents>;
  /** An aggregate relationship */
  documents_aggregate: Documents_Aggregate;
  /** An object relationship */
  exchangeContent: Maybe<ExchangeContent>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  shortName: Maybe<Scalars['String']>;
  /** An array relationship */
  userRoleRequests: Array<UserRoleRequests>;
  /** An aggregate relationship */
  userRoleRequests_aggregate: UserRoleRequests_Aggregate;
};


/** columns and relationships of "exchanges" */
export type ExchangesDocumentsArgs = {
  distinct_on: InputMaybe<Array<Documents_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Documents_Order_By>>;
  where: InputMaybe<Documents_Bool_Exp>;
};


/** columns and relationships of "exchanges" */
export type ExchangesDocuments_AggregateArgs = {
  distinct_on: InputMaybe<Array<Documents_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Documents_Order_By>>;
  where: InputMaybe<Documents_Bool_Exp>;
};


/** columns and relationships of "exchanges" */
export type ExchangesUserRoleRequestsArgs = {
  distinct_on: InputMaybe<Array<UserRoleRequests_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserRoleRequests_Order_By>>;
  where: InputMaybe<UserRoleRequests_Bool_Exp>;
};


/** columns and relationships of "exchanges" */
export type ExchangesUserRoleRequests_AggregateArgs = {
  distinct_on: InputMaybe<Array<UserRoleRequests_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserRoleRequests_Order_By>>;
  where: InputMaybe<UserRoleRequests_Bool_Exp>;
};

/** aggregated selection of "exchanges" */
export type Exchanges_Aggregate = {
  __typename?: 'exchanges_aggregate';
  aggregate: Maybe<Exchanges_Aggregate_Fields>;
  nodes: Array<Exchanges>;
};

/** aggregate fields of "exchanges" */
export type Exchanges_Aggregate_Fields = {
  __typename?: 'exchanges_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Exchanges_Max_Fields>;
  min: Maybe<Exchanges_Min_Fields>;
};


/** aggregate fields of "exchanges" */
export type Exchanges_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Exchanges_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "exchanges". All fields are combined with a logical 'AND'. */
export type Exchanges_Bool_Exp = {
  _and?: InputMaybe<Array<Exchanges_Bool_Exp>>;
  _not?: InputMaybe<Exchanges_Bool_Exp>;
  _or?: InputMaybe<Array<Exchanges_Bool_Exp>>;
  documents?: InputMaybe<Documents_Bool_Exp>;
  exchangeContent?: InputMaybe<ExchangeContent_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  shortName?: InputMaybe<String_Comparison_Exp>;
  userRoleRequests?: InputMaybe<UserRoleRequests_Bool_Exp>;
};

/** unique or primary key constraints on table "exchanges" */
export enum Exchanges_Constraint {
  /** unique or primary key constraint */
  ExchangePkey = 'exchange_pkey',
  /** unique or primary key constraint */
  ExchangesNameKey = 'exchanges_name_key',
  /** unique or primary key constraint */
  ExchangesShortNameKey = 'exchanges_shortName_key'
}

/** input type for inserting data into table "exchanges" */
export type Exchanges_Insert_Input = {
  documents?: InputMaybe<Documents_Arr_Rel_Insert_Input>;
  exchangeContent?: InputMaybe<ExchangeContent_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  shortName?: InputMaybe<Scalars['String']>;
  userRoleRequests?: InputMaybe<UserRoleRequests_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Exchanges_Max_Fields = {
  __typename?: 'exchanges_max_fields';
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  shortName: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Exchanges_Min_Fields = {
  __typename?: 'exchanges_min_fields';
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  shortName: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "exchanges" */
export type Exchanges_Mutation_Response = {
  __typename?: 'exchanges_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Exchanges>;
};

/** input type for inserting object relation for remote table "exchanges" */
export type Exchanges_Obj_Rel_Insert_Input = {
  data: Exchanges_Insert_Input;
  /** on conflict condition */
  on_conflict?: InputMaybe<Exchanges_On_Conflict>;
};

/** on conflict condition type for table "exchanges" */
export type Exchanges_On_Conflict = {
  constraint: Exchanges_Constraint;
  update_columns: Array<Exchanges_Update_Column>;
  where?: InputMaybe<Exchanges_Bool_Exp>;
};

/** Ordering options when selecting data from "exchanges". */
export type Exchanges_Order_By = {
  documents_aggregate?: InputMaybe<Documents_Aggregate_Order_By>;
  exchangeContent?: InputMaybe<ExchangeContent_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  shortName?: InputMaybe<Order_By>;
  userRoleRequests_aggregate?: InputMaybe<UserRoleRequests_Aggregate_Order_By>;
};

/** primary key columns input for table: exchanges */
export type Exchanges_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "exchanges" */
export enum Exchanges_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ShortName = 'shortName'
}

/** input type for updating data in table "exchanges" */
export type Exchanges_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  shortName?: InputMaybe<Scalars['String']>;
};

/** update columns of table "exchanges" */
export enum Exchanges_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ShortName = 'shortName'
}

/** columns and relationships of "files" */
export type Files = {
  __typename?: 'files';
  contentLength: Scalars['Int'];
  createdAt: Scalars['timestamptz'];
  domain: Scalars['String'];
  fileType: Scalars['String'];
  id: Scalars['uuid'];
  isPublic: Scalars['Boolean'];
  meta: Scalars['jsonb'];
  mimeType: Scalars['String'];
  name: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  /** A computed field, executes function "files_url" */
  url: Maybe<Scalars['String']>;
  userId: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "files" */
export type FilesMetaArgs = {
  path: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "files" */
export type Files_Aggregate = {
  __typename?: 'files_aggregate';
  aggregate: Maybe<Files_Aggregate_Fields>;
  nodes: Array<Files>;
};

/** aggregate fields of "files" */
export type Files_Aggregate_Fields = {
  __typename?: 'files_aggregate_fields';
  avg: Maybe<Files_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Files_Max_Fields>;
  min: Maybe<Files_Min_Fields>;
  stddev: Maybe<Files_Stddev_Fields>;
  stddev_pop: Maybe<Files_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Files_Stddev_Samp_Fields>;
  sum: Maybe<Files_Sum_Fields>;
  var_pop: Maybe<Files_Var_Pop_Fields>;
  var_samp: Maybe<Files_Var_Samp_Fields>;
  variance: Maybe<Files_Variance_Fields>;
};


/** aggregate fields of "files" */
export type Files_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Files_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Files_Append_Input = {
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Files_Avg_Fields = {
  __typename?: 'files_avg_fields';
  contentLength: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "files". All fields are combined with a logical 'AND'. */
export type Files_Bool_Exp = {
  _and?: InputMaybe<Array<Files_Bool_Exp>>;
  _not?: InputMaybe<Files_Bool_Exp>;
  _or?: InputMaybe<Array<Files_Bool_Exp>>;
  contentLength?: InputMaybe<Int_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  domain?: InputMaybe<String_Comparison_Exp>;
  fileType?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isPublic?: InputMaybe<Boolean_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  mimeType?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "files" */
export enum Files_Constraint {
  /** unique or primary key constraint */
  FilesPkey = 'files_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Files_Delete_At_Path_Input = {
  meta?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Files_Delete_Elem_Input = {
  meta?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Files_Delete_Key_Input = {
  meta?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "files" */
export type Files_Inc_Input = {
  contentLength?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "files" */
export type Files_Insert_Input = {
  contentLength?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  domain?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  mimeType?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Files_Max_Fields = {
  __typename?: 'files_max_fields';
  contentLength: Maybe<Scalars['Int']>;
  createdAt: Maybe<Scalars['timestamptz']>;
  domain: Maybe<Scalars['String']>;
  fileType: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  mimeType: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
  userId: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Files_Min_Fields = {
  __typename?: 'files_min_fields';
  contentLength: Maybe<Scalars['Int']>;
  createdAt: Maybe<Scalars['timestamptz']>;
  domain: Maybe<Scalars['String']>;
  fileType: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  mimeType: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
  userId: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "files" */
export type Files_Mutation_Response = {
  __typename?: 'files_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Files>;
};

/** on conflict condition type for table "files" */
export type Files_On_Conflict = {
  constraint: Files_Constraint;
  update_columns: Array<Files_Update_Column>;
  where?: InputMaybe<Files_Bool_Exp>;
};

/** Ordering options when selecting data from "files". */
export type Files_Order_By = {
  contentLength?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  domain?: InputMaybe<Order_By>;
  fileType?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isPublic?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  mimeType?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: files */
export type Files_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Files_Prepend_Input = {
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "files" */
export enum Files_Select_Column {
  /** column name */
  ContentLength = 'contentLength',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Domain = 'domain',
  /** column name */
  FileType = 'fileType',
  /** column name */
  Id = 'id',
  /** column name */
  IsPublic = 'isPublic',
  /** column name */
  Meta = 'meta',
  /** column name */
  MimeType = 'mimeType',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "files" */
export type Files_Set_Input = {
  contentLength?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  domain?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  mimeType?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Files_Stddev_Fields = {
  __typename?: 'files_stddev_fields';
  contentLength: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Files_Stddev_Pop_Fields = {
  __typename?: 'files_stddev_pop_fields';
  contentLength: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Files_Stddev_Samp_Fields = {
  __typename?: 'files_stddev_samp_fields';
  contentLength: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Files_Sum_Fields = {
  __typename?: 'files_sum_fields';
  contentLength: Maybe<Scalars['Int']>;
};

/** update columns of table "files" */
export enum Files_Update_Column {
  /** column name */
  ContentLength = 'contentLength',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Domain = 'domain',
  /** column name */
  FileType = 'fileType',
  /** column name */
  Id = 'id',
  /** column name */
  IsPublic = 'isPublic',
  /** column name */
  Meta = 'meta',
  /** column name */
  MimeType = 'mimeType',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** aggregate var_pop on columns */
export type Files_Var_Pop_Fields = {
  __typename?: 'files_var_pop_fields';
  contentLength: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Files_Var_Samp_Fields = {
  __typename?: 'files_var_samp_fields';
  contentLength: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Files_Variance_Fields = {
  __typename?: 'files_variance_fields';
  contentLength: Maybe<Scalars['Float']>;
};

/** columns and relationships of "hubspotSyncJob" */
export type HubspotSyncJob = {
  __typename?: 'hubspotSyncJob';
  beginningAddedAt: Maybe<Scalars['timestamptz']>;
  createdAt: Scalars['timestamptz'];
  endingAddedAt: Maybe<Scalars['timestamptz']>;
  id: Scalars['bigint'];
  isComplete: Scalars['Boolean'];
  message: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "hubspotSyncJob" */
export type HubspotSyncJob_Aggregate = {
  __typename?: 'hubspotSyncJob_aggregate';
  aggregate: Maybe<HubspotSyncJob_Aggregate_Fields>;
  nodes: Array<HubspotSyncJob>;
};

/** aggregate fields of "hubspotSyncJob" */
export type HubspotSyncJob_Aggregate_Fields = {
  __typename?: 'hubspotSyncJob_aggregate_fields';
  avg: Maybe<HubspotSyncJob_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<HubspotSyncJob_Max_Fields>;
  min: Maybe<HubspotSyncJob_Min_Fields>;
  stddev: Maybe<HubspotSyncJob_Stddev_Fields>;
  stddev_pop: Maybe<HubspotSyncJob_Stddev_Pop_Fields>;
  stddev_samp: Maybe<HubspotSyncJob_Stddev_Samp_Fields>;
  sum: Maybe<HubspotSyncJob_Sum_Fields>;
  var_pop: Maybe<HubspotSyncJob_Var_Pop_Fields>;
  var_samp: Maybe<HubspotSyncJob_Var_Samp_Fields>;
  variance: Maybe<HubspotSyncJob_Variance_Fields>;
};


/** aggregate fields of "hubspotSyncJob" */
export type HubspotSyncJob_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<HubspotSyncJob_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type HubspotSyncJob_Avg_Fields = {
  __typename?: 'hubspotSyncJob_avg_fields';
  id: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "hubspotSyncJob". All fields are combined with a logical 'AND'. */
export type HubspotSyncJob_Bool_Exp = {
  _and?: InputMaybe<Array<HubspotSyncJob_Bool_Exp>>;
  _not?: InputMaybe<HubspotSyncJob_Bool_Exp>;
  _or?: InputMaybe<Array<HubspotSyncJob_Bool_Exp>>;
  beginningAddedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  endingAddedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  isComplete?: InputMaybe<Boolean_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "hubspotSyncJob" */
export enum HubspotSyncJob_Constraint {
  /** unique or primary key constraint */
  HubspotSyncJobPkey = 'hubspotSyncJob_pkey'
}

/** input type for incrementing numeric columns in table "hubspotSyncJob" */
export type HubspotSyncJob_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "hubspotSyncJob" */
export type HubspotSyncJob_Insert_Input = {
  beginningAddedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  endingAddedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  isComplete?: InputMaybe<Scalars['Boolean']>;
  message?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type HubspotSyncJob_Max_Fields = {
  __typename?: 'hubspotSyncJob_max_fields';
  beginningAddedAt: Maybe<Scalars['timestamptz']>;
  createdAt: Maybe<Scalars['timestamptz']>;
  endingAddedAt: Maybe<Scalars['timestamptz']>;
  id: Maybe<Scalars['bigint']>;
  message: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type HubspotSyncJob_Min_Fields = {
  __typename?: 'hubspotSyncJob_min_fields';
  beginningAddedAt: Maybe<Scalars['timestamptz']>;
  createdAt: Maybe<Scalars['timestamptz']>;
  endingAddedAt: Maybe<Scalars['timestamptz']>;
  id: Maybe<Scalars['bigint']>;
  message: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "hubspotSyncJob" */
export type HubspotSyncJob_Mutation_Response = {
  __typename?: 'hubspotSyncJob_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<HubspotSyncJob>;
};

/** on conflict condition type for table "hubspotSyncJob" */
export type HubspotSyncJob_On_Conflict = {
  constraint: HubspotSyncJob_Constraint;
  update_columns: Array<HubspotSyncJob_Update_Column>;
  where?: InputMaybe<HubspotSyncJob_Bool_Exp>;
};

/** Ordering options when selecting data from "hubspotSyncJob". */
export type HubspotSyncJob_Order_By = {
  beginningAddedAt?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  endingAddedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isComplete?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: hubspotSyncJob */
export type HubspotSyncJob_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "hubspotSyncJob" */
export enum HubspotSyncJob_Select_Column {
  /** column name */
  BeginningAddedAt = 'beginningAddedAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EndingAddedAt = 'endingAddedAt',
  /** column name */
  Id = 'id',
  /** column name */
  IsComplete = 'isComplete',
  /** column name */
  Message = 'message',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "hubspotSyncJob" */
export type HubspotSyncJob_Set_Input = {
  beginningAddedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  endingAddedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  isComplete?: InputMaybe<Scalars['Boolean']>;
  message?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type HubspotSyncJob_Stddev_Fields = {
  __typename?: 'hubspotSyncJob_stddev_fields';
  id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type HubspotSyncJob_Stddev_Pop_Fields = {
  __typename?: 'hubspotSyncJob_stddev_pop_fields';
  id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type HubspotSyncJob_Stddev_Samp_Fields = {
  __typename?: 'hubspotSyncJob_stddev_samp_fields';
  id: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type HubspotSyncJob_Sum_Fields = {
  __typename?: 'hubspotSyncJob_sum_fields';
  id: Maybe<Scalars['bigint']>;
};

/** update columns of table "hubspotSyncJob" */
export enum HubspotSyncJob_Update_Column {
  /** column name */
  BeginningAddedAt = 'beginningAddedAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EndingAddedAt = 'endingAddedAt',
  /** column name */
  Id = 'id',
  /** column name */
  IsComplete = 'isComplete',
  /** column name */
  Message = 'message',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** aggregate var_pop on columns */
export type HubspotSyncJob_Var_Pop_Fields = {
  __typename?: 'hubspotSyncJob_var_pop_fields';
  id: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type HubspotSyncJob_Var_Samp_Fields = {
  __typename?: 'hubspotSyncJob_var_samp_fields';
  id: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type HubspotSyncJob_Variance_Fields = {
  __typename?: 'hubspotSyncJob_variance_fields';
  id: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "json". All fields are combined with logical 'AND'. */
export type Json_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['json']>;
  _gt?: InputMaybe<Scalars['json']>;
  _gte?: InputMaybe<Scalars['json']>;
  _in?: InputMaybe<Array<Scalars['json']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['json']>;
  _lte?: InputMaybe<Scalars['json']>;
  _neq?: InputMaybe<Scalars['json']>;
  _nin?: InputMaybe<Array<Scalars['json']>>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']>;
  _eq?: InputMaybe<Scalars['jsonb']>;
  _gt?: InputMaybe<Scalars['jsonb']>;
  _gte?: InputMaybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['jsonb']>;
  _lte?: InputMaybe<Scalars['jsonb']>;
  _neq?: InputMaybe<Scalars['jsonb']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']>>;
};

/** columns and relationships of "languages" */
export type Languages = {
  __typename?: 'languages';
  id: Scalars['Int'];
  name: Scalars['String'];
  /** An array relationship */
  userData: Array<UserData>;
  /** An aggregate relationship */
  userData_aggregate: UserData_Aggregate;
};


/** columns and relationships of "languages" */
export type LanguagesUserDataArgs = {
  distinct_on: InputMaybe<Array<UserData_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserData_Order_By>>;
  where: InputMaybe<UserData_Bool_Exp>;
};


/** columns and relationships of "languages" */
export type LanguagesUserData_AggregateArgs = {
  distinct_on: InputMaybe<Array<UserData_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserData_Order_By>>;
  where: InputMaybe<UserData_Bool_Exp>;
};

/** aggregated selection of "languages" */
export type Languages_Aggregate = {
  __typename?: 'languages_aggregate';
  aggregate: Maybe<Languages_Aggregate_Fields>;
  nodes: Array<Languages>;
};

/** aggregate fields of "languages" */
export type Languages_Aggregate_Fields = {
  __typename?: 'languages_aggregate_fields';
  avg: Maybe<Languages_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Languages_Max_Fields>;
  min: Maybe<Languages_Min_Fields>;
  stddev: Maybe<Languages_Stddev_Fields>;
  stddev_pop: Maybe<Languages_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Languages_Stddev_Samp_Fields>;
  sum: Maybe<Languages_Sum_Fields>;
  var_pop: Maybe<Languages_Var_Pop_Fields>;
  var_samp: Maybe<Languages_Var_Samp_Fields>;
  variance: Maybe<Languages_Variance_Fields>;
};


/** aggregate fields of "languages" */
export type Languages_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Languages_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Languages_Avg_Fields = {
  __typename?: 'languages_avg_fields';
  id: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "languages". All fields are combined with a logical 'AND'. */
export type Languages_Bool_Exp = {
  _and?: InputMaybe<Array<Languages_Bool_Exp>>;
  _not?: InputMaybe<Languages_Bool_Exp>;
  _or?: InputMaybe<Array<Languages_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  userData?: InputMaybe<UserData_Bool_Exp>;
};

/** unique or primary key constraints on table "languages" */
export enum Languages_Constraint {
  /** unique or primary key constraint */
  LanguagesPkey = 'languages_pkey'
}

/** input type for incrementing numeric columns in table "languages" */
export type Languages_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "languages" */
export type Languages_Insert_Input = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  userData?: InputMaybe<UserData_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Languages_Max_Fields = {
  __typename?: 'languages_max_fields';
  id: Maybe<Scalars['Int']>;
  name: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Languages_Min_Fields = {
  __typename?: 'languages_min_fields';
  id: Maybe<Scalars['Int']>;
  name: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "languages" */
export type Languages_Mutation_Response = {
  __typename?: 'languages_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Languages>;
};

/** input type for inserting object relation for remote table "languages" */
export type Languages_Obj_Rel_Insert_Input = {
  data: Languages_Insert_Input;
  /** on conflict condition */
  on_conflict?: InputMaybe<Languages_On_Conflict>;
};

/** on conflict condition type for table "languages" */
export type Languages_On_Conflict = {
  constraint: Languages_Constraint;
  update_columns: Array<Languages_Update_Column>;
  where?: InputMaybe<Languages_Bool_Exp>;
};

/** Ordering options when selecting data from "languages". */
export type Languages_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  userData_aggregate?: InputMaybe<UserData_Aggregate_Order_By>;
};

/** primary key columns input for table: languages */
export type Languages_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "languages" */
export enum Languages_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "languages" */
export type Languages_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Languages_Stddev_Fields = {
  __typename?: 'languages_stddev_fields';
  id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Languages_Stddev_Pop_Fields = {
  __typename?: 'languages_stddev_pop_fields';
  id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Languages_Stddev_Samp_Fields = {
  __typename?: 'languages_stddev_samp_fields';
  id: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Languages_Sum_Fields = {
  __typename?: 'languages_sum_fields';
  id: Maybe<Scalars['Int']>;
};

/** update columns of table "languages" */
export enum Languages_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** aggregate var_pop on columns */
export type Languages_Var_Pop_Fields = {
  __typename?: 'languages_var_pop_fields';
  id: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Languages_Var_Samp_Fields = {
  __typename?: 'languages_var_samp_fields';
  id: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Languages_Variance_Fields = {
  __typename?: 'languages_variance_fields';
  id: Maybe<Scalars['Float']>;
};

/** columns and relationships of "leadLocks" */
export type LeadLocks = {
  __typename?: 'leadLocks';
  /** An object relationship */
  admin: Users;
  adminId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  exchange: Exchanges;
  exchangeId: Scalars['uuid'];
  /** An object relationship */
  grantee: Users;
  granteeId: Scalars['uuid'];
  id: Scalars['uuid'];
  releasedAt: Scalars['timestamptz'];
  type: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  value: Scalars['String'];
};

/** aggregated selection of "leadLocks" */
export type LeadLocks_Aggregate = {
  __typename?: 'leadLocks_aggregate';
  aggregate: Maybe<LeadLocks_Aggregate_Fields>;
  nodes: Array<LeadLocks>;
};

/** aggregate fields of "leadLocks" */
export type LeadLocks_Aggregate_Fields = {
  __typename?: 'leadLocks_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<LeadLocks_Max_Fields>;
  min: Maybe<LeadLocks_Min_Fields>;
};


/** aggregate fields of "leadLocks" */
export type LeadLocks_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<LeadLocks_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "leadLocks" */
export type LeadLocks_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<LeadLocks_Max_Order_By>;
  min?: InputMaybe<LeadLocks_Min_Order_By>;
};

/** input type for inserting array relation for remote table "leadLocks" */
export type LeadLocks_Arr_Rel_Insert_Input = {
  data: Array<LeadLocks_Insert_Input>;
  /** on conflict condition */
  on_conflict?: InputMaybe<LeadLocks_On_Conflict>;
};

/** Boolean expression to filter rows from the table "leadLocks". All fields are combined with a logical 'AND'. */
export type LeadLocks_Bool_Exp = {
  _and?: InputMaybe<Array<LeadLocks_Bool_Exp>>;
  _not?: InputMaybe<LeadLocks_Bool_Exp>;
  _or?: InputMaybe<Array<LeadLocks_Bool_Exp>>;
  admin?: InputMaybe<Users_Bool_Exp>;
  adminId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  exchange?: InputMaybe<Exchanges_Bool_Exp>;
  exchangeId?: InputMaybe<Uuid_Comparison_Exp>;
  grantee?: InputMaybe<Users_Bool_Exp>;
  granteeId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  releasedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "leadLocks" */
export enum LeadLocks_Constraint {
  /** unique or primary key constraint */
  LeadLocksPkey = 'leadLocks_pkey'
}

/** input type for inserting data into table "leadLocks" */
export type LeadLocks_Insert_Input = {
  admin?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  adminId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  exchange?: InputMaybe<Exchanges_Obj_Rel_Insert_Input>;
  exchangeId?: InputMaybe<Scalars['uuid']>;
  grantee?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  granteeId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  releasedAt?: InputMaybe<Scalars['timestamptz']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type LeadLocks_Max_Fields = {
  __typename?: 'leadLocks_max_fields';
  adminId: Maybe<Scalars['uuid']>;
  createdAt: Maybe<Scalars['timestamptz']>;
  exchangeId: Maybe<Scalars['uuid']>;
  granteeId: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  releasedAt: Maybe<Scalars['timestamptz']>;
  type: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
  value: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "leadLocks" */
export type LeadLocks_Max_Order_By = {
  adminId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  exchangeId?: InputMaybe<Order_By>;
  granteeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  releasedAt?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type LeadLocks_Min_Fields = {
  __typename?: 'leadLocks_min_fields';
  adminId: Maybe<Scalars['uuid']>;
  createdAt: Maybe<Scalars['timestamptz']>;
  exchangeId: Maybe<Scalars['uuid']>;
  granteeId: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  releasedAt: Maybe<Scalars['timestamptz']>;
  type: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
  value: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "leadLocks" */
export type LeadLocks_Min_Order_By = {
  adminId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  exchangeId?: InputMaybe<Order_By>;
  granteeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  releasedAt?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "leadLocks" */
export type LeadLocks_Mutation_Response = {
  __typename?: 'leadLocks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LeadLocks>;
};

/** on conflict condition type for table "leadLocks" */
export type LeadLocks_On_Conflict = {
  constraint: LeadLocks_Constraint;
  update_columns: Array<LeadLocks_Update_Column>;
  where?: InputMaybe<LeadLocks_Bool_Exp>;
};

/** Ordering options when selecting data from "leadLocks". */
export type LeadLocks_Order_By = {
  admin?: InputMaybe<Users_Order_By>;
  adminId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  exchange?: InputMaybe<Exchanges_Order_By>;
  exchangeId?: InputMaybe<Order_By>;
  grantee?: InputMaybe<Users_Order_By>;
  granteeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  releasedAt?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: leadLocks */
export type LeadLocks_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "leadLocks" */
export enum LeadLocks_Select_Column {
  /** column name */
  AdminId = 'adminId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExchangeId = 'exchangeId',
  /** column name */
  GranteeId = 'granteeId',
  /** column name */
  Id = 'id',
  /** column name */
  ReleasedAt = 'releasedAt',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "leadLocks" */
export type LeadLocks_Set_Input = {
  adminId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  exchangeId?: InputMaybe<Scalars['uuid']>;
  granteeId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  releasedAt?: InputMaybe<Scalars['timestamptz']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "leadLocks" */
export enum LeadLocks_Update_Column {
  /** column name */
  AdminId = 'adminId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExchangeId = 'exchangeId',
  /** column name */
  GranteeId = 'granteeId',
  /** column name */
  Id = 'id',
  /** column name */
  ReleasedAt = 'releasedAt',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Value = 'value'
}

/** columns and relationships of "leadsHistory" */
export type LeadsHistory = {
  __typename?: 'leadsHistory';
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  exchange: Exchanges;
  exchangeId: Scalars['uuid'];
  id: Scalars['uuid'];
  leadID: Scalars['String'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
};

/** aggregated selection of "leadsHistory" */
export type LeadsHistory_Aggregate = {
  __typename?: 'leadsHistory_aggregate';
  aggregate: Maybe<LeadsHistory_Aggregate_Fields>;
  nodes: Array<LeadsHistory>;
};

/** aggregate fields of "leadsHistory" */
export type LeadsHistory_Aggregate_Fields = {
  __typename?: 'leadsHistory_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<LeadsHistory_Max_Fields>;
  min: Maybe<LeadsHistory_Min_Fields>;
};


/** aggregate fields of "leadsHistory" */
export type LeadsHistory_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<LeadsHistory_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "leadsHistory" */
export type LeadsHistory_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<LeadsHistory_Max_Order_By>;
  min?: InputMaybe<LeadsHistory_Min_Order_By>;
};

/** input type for inserting array relation for remote table "leadsHistory" */
export type LeadsHistory_Arr_Rel_Insert_Input = {
  data: Array<LeadsHistory_Insert_Input>;
  /** on conflict condition */
  on_conflict?: InputMaybe<LeadsHistory_On_Conflict>;
};

/** Boolean expression to filter rows from the table "leadsHistory". All fields are combined with a logical 'AND'. */
export type LeadsHistory_Bool_Exp = {
  _and?: InputMaybe<Array<LeadsHistory_Bool_Exp>>;
  _not?: InputMaybe<LeadsHistory_Bool_Exp>;
  _or?: InputMaybe<Array<LeadsHistory_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  exchange?: InputMaybe<Exchanges_Bool_Exp>;
  exchangeId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  leadID?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "leadsHistory" */
export enum LeadsHistory_Constraint {
  /** unique or primary key constraint */
  LeadsHistoryPkey = 'leadsHistory_pkey'
}

/** input type for inserting data into table "leadsHistory" */
export type LeadsHistory_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  exchange?: InputMaybe<Exchanges_Obj_Rel_Insert_Input>;
  exchangeId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  leadID?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type LeadsHistory_Max_Fields = {
  __typename?: 'leadsHistory_max_fields';
  createdAt: Maybe<Scalars['timestamptz']>;
  exchangeId: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  leadID: Maybe<Scalars['String']>;
  userId: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "leadsHistory" */
export type LeadsHistory_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  exchangeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  leadID?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type LeadsHistory_Min_Fields = {
  __typename?: 'leadsHistory_min_fields';
  createdAt: Maybe<Scalars['timestamptz']>;
  exchangeId: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  leadID: Maybe<Scalars['String']>;
  userId: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "leadsHistory" */
export type LeadsHistory_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  exchangeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  leadID?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "leadsHistory" */
export type LeadsHistory_Mutation_Response = {
  __typename?: 'leadsHistory_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LeadsHistory>;
};

/** on conflict condition type for table "leadsHistory" */
export type LeadsHistory_On_Conflict = {
  constraint: LeadsHistory_Constraint;
  update_columns: Array<LeadsHistory_Update_Column>;
  where?: InputMaybe<LeadsHistory_Bool_Exp>;
};

/** Ordering options when selecting data from "leadsHistory". */
export type LeadsHistory_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  exchange?: InputMaybe<Exchanges_Order_By>;
  exchangeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  leadID?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: leadsHistory */
export type LeadsHistory_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "leadsHistory" */
export enum LeadsHistory_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExchangeId = 'exchangeId',
  /** column name */
  Id = 'id',
  /** column name */
  LeadId = 'leadID',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "leadsHistory" */
export type LeadsHistory_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  exchangeId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  leadID?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "leadsHistory" */
export enum LeadsHistory_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExchangeId = 'exchangeId',
  /** column name */
  Id = 'id',
  /** column name */
  LeadId = 'leadID',
  /** column name */
  UserId = 'userId'
}

/** columns and relationships of "lineage" */
export type Lineage = {
  __typename?: 'lineage';
  email: Maybe<Scalars['String']>;
  personFirstName: Maybe<Scalars['String']>;
  personLastName: Maybe<Scalars['String']>;
  personPrimaryEmail: Maybe<Scalars['String']>;
  personReferredBy: Maybe<Scalars['uuid']>;
  profileId: Maybe<Scalars['uuid']>;
  /** An array relationship */
  referrals: Array<Lineage>;
  /** An aggregate relationship */
  referrals_aggregate: Lineage_Aggregate;
  /** An object relationship */
  referrer: Maybe<Lineage>;
};


/** columns and relationships of "lineage" */
export type LineageReferralsArgs = {
  distinct_on: InputMaybe<Array<Lineage_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Lineage_Order_By>>;
  where: InputMaybe<Lineage_Bool_Exp>;
};


/** columns and relationships of "lineage" */
export type LineageReferrals_AggregateArgs = {
  distinct_on: InputMaybe<Array<Lineage_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Lineage_Order_By>>;
  where: InputMaybe<Lineage_Bool_Exp>;
};

/** aggregated selection of "lineage" */
export type Lineage_Aggregate = {
  __typename?: 'lineage_aggregate';
  aggregate: Maybe<Lineage_Aggregate_Fields>;
  nodes: Array<Lineage>;
};

/** aggregate fields of "lineage" */
export type Lineage_Aggregate_Fields = {
  __typename?: 'lineage_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Lineage_Max_Fields>;
  min: Maybe<Lineage_Min_Fields>;
};


/** aggregate fields of "lineage" */
export type Lineage_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Lineage_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "lineage" */
export type Lineage_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Lineage_Max_Order_By>;
  min?: InputMaybe<Lineage_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "lineage". All fields are combined with a logical 'AND'. */
export type Lineage_Bool_Exp = {
  _and?: InputMaybe<Array<Lineage_Bool_Exp>>;
  _not?: InputMaybe<Lineage_Bool_Exp>;
  _or?: InputMaybe<Array<Lineage_Bool_Exp>>;
  email?: InputMaybe<String_Comparison_Exp>;
  personFirstName?: InputMaybe<String_Comparison_Exp>;
  personLastName?: InputMaybe<String_Comparison_Exp>;
  personPrimaryEmail?: InputMaybe<String_Comparison_Exp>;
  personReferredBy?: InputMaybe<Uuid_Comparison_Exp>;
  profileId?: InputMaybe<Uuid_Comparison_Exp>;
  referrals?: InputMaybe<Lineage_Bool_Exp>;
  referrer?: InputMaybe<Lineage_Bool_Exp>;
};

/** aggregate max on columns */
export type Lineage_Max_Fields = {
  __typename?: 'lineage_max_fields';
  email: Maybe<Scalars['String']>;
  personFirstName: Maybe<Scalars['String']>;
  personLastName: Maybe<Scalars['String']>;
  personPrimaryEmail: Maybe<Scalars['String']>;
  personReferredBy: Maybe<Scalars['uuid']>;
  profileId: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "lineage" */
export type Lineage_Max_Order_By = {
  email?: InputMaybe<Order_By>;
  personFirstName?: InputMaybe<Order_By>;
  personLastName?: InputMaybe<Order_By>;
  personPrimaryEmail?: InputMaybe<Order_By>;
  personReferredBy?: InputMaybe<Order_By>;
  profileId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Lineage_Min_Fields = {
  __typename?: 'lineage_min_fields';
  email: Maybe<Scalars['String']>;
  personFirstName: Maybe<Scalars['String']>;
  personLastName: Maybe<Scalars['String']>;
  personPrimaryEmail: Maybe<Scalars['String']>;
  personReferredBy: Maybe<Scalars['uuid']>;
  profileId: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "lineage" */
export type Lineage_Min_Order_By = {
  email?: InputMaybe<Order_By>;
  personFirstName?: InputMaybe<Order_By>;
  personLastName?: InputMaybe<Order_By>;
  personPrimaryEmail?: InputMaybe<Order_By>;
  personReferredBy?: InputMaybe<Order_By>;
  profileId?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "lineage". */
export type Lineage_Order_By = {
  email?: InputMaybe<Order_By>;
  personFirstName?: InputMaybe<Order_By>;
  personLastName?: InputMaybe<Order_By>;
  personPrimaryEmail?: InputMaybe<Order_By>;
  personReferredBy?: InputMaybe<Order_By>;
  profileId?: InputMaybe<Order_By>;
  referrals_aggregate?: InputMaybe<Lineage_Aggregate_Order_By>;
  referrer?: InputMaybe<Lineage_Order_By>;
};

/** select columns of table "lineage" */
export enum Lineage_Select_Column {
  /** column name */
  Email = 'email',
  /** column name */
  PersonFirstName = 'personFirstName',
  /** column name */
  PersonLastName = 'personLastName',
  /** column name */
  PersonPrimaryEmail = 'personPrimaryEmail',
  /** column name */
  PersonReferredBy = 'personReferredBy',
  /** column name */
  ProfileId = 'profileId'
}

/** columns and relationships of "logTraces" */
export type LogTraces = {
  __typename?: 'logTraces';
  id: Maybe<Scalars['String']>;
  /** An array relationship */
  logs: Array<Logs>;
  /** An aggregate relationship */
  logs_aggregate: Logs_Aggregate;
  maxTimestamp: Maybe<Scalars['timestamptz']>;
  minTimestamp: Maybe<Scalars['timestamptz']>;
  userId: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "logTraces" */
export type LogTracesLogsArgs = {
  distinct_on: InputMaybe<Array<Logs_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Logs_Order_By>>;
  where: InputMaybe<Logs_Bool_Exp>;
};


/** columns and relationships of "logTraces" */
export type LogTracesLogs_AggregateArgs = {
  distinct_on: InputMaybe<Array<Logs_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Logs_Order_By>>;
  where: InputMaybe<Logs_Bool_Exp>;
};

/** aggregated selection of "logTraces" */
export type LogTraces_Aggregate = {
  __typename?: 'logTraces_aggregate';
  aggregate: Maybe<LogTraces_Aggregate_Fields>;
  nodes: Array<LogTraces>;
};

/** aggregate fields of "logTraces" */
export type LogTraces_Aggregate_Fields = {
  __typename?: 'logTraces_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<LogTraces_Max_Fields>;
  min: Maybe<LogTraces_Min_Fields>;
};


/** aggregate fields of "logTraces" */
export type LogTraces_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<LogTraces_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "logTraces" */
export type LogTraces_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<LogTraces_Max_Order_By>;
  min?: InputMaybe<LogTraces_Min_Order_By>;
};

/** input type for inserting array relation for remote table "logTraces" */
export type LogTraces_Arr_Rel_Insert_Input = {
  data: Array<LogTraces_Insert_Input>;
};

/** Boolean expression to filter rows from the table "logTraces". All fields are combined with a logical 'AND'. */
export type LogTraces_Bool_Exp = {
  _and?: InputMaybe<Array<LogTraces_Bool_Exp>>;
  _not?: InputMaybe<LogTraces_Bool_Exp>;
  _or?: InputMaybe<Array<LogTraces_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
  logs?: InputMaybe<Logs_Bool_Exp>;
  maxTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  minTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** input type for inserting data into table "logTraces" */
export type LogTraces_Insert_Input = {
  id?: InputMaybe<Scalars['String']>;
  logs?: InputMaybe<Logs_Arr_Rel_Insert_Input>;
  maxTimestamp?: InputMaybe<Scalars['timestamptz']>;
  minTimestamp?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type LogTraces_Max_Fields = {
  __typename?: 'logTraces_max_fields';
  id: Maybe<Scalars['String']>;
  maxTimestamp: Maybe<Scalars['timestamptz']>;
  minTimestamp: Maybe<Scalars['timestamptz']>;
  userId: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "logTraces" */
export type LogTraces_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  maxTimestamp?: InputMaybe<Order_By>;
  minTimestamp?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type LogTraces_Min_Fields = {
  __typename?: 'logTraces_min_fields';
  id: Maybe<Scalars['String']>;
  maxTimestamp: Maybe<Scalars['timestamptz']>;
  minTimestamp: Maybe<Scalars['timestamptz']>;
  userId: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "logTraces" */
export type LogTraces_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  maxTimestamp?: InputMaybe<Order_By>;
  minTimestamp?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "logTraces". */
export type LogTraces_Order_By = {
  id?: InputMaybe<Order_By>;
  logs_aggregate?: InputMaybe<Logs_Aggregate_Order_By>;
  maxTimestamp?: InputMaybe<Order_By>;
  minTimestamp?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** select columns of table "logTraces" */
export enum LogTraces_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  MaxTimestamp = 'maxTimestamp',
  /** column name */
  MinTimestamp = 'minTimestamp',
  /** column name */
  UserId = 'userId'
}

/** columns and relationships of "logs" */
export type Logs = {
  __typename?: 'logs';
  createdAt: Maybe<Scalars['timestamptz']>;
  details: Scalars['jsonb'];
  id: Scalars['uuid'];
  level: Scalars['String'];
  service: Maybe<Scalars['String']>;
  timestamp: Scalars['timestamptz'];
  trace: Scalars['String'];
  type: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  user: Maybe<Users>;
  userId: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "logs" */
export type LogsDetailsArgs = {
  path: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "logs" */
export type Logs_Aggregate = {
  __typename?: 'logs_aggregate';
  aggregate: Maybe<Logs_Aggregate_Fields>;
  nodes: Array<Logs>;
};

/** aggregate fields of "logs" */
export type Logs_Aggregate_Fields = {
  __typename?: 'logs_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Logs_Max_Fields>;
  min: Maybe<Logs_Min_Fields>;
};


/** aggregate fields of "logs" */
export type Logs_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Logs_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "logs" */
export type Logs_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Logs_Max_Order_By>;
  min?: InputMaybe<Logs_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Logs_Append_Input = {
  details?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "logs" */
export type Logs_Arr_Rel_Insert_Input = {
  data: Array<Logs_Insert_Input>;
  /** on conflict condition */
  on_conflict?: InputMaybe<Logs_On_Conflict>;
};

/** Boolean expression to filter rows from the table "logs". All fields are combined with a logical 'AND'. */
export type Logs_Bool_Exp = {
  _and?: InputMaybe<Array<Logs_Bool_Exp>>;
  _not?: InputMaybe<Logs_Bool_Exp>;
  _or?: InputMaybe<Array<Logs_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  details?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  level?: InputMaybe<String_Comparison_Exp>;
  service?: InputMaybe<String_Comparison_Exp>;
  timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  trace?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "logs" */
export enum Logs_Constraint {
  /** unique or primary key constraint */
  InstallLogIdKey = 'install_log_id_key',
  /** unique or primary key constraint */
  VraiAppLogPkey = 'vrai_app_log_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Logs_Delete_At_Path_Input = {
  details?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Logs_Delete_Elem_Input = {
  details?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Logs_Delete_Key_Input = {
  details?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "logs" */
export type Logs_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  details?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  level?: InputMaybe<Scalars['String']>;
  service?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['timestamptz']>;
  trace?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Logs_Max_Fields = {
  __typename?: 'logs_max_fields';
  createdAt: Maybe<Scalars['timestamptz']>;
  id: Maybe<Scalars['uuid']>;
  level: Maybe<Scalars['String']>;
  service: Maybe<Scalars['String']>;
  timestamp: Maybe<Scalars['timestamptz']>;
  trace: Maybe<Scalars['String']>;
  type: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
  userId: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "logs" */
export type Logs_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  service?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  trace?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Logs_Min_Fields = {
  __typename?: 'logs_min_fields';
  createdAt: Maybe<Scalars['timestamptz']>;
  id: Maybe<Scalars['uuid']>;
  level: Maybe<Scalars['String']>;
  service: Maybe<Scalars['String']>;
  timestamp: Maybe<Scalars['timestamptz']>;
  trace: Maybe<Scalars['String']>;
  type: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
  userId: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "logs" */
export type Logs_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  service?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  trace?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "logs" */
export type Logs_Mutation_Response = {
  __typename?: 'logs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Logs>;
};

/** on conflict condition type for table "logs" */
export type Logs_On_Conflict = {
  constraint: Logs_Constraint;
  update_columns: Array<Logs_Update_Column>;
  where?: InputMaybe<Logs_Bool_Exp>;
};

/** Ordering options when selecting data from "logs". */
export type Logs_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  details?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  service?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  trace?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: logs */
export type Logs_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Logs_Prepend_Input = {
  details?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "logs" */
export enum Logs_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Details = 'details',
  /** column name */
  Id = 'id',
  /** column name */
  Level = 'level',
  /** column name */
  Service = 'service',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  Trace = 'trace',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "logs" */
export type Logs_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  details?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  level?: InputMaybe<Scalars['String']>;
  service?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['timestamptz']>;
  trace?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "logs" */
export enum Logs_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Details = 'details',
  /** column name */
  Id = 'id',
  /** column name */
  Level = 'level',
  /** column name */
  Service = 'service',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  Trace = 'trace',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  approveRole: Maybe<ApproveOutput>;
  /** delete data from the table: "apiKeys" */
  delete_apiKeys: Maybe<ApiKeys_Mutation_Response>;
  /** delete single row from the table: "apiKeys" */
  delete_apiKeys_by_pk: Maybe<ApiKeys>;
  /** delete data from the table: "callToActionConfigs" */
  delete_callToActionConfigs: Maybe<CallToActionConfigs_Mutation_Response>;
  /** delete single row from the table: "callToActionConfigs" */
  delete_callToActionConfigs_by_pk: Maybe<CallToActionConfigs>;
  /** delete data from the table: "callToActionFields" */
  delete_callToActionFields: Maybe<CallToActionFields_Mutation_Response>;
  /** delete single row from the table: "callToActionFields" */
  delete_callToActionFields_by_pk: Maybe<CallToActionFields>;
  /** delete data from the table: "callToActionGlobalSettings" */
  delete_callToActionGlobalSettings: Maybe<CallToActionGlobalSettings_Mutation_Response>;
  /** delete single row from the table: "callToActionGlobalSettings" */
  delete_callToActionGlobalSettings_by_pk: Maybe<CallToActionGlobalSettings>;
  /** delete data from the table: "devicePublicIps" */
  delete_devicePublicIps: Maybe<DevicePublicIps_Mutation_Response>;
  /** delete single row from the table: "devicePublicIps" */
  delete_devicePublicIps_by_pk: Maybe<DevicePublicIps>;
  /** delete data from the table: "devices" */
  delete_devices: Maybe<Devices_Mutation_Response>;
  /** delete single row from the table: "devices" */
  delete_devices_by_pk: Maybe<Devices>;
  /** delete data from the table: "digitalProducts" */
  delete_digitalProducts: Maybe<DigitalProducts_Mutation_Response>;
  /** delete single row from the table: "digitalProducts" */
  delete_digitalProducts_by_pk: Maybe<DigitalProducts>;
  /** delete data from the table: "documents" */
  delete_documents: Maybe<Documents_Mutation_Response>;
  /** delete single row from the table: "documents" */
  delete_documents_by_pk: Maybe<Documents>;
  /** delete data from the table: "exchangeContent" */
  delete_exchangeContent: Maybe<ExchangeContent_Mutation_Response>;
  /** delete single row from the table: "exchangeContent" */
  delete_exchangeContent_by_pk: Maybe<ExchangeContent>;
  /** delete data from the table: "exchanges" */
  delete_exchanges: Maybe<Exchanges_Mutation_Response>;
  /** delete single row from the table: "exchanges" */
  delete_exchanges_by_pk: Maybe<Exchanges>;
  /** delete data from the table: "files" */
  delete_files: Maybe<Files_Mutation_Response>;
  /** delete single row from the table: "files" */
  delete_files_by_pk: Maybe<Files>;
  /** delete data from the table: "hubspotSyncJob" */
  delete_hubspotSyncJob: Maybe<HubspotSyncJob_Mutation_Response>;
  /** delete single row from the table: "hubspotSyncJob" */
  delete_hubspotSyncJob_by_pk: Maybe<HubspotSyncJob>;
  /** delete data from the table: "languages" */
  delete_languages: Maybe<Languages_Mutation_Response>;
  /** delete single row from the table: "languages" */
  delete_languages_by_pk: Maybe<Languages>;
  /** delete data from the table: "leadLocks" */
  delete_leadLocks: Maybe<LeadLocks_Mutation_Response>;
  /** delete single row from the table: "leadLocks" */
  delete_leadLocks_by_pk: Maybe<LeadLocks>;
  /** delete data from the table: "leadsHistory" */
  delete_leadsHistory: Maybe<LeadsHistory_Mutation_Response>;
  /** delete single row from the table: "leadsHistory" */
  delete_leadsHistory_by_pk: Maybe<LeadsHistory>;
  /** delete data from the table: "logs" */
  delete_logs: Maybe<Logs_Mutation_Response>;
  /** delete single row from the table: "logs" */
  delete_logs_by_pk: Maybe<Logs>;
  /** delete data from the table: "orders" */
  delete_orders: Maybe<Orders_Mutation_Response>;
  /** delete single row from the table: "orders" */
  delete_orders_by_pk: Maybe<Orders>;
  /** delete data from the table: "payments" */
  delete_payments: Maybe<Payments_Mutation_Response>;
  /** delete single row from the table: "payments" */
  delete_payments_by_pk: Maybe<Payments>;
  /** delete data from the table: "products" */
  delete_products: Maybe<Products_Mutation_Response>;
  /** delete single row from the table: "products" */
  delete_products_by_pk: Maybe<Products>;
  /** delete data from the table: "roles" */
  delete_roles: Maybe<Roles_Mutation_Response>;
  /** delete single row from the table: "roles" */
  delete_roles_by_pk: Maybe<Roles>;
  /** delete data from the table: "rules" */
  delete_rules: Maybe<Rules_Mutation_Response>;
  /** delete single row from the table: "rules" */
  delete_rules_by_pk: Maybe<Rules>;
  /** delete data from the table: "settings" */
  delete_settings: Maybe<Settings_Mutation_Response>;
  /** delete single row from the table: "settings" */
  delete_settings_by_pk: Maybe<Settings>;
  /** delete data from the table: "trackingEvents" */
  delete_trackingEvents: Maybe<TrackingEvents_Mutation_Response>;
  /** delete single row from the table: "trackingEvents" */
  delete_trackingEvents_by_pk: Maybe<TrackingEvents>;
  /** delete data from the table: "userData" */
  delete_userData: Maybe<UserData_Mutation_Response>;
  /** delete single row from the table: "userData" */
  delete_userData_by_pk: Maybe<UserData>;
  /** delete data from the table: "userDocuments" */
  delete_userDocuments: Maybe<UserDocuments_Mutation_Response>;
  /** delete single row from the table: "userDocuments" */
  delete_userDocuments_by_pk: Maybe<UserDocuments>;
  /** delete data from the table: "userIdTypes" */
  delete_userIdTypes: Maybe<UserIdTypes_Mutation_Response>;
  /** delete single row from the table: "userIdTypes" */
  delete_userIdTypes_by_pk: Maybe<UserIdTypes>;
  /** delete data from the table: "userIds" */
  delete_userIds: Maybe<UserIds_Mutation_Response>;
  /** delete data from the table: "userRoleRequests" */
  delete_userRoleRequests: Maybe<UserRoleRequests_Mutation_Response>;
  /** delete single row from the table: "userRoleRequests" */
  delete_userRoleRequests_by_pk: Maybe<UserRoleRequests>;
  /** delete data from the table: "userRoles" */
  delete_userRoles: Maybe<UserRoles_Mutation_Response>;
  /** delete single row from the table: "userRoles" */
  delete_userRoles_by_pk: Maybe<UserRoles>;
  /** delete data from the table: "userRuleValues" */
  delete_userRuleValues: Maybe<UserRuleValues_Mutation_Response>;
  /** delete single row from the table: "userRuleValues" */
  delete_userRuleValues_by_pk: Maybe<UserRuleValues>;
  /** delete data from the table: "users" */
  delete_users: Maybe<Users_Mutation_Response>;
  /** delete single row from the table: "users" */
  delete_users_by_pk: Maybe<Users>;
  /** delete data from the table: "videos" */
  delete_videos: Maybe<Videos_Mutation_Response>;
  /** delete single row from the table: "videos" */
  delete_videos_by_pk: Maybe<Videos>;
  insertRolesOneForUser: InsertRolesOneForUserOutput;
  /** insert data into the table: "apiKeys" */
  insert_apiKeys: Maybe<ApiKeys_Mutation_Response>;
  /** insert a single row into the table: "apiKeys" */
  insert_apiKeys_one: Maybe<ApiKeys>;
  /** insert data into the table: "callToActionConfigs" */
  insert_callToActionConfigs: Maybe<CallToActionConfigs_Mutation_Response>;
  /** insert a single row into the table: "callToActionConfigs" */
  insert_callToActionConfigs_one: Maybe<CallToActionConfigs>;
  /** insert data into the table: "callToActionFields" */
  insert_callToActionFields: Maybe<CallToActionFields_Mutation_Response>;
  /** insert a single row into the table: "callToActionFields" */
  insert_callToActionFields_one: Maybe<CallToActionFields>;
  /** insert data into the table: "callToActionGlobalSettings" */
  insert_callToActionGlobalSettings: Maybe<CallToActionGlobalSettings_Mutation_Response>;
  /** insert a single row into the table: "callToActionGlobalSettings" */
  insert_callToActionGlobalSettings_one: Maybe<CallToActionGlobalSettings>;
  /** insert data into the table: "devicePublicIps" */
  insert_devicePublicIps: Maybe<DevicePublicIps_Mutation_Response>;
  /** insert a single row into the table: "devicePublicIps" */
  insert_devicePublicIps_one: Maybe<DevicePublicIps>;
  /** insert data into the table: "devices" */
  insert_devices: Maybe<Devices_Mutation_Response>;
  /** insert a single row into the table: "devices" */
  insert_devices_one: Maybe<Devices>;
  /** insert data into the table: "digitalProducts" */
  insert_digitalProducts: Maybe<DigitalProducts_Mutation_Response>;
  /** insert a single row into the table: "digitalProducts" */
  insert_digitalProducts_one: Maybe<DigitalProducts>;
  /** insert data into the table: "documents" */
  insert_documents: Maybe<Documents_Mutation_Response>;
  /** insert a single row into the table: "documents" */
  insert_documents_one: Maybe<Documents>;
  /** insert data into the table: "exchangeContent" */
  insert_exchangeContent: Maybe<ExchangeContent_Mutation_Response>;
  /** insert a single row into the table: "exchangeContent" */
  insert_exchangeContent_one: Maybe<ExchangeContent>;
  /** insert data into the table: "exchanges" */
  insert_exchanges: Maybe<Exchanges_Mutation_Response>;
  /** insert a single row into the table: "exchanges" */
  insert_exchanges_one: Maybe<Exchanges>;
  /** insert data into the table: "files" */
  insert_files: Maybe<Files_Mutation_Response>;
  /** insert a single row into the table: "files" */
  insert_files_one: Maybe<Files>;
  /** insert data into the table: "hubspotSyncJob" */
  insert_hubspotSyncJob: Maybe<HubspotSyncJob_Mutation_Response>;
  /** insert a single row into the table: "hubspotSyncJob" */
  insert_hubspotSyncJob_one: Maybe<HubspotSyncJob>;
  /** insert data into the table: "languages" */
  insert_languages: Maybe<Languages_Mutation_Response>;
  /** insert a single row into the table: "languages" */
  insert_languages_one: Maybe<Languages>;
  /** insert data into the table: "leadLocks" */
  insert_leadLocks: Maybe<LeadLocks_Mutation_Response>;
  /** insert a single row into the table: "leadLocks" */
  insert_leadLocks_one: Maybe<LeadLocks>;
  /** insert data into the table: "leadsHistory" */
  insert_leadsHistory: Maybe<LeadsHistory_Mutation_Response>;
  /** insert a single row into the table: "leadsHistory" */
  insert_leadsHistory_one: Maybe<LeadsHistory>;
  /** insert data into the table: "logs" */
  insert_logs: Maybe<Logs_Mutation_Response>;
  /** insert a single row into the table: "logs" */
  insert_logs_one: Maybe<Logs>;
  /** insert data into the table: "orders" */
  insert_orders: Maybe<Orders_Mutation_Response>;
  /** insert a single row into the table: "orders" */
  insert_orders_one: Maybe<Orders>;
  /** insert data into the table: "payments" */
  insert_payments: Maybe<Payments_Mutation_Response>;
  /** insert a single row into the table: "payments" */
  insert_payments_one: Maybe<Payments>;
  /** insert data into the table: "products" */
  insert_products: Maybe<Products_Mutation_Response>;
  /** insert a single row into the table: "products" */
  insert_products_one: Maybe<Products>;
  /** insert data into the table: "roles" */
  insert_roles: Maybe<Roles_Mutation_Response>;
  /** insert a single row into the table: "roles" */
  insert_roles_one: Maybe<Roles>;
  /** insert data into the table: "rules" */
  insert_rules: Maybe<Rules_Mutation_Response>;
  /** insert a single row into the table: "rules" */
  insert_rules_one: Maybe<Rules>;
  /** insert data into the table: "settings" */
  insert_settings: Maybe<Settings_Mutation_Response>;
  /** insert a single row into the table: "settings" */
  insert_settings_one: Maybe<Settings>;
  /** insert data into the table: "trackingEvents" */
  insert_trackingEvents: Maybe<TrackingEvents_Mutation_Response>;
  /** insert a single row into the table: "trackingEvents" */
  insert_trackingEvents_one: Maybe<TrackingEvents>;
  /** insert data into the table: "userData" */
  insert_userData: Maybe<UserData_Mutation_Response>;
  /** insert a single row into the table: "userData" */
  insert_userData_one: Maybe<UserData>;
  /** insert data into the table: "userDocuments" */
  insert_userDocuments: Maybe<UserDocuments_Mutation_Response>;
  /** insert a single row into the table: "userDocuments" */
  insert_userDocuments_one: Maybe<UserDocuments>;
  /** insert data into the table: "userIdTypes" */
  insert_userIdTypes: Maybe<UserIdTypes_Mutation_Response>;
  /** insert a single row into the table: "userIdTypes" */
  insert_userIdTypes_one: Maybe<UserIdTypes>;
  /** insert data into the table: "userIds" */
  insert_userIds: Maybe<UserIds_Mutation_Response>;
  /** insert a single row into the table: "userIds" */
  insert_userIds_one: Maybe<UserIds>;
  /** insert data into the table: "userRoleRequests" */
  insert_userRoleRequests: Maybe<UserRoleRequests_Mutation_Response>;
  /** insert a single row into the table: "userRoleRequests" */
  insert_userRoleRequests_one: Maybe<UserRoleRequests>;
  /** insert data into the table: "userRoles" */
  insert_userRoles: Maybe<UserRoles_Mutation_Response>;
  /** insert a single row into the table: "userRoles" */
  insert_userRoles_one: Maybe<UserRoles>;
  /** insert data into the table: "userRuleValues" */
  insert_userRuleValues: Maybe<UserRuleValues_Mutation_Response>;
  /** insert a single row into the table: "userRuleValues" */
  insert_userRuleValues_one: Maybe<UserRuleValues>;
  /** insert data into the table: "users" */
  insert_users: Maybe<Users_Mutation_Response>;
  /** insert a single row into the table: "users" */
  insert_users_one: Maybe<Users>;
  /** insert data into the table: "videos" */
  insert_videos: Maybe<Videos_Mutation_Response>;
  /** insert a single row into the table: "videos" */
  insert_videos_one: Maybe<Videos>;
  registerAndLoginUser: Maybe<RegisterAndLoginOutput>;
  sendEmail: Maybe<EmailOutput>;
  /** update data of the table: "apiKeys" */
  update_apiKeys: Maybe<ApiKeys_Mutation_Response>;
  /** update single row of the table: "apiKeys" */
  update_apiKeys_by_pk: Maybe<ApiKeys>;
  /** update data of the table: "callToActionConfigs" */
  update_callToActionConfigs: Maybe<CallToActionConfigs_Mutation_Response>;
  /** update single row of the table: "callToActionConfigs" */
  update_callToActionConfigs_by_pk: Maybe<CallToActionConfigs>;
  /** update data of the table: "callToActionFields" */
  update_callToActionFields: Maybe<CallToActionFields_Mutation_Response>;
  /** update single row of the table: "callToActionFields" */
  update_callToActionFields_by_pk: Maybe<CallToActionFields>;
  /** update data of the table: "callToActionGlobalSettings" */
  update_callToActionGlobalSettings: Maybe<CallToActionGlobalSettings_Mutation_Response>;
  /** update single row of the table: "callToActionGlobalSettings" */
  update_callToActionGlobalSettings_by_pk: Maybe<CallToActionGlobalSettings>;
  /** update data of the table: "devicePublicIps" */
  update_devicePublicIps: Maybe<DevicePublicIps_Mutation_Response>;
  /** update single row of the table: "devicePublicIps" */
  update_devicePublicIps_by_pk: Maybe<DevicePublicIps>;
  /** update data of the table: "devices" */
  update_devices: Maybe<Devices_Mutation_Response>;
  /** update single row of the table: "devices" */
  update_devices_by_pk: Maybe<Devices>;
  /** update data of the table: "digitalProducts" */
  update_digitalProducts: Maybe<DigitalProducts_Mutation_Response>;
  /** update single row of the table: "digitalProducts" */
  update_digitalProducts_by_pk: Maybe<DigitalProducts>;
  /** update data of the table: "documents" */
  update_documents: Maybe<Documents_Mutation_Response>;
  /** update single row of the table: "documents" */
  update_documents_by_pk: Maybe<Documents>;
  /** update data of the table: "exchangeContent" */
  update_exchangeContent: Maybe<ExchangeContent_Mutation_Response>;
  /** update single row of the table: "exchangeContent" */
  update_exchangeContent_by_pk: Maybe<ExchangeContent>;
  /** update data of the table: "exchanges" */
  update_exchanges: Maybe<Exchanges_Mutation_Response>;
  /** update single row of the table: "exchanges" */
  update_exchanges_by_pk: Maybe<Exchanges>;
  /** update data of the table: "files" */
  update_files: Maybe<Files_Mutation_Response>;
  /** update single row of the table: "files" */
  update_files_by_pk: Maybe<Files>;
  /** update data of the table: "hubspotSyncJob" */
  update_hubspotSyncJob: Maybe<HubspotSyncJob_Mutation_Response>;
  /** update single row of the table: "hubspotSyncJob" */
  update_hubspotSyncJob_by_pk: Maybe<HubspotSyncJob>;
  /** update data of the table: "languages" */
  update_languages: Maybe<Languages_Mutation_Response>;
  /** update single row of the table: "languages" */
  update_languages_by_pk: Maybe<Languages>;
  /** update data of the table: "leadLocks" */
  update_leadLocks: Maybe<LeadLocks_Mutation_Response>;
  /** update single row of the table: "leadLocks" */
  update_leadLocks_by_pk: Maybe<LeadLocks>;
  /** update data of the table: "leadsHistory" */
  update_leadsHistory: Maybe<LeadsHistory_Mutation_Response>;
  /** update single row of the table: "leadsHistory" */
  update_leadsHistory_by_pk: Maybe<LeadsHistory>;
  /** update data of the table: "logs" */
  update_logs: Maybe<Logs_Mutation_Response>;
  /** update single row of the table: "logs" */
  update_logs_by_pk: Maybe<Logs>;
  /** update data of the table: "orders" */
  update_orders: Maybe<Orders_Mutation_Response>;
  /** update single row of the table: "orders" */
  update_orders_by_pk: Maybe<Orders>;
  /** update data of the table: "payments" */
  update_payments: Maybe<Payments_Mutation_Response>;
  /** update single row of the table: "payments" */
  update_payments_by_pk: Maybe<Payments>;
  /** update data of the table: "products" */
  update_products: Maybe<Products_Mutation_Response>;
  /** update single row of the table: "products" */
  update_products_by_pk: Maybe<Products>;
  /** update data of the table: "roles" */
  update_roles: Maybe<Roles_Mutation_Response>;
  /** update single row of the table: "roles" */
  update_roles_by_pk: Maybe<Roles>;
  /** update data of the table: "rules" */
  update_rules: Maybe<Rules_Mutation_Response>;
  /** update single row of the table: "rules" */
  update_rules_by_pk: Maybe<Rules>;
  /** update data of the table: "settings" */
  update_settings: Maybe<Settings_Mutation_Response>;
  /** update single row of the table: "settings" */
  update_settings_by_pk: Maybe<Settings>;
  /** update data of the table: "trackingEvents" */
  update_trackingEvents: Maybe<TrackingEvents_Mutation_Response>;
  /** update single row of the table: "trackingEvents" */
  update_trackingEvents_by_pk: Maybe<TrackingEvents>;
  /** update data of the table: "userData" */
  update_userData: Maybe<UserData_Mutation_Response>;
  /** update single row of the table: "userData" */
  update_userData_by_pk: Maybe<UserData>;
  /** update data of the table: "userDocuments" */
  update_userDocuments: Maybe<UserDocuments_Mutation_Response>;
  /** update single row of the table: "userDocuments" */
  update_userDocuments_by_pk: Maybe<UserDocuments>;
  /** update data of the table: "userIdTypes" */
  update_userIdTypes: Maybe<UserIdTypes_Mutation_Response>;
  /** update single row of the table: "userIdTypes" */
  update_userIdTypes_by_pk: Maybe<UserIdTypes>;
  /** update data of the table: "userIds" */
  update_userIds: Maybe<UserIds_Mutation_Response>;
  /** update data of the table: "userRoleRequests" */
  update_userRoleRequests: Maybe<UserRoleRequests_Mutation_Response>;
  /** update single row of the table: "userRoleRequests" */
  update_userRoleRequests_by_pk: Maybe<UserRoleRequests>;
  /** update data of the table: "userRoles" */
  update_userRoles: Maybe<UserRoles_Mutation_Response>;
  /** update single row of the table: "userRoles" */
  update_userRoles_by_pk: Maybe<UserRoles>;
  /** update data of the table: "userRuleValues" */
  update_userRuleValues: Maybe<UserRuleValues_Mutation_Response>;
  /** update single row of the table: "userRuleValues" */
  update_userRuleValues_by_pk: Maybe<UserRuleValues>;
  /** update data of the table: "users" */
  update_users: Maybe<Users_Mutation_Response>;
  /** update single row of the table: "users" */
  update_users_by_pk: Maybe<Users>;
  /** update data of the table: "videos" */
  update_videos: Maybe<Videos_Mutation_Response>;
  /** update single row of the table: "videos" */
  update_videos_by_pk: Maybe<Videos>;
  upsert_userAndUserData_one: Maybe<Upsert_UserAndUserData_Response>;
};


/** mutation root */
export type Mutation_RootApproveRoleArgs = {
  userRoleId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ApiKeysArgs = {
  where: ApiKeys_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ApiKeys_By_PkArgs = {
  key: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_CallToActionConfigsArgs = {
  where: CallToActionConfigs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_CallToActionConfigs_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_CallToActionFieldsArgs = {
  where: CallToActionFields_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_CallToActionFields_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_CallToActionGlobalSettingsArgs = {
  where: CallToActionGlobalSettings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_CallToActionGlobalSettings_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_DevicePublicIpsArgs = {
  where: DevicePublicIps_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_DevicePublicIps_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_DevicesArgs = {
  where: Devices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Devices_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_DigitalProductsArgs = {
  where: DigitalProducts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_DigitalProducts_By_PkArgs = {
  sku: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_DocumentsArgs = {
  where: Documents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Documents_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ExchangeContentArgs = {
  where: ExchangeContent_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ExchangeContent_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ExchangesArgs = {
  where: Exchanges_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Exchanges_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_FilesArgs = {
  where: Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Files_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_HubspotSyncJobArgs = {
  where: HubspotSyncJob_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_HubspotSyncJob_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_LanguagesArgs = {
  where: Languages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Languages_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_LeadLocksArgs = {
  where: LeadLocks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_LeadLocks_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_LeadsHistoryArgs = {
  where: LeadsHistory_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_LeadsHistory_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_LogsArgs = {
  where: Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Logs_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_OrdersArgs = {
  where: Orders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Orders_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_PaymentsArgs = {
  where: Payments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Payments_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ProductsArgs = {
  where: Products_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Products_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_RolesArgs = {
  where: Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Roles_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_RulesArgs = {
  where: Rules_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Rules_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_SettingsArgs = {
  where: Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Settings_By_PkArgs = {
  key: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_TrackingEventsArgs = {
  where: TrackingEvents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_TrackingEvents_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_UserDataArgs = {
  where: UserData_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_UserData_By_PkArgs = {
  profileId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_UserDocumentsArgs = {
  where: UserDocuments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_UserDocuments_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_UserIdTypesArgs = {
  where: UserIdTypes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_UserIdTypes_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_UserIdsArgs = {
  where: UserIds_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_UserRoleRequestsArgs = {
  where: UserRoleRequests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_UserRoleRequests_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_UserRolesArgs = {
  where: UserRoles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_UserRoles_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_UserRuleValuesArgs = {
  where: UserRuleValues_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_UserRuleValues_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_UsersArgs = {
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Users_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_VideosArgs = {
  where: Videos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Videos_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootInsertRolesOneForUserArgs = {
  roleName: Scalars['String'];
};


/** mutation root */
export type Mutation_RootInsert_ApiKeysArgs = {
  objects: Array<ApiKeys_Insert_Input>;
  on_conflict: InputMaybe<ApiKeys_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ApiKeys_OneArgs = {
  object: ApiKeys_Insert_Input;
  on_conflict: InputMaybe<ApiKeys_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CallToActionConfigsArgs = {
  objects: Array<CallToActionConfigs_Insert_Input>;
  on_conflict: InputMaybe<CallToActionConfigs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CallToActionConfigs_OneArgs = {
  object: CallToActionConfigs_Insert_Input;
  on_conflict: InputMaybe<CallToActionConfigs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CallToActionFieldsArgs = {
  objects: Array<CallToActionFields_Insert_Input>;
  on_conflict: InputMaybe<CallToActionFields_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CallToActionFields_OneArgs = {
  object: CallToActionFields_Insert_Input;
  on_conflict: InputMaybe<CallToActionFields_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CallToActionGlobalSettingsArgs = {
  objects: Array<CallToActionGlobalSettings_Insert_Input>;
  on_conflict: InputMaybe<CallToActionGlobalSettings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CallToActionGlobalSettings_OneArgs = {
  object: CallToActionGlobalSettings_Insert_Input;
  on_conflict: InputMaybe<CallToActionGlobalSettings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_DevicePublicIpsArgs = {
  objects: Array<DevicePublicIps_Insert_Input>;
  on_conflict: InputMaybe<DevicePublicIps_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_DevicePublicIps_OneArgs = {
  object: DevicePublicIps_Insert_Input;
  on_conflict: InputMaybe<DevicePublicIps_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_DevicesArgs = {
  objects: Array<Devices_Insert_Input>;
  on_conflict: InputMaybe<Devices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Devices_OneArgs = {
  object: Devices_Insert_Input;
  on_conflict: InputMaybe<Devices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_DigitalProductsArgs = {
  objects: Array<DigitalProducts_Insert_Input>;
  on_conflict: InputMaybe<DigitalProducts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_DigitalProducts_OneArgs = {
  object: DigitalProducts_Insert_Input;
  on_conflict: InputMaybe<DigitalProducts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_DocumentsArgs = {
  objects: Array<Documents_Insert_Input>;
  on_conflict: InputMaybe<Documents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Documents_OneArgs = {
  object: Documents_Insert_Input;
  on_conflict: InputMaybe<Documents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ExchangeContentArgs = {
  objects: Array<ExchangeContent_Insert_Input>;
  on_conflict: InputMaybe<ExchangeContent_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ExchangeContent_OneArgs = {
  object: ExchangeContent_Insert_Input;
  on_conflict: InputMaybe<ExchangeContent_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ExchangesArgs = {
  objects: Array<Exchanges_Insert_Input>;
  on_conflict: InputMaybe<Exchanges_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Exchanges_OneArgs = {
  object: Exchanges_Insert_Input;
  on_conflict: InputMaybe<Exchanges_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FilesArgs = {
  objects: Array<Files_Insert_Input>;
  on_conflict: InputMaybe<Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Files_OneArgs = {
  object: Files_Insert_Input;
  on_conflict: InputMaybe<Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_HubspotSyncJobArgs = {
  objects: Array<HubspotSyncJob_Insert_Input>;
  on_conflict: InputMaybe<HubspotSyncJob_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_HubspotSyncJob_OneArgs = {
  object: HubspotSyncJob_Insert_Input;
  on_conflict: InputMaybe<HubspotSyncJob_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LanguagesArgs = {
  objects: Array<Languages_Insert_Input>;
  on_conflict: InputMaybe<Languages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Languages_OneArgs = {
  object: Languages_Insert_Input;
  on_conflict: InputMaybe<Languages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LeadLocksArgs = {
  objects: Array<LeadLocks_Insert_Input>;
  on_conflict: InputMaybe<LeadLocks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LeadLocks_OneArgs = {
  object: LeadLocks_Insert_Input;
  on_conflict: InputMaybe<LeadLocks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LeadsHistoryArgs = {
  objects: Array<LeadsHistory_Insert_Input>;
  on_conflict: InputMaybe<LeadsHistory_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LeadsHistory_OneArgs = {
  object: LeadsHistory_Insert_Input;
  on_conflict: InputMaybe<LeadsHistory_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LogsArgs = {
  objects: Array<Logs_Insert_Input>;
  on_conflict: InputMaybe<Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Logs_OneArgs = {
  object: Logs_Insert_Input;
  on_conflict: InputMaybe<Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_OrdersArgs = {
  objects: Array<Orders_Insert_Input>;
  on_conflict: InputMaybe<Orders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Orders_OneArgs = {
  object: Orders_Insert_Input;
  on_conflict: InputMaybe<Orders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PaymentsArgs = {
  objects: Array<Payments_Insert_Input>;
  on_conflict: InputMaybe<Payments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Payments_OneArgs = {
  object: Payments_Insert_Input;
  on_conflict: InputMaybe<Payments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProductsArgs = {
  objects: Array<Products_Insert_Input>;
  on_conflict: InputMaybe<Products_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Products_OneArgs = {
  object: Products_Insert_Input;
  on_conflict: InputMaybe<Products_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RolesArgs = {
  objects: Array<Roles_Insert_Input>;
  on_conflict: InputMaybe<Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Roles_OneArgs = {
  object: Roles_Insert_Input;
  on_conflict: InputMaybe<Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RulesArgs = {
  objects: Array<Rules_Insert_Input>;
  on_conflict: InputMaybe<Rules_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rules_OneArgs = {
  object: Rules_Insert_Input;
  on_conflict: InputMaybe<Rules_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SettingsArgs = {
  objects: Array<Settings_Insert_Input>;
  on_conflict: InputMaybe<Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Settings_OneArgs = {
  object: Settings_Insert_Input;
  on_conflict: InputMaybe<Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TrackingEventsArgs = {
  objects: Array<TrackingEvents_Insert_Input>;
  on_conflict: InputMaybe<TrackingEvents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TrackingEvents_OneArgs = {
  object: TrackingEvents_Insert_Input;
  on_conflict: InputMaybe<TrackingEvents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserDataArgs = {
  objects: Array<UserData_Insert_Input>;
  on_conflict: InputMaybe<UserData_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserData_OneArgs = {
  object: UserData_Insert_Input;
  on_conflict: InputMaybe<UserData_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserDocumentsArgs = {
  objects: Array<UserDocuments_Insert_Input>;
  on_conflict: InputMaybe<UserDocuments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserDocuments_OneArgs = {
  object: UserDocuments_Insert_Input;
  on_conflict: InputMaybe<UserDocuments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserIdTypesArgs = {
  objects: Array<UserIdTypes_Insert_Input>;
  on_conflict: InputMaybe<UserIdTypes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserIdTypes_OneArgs = {
  object: UserIdTypes_Insert_Input;
  on_conflict: InputMaybe<UserIdTypes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserIdsArgs = {
  objects: Array<UserIds_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_UserIds_OneArgs = {
  object: UserIds_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_UserRoleRequestsArgs = {
  objects: Array<UserRoleRequests_Insert_Input>;
  on_conflict: InputMaybe<UserRoleRequests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserRoleRequests_OneArgs = {
  object: UserRoleRequests_Insert_Input;
  on_conflict: InputMaybe<UserRoleRequests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserRolesArgs = {
  objects: Array<UserRoles_Insert_Input>;
  on_conflict: InputMaybe<UserRoles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserRoles_OneArgs = {
  object: UserRoles_Insert_Input;
  on_conflict: InputMaybe<UserRoles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserRuleValuesArgs = {
  objects: Array<UserRuleValues_Insert_Input>;
  on_conflict: InputMaybe<UserRuleValues_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserRuleValues_OneArgs = {
  object: UserRuleValues_Insert_Input;
  on_conflict: InputMaybe<UserRuleValues_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UsersArgs = {
  objects: Array<Users_Insert_Input>;
  on_conflict: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_OneArgs = {
  object: Users_Insert_Input;
  on_conflict: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_VideosArgs = {
  objects: Array<Videos_Insert_Input>;
  on_conflict: InputMaybe<Videos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Videos_OneArgs = {
  object: Videos_Insert_Input;
  on_conflict: InputMaybe<Videos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootRegisterAndLoginUserArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
  userData: InputMaybe<UserData_Set_Input_Custom>;
  userRoleRequestsByName: InputMaybe<Array<UserRoleRequestByNameInput>>;
};


/** mutation root */
export type Mutation_RootSendEmailArgs = {
  fromEmail: Scalars['String'];
  htmlMessage: Scalars['String'];
  replyToEmail: Scalars['String'];
  subject: Scalars['String'];
  toEmail: Scalars['String'];
};


/** mutation root */
export type Mutation_RootUpdate_ApiKeysArgs = {
  _set: InputMaybe<ApiKeys_Set_Input>;
  where: ApiKeys_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ApiKeys_By_PkArgs = {
  _set: InputMaybe<ApiKeys_Set_Input>;
  pk_columns: ApiKeys_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_CallToActionConfigsArgs = {
  _set: InputMaybe<CallToActionConfigs_Set_Input>;
  where: CallToActionConfigs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_CallToActionConfigs_By_PkArgs = {
  _set: InputMaybe<CallToActionConfigs_Set_Input>;
  pk_columns: CallToActionConfigs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_CallToActionFieldsArgs = {
  _set: InputMaybe<CallToActionFields_Set_Input>;
  where: CallToActionFields_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_CallToActionFields_By_PkArgs = {
  _set: InputMaybe<CallToActionFields_Set_Input>;
  pk_columns: CallToActionFields_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_CallToActionGlobalSettingsArgs = {
  _set: InputMaybe<CallToActionGlobalSettings_Set_Input>;
  where: CallToActionGlobalSettings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_CallToActionGlobalSettings_By_PkArgs = {
  _set: InputMaybe<CallToActionGlobalSettings_Set_Input>;
  pk_columns: CallToActionGlobalSettings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_DevicePublicIpsArgs = {
  _set: InputMaybe<DevicePublicIps_Set_Input>;
  where: DevicePublicIps_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_DevicePublicIps_By_PkArgs = {
  _set: InputMaybe<DevicePublicIps_Set_Input>;
  pk_columns: DevicePublicIps_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_DevicesArgs = {
  _append: InputMaybe<Devices_Append_Input>;
  _delete_at_path: InputMaybe<Devices_Delete_At_Path_Input>;
  _delete_elem: InputMaybe<Devices_Delete_Elem_Input>;
  _delete_key: InputMaybe<Devices_Delete_Key_Input>;
  _prepend: InputMaybe<Devices_Prepend_Input>;
  _set: InputMaybe<Devices_Set_Input>;
  where: Devices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Devices_By_PkArgs = {
  _append: InputMaybe<Devices_Append_Input>;
  _delete_at_path: InputMaybe<Devices_Delete_At_Path_Input>;
  _delete_elem: InputMaybe<Devices_Delete_Elem_Input>;
  _delete_key: InputMaybe<Devices_Delete_Key_Input>;
  _prepend: InputMaybe<Devices_Prepend_Input>;
  _set: InputMaybe<Devices_Set_Input>;
  pk_columns: Devices_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_DigitalProductsArgs = {
  _append: InputMaybe<DigitalProducts_Append_Input>;
  _delete_at_path: InputMaybe<DigitalProducts_Delete_At_Path_Input>;
  _delete_elem: InputMaybe<DigitalProducts_Delete_Elem_Input>;
  _delete_key: InputMaybe<DigitalProducts_Delete_Key_Input>;
  _prepend: InputMaybe<DigitalProducts_Prepend_Input>;
  _set: InputMaybe<DigitalProducts_Set_Input>;
  where: DigitalProducts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_DigitalProducts_By_PkArgs = {
  _append: InputMaybe<DigitalProducts_Append_Input>;
  _delete_at_path: InputMaybe<DigitalProducts_Delete_At_Path_Input>;
  _delete_elem: InputMaybe<DigitalProducts_Delete_Elem_Input>;
  _delete_key: InputMaybe<DigitalProducts_Delete_Key_Input>;
  _prepend: InputMaybe<DigitalProducts_Prepend_Input>;
  _set: InputMaybe<DigitalProducts_Set_Input>;
  pk_columns: DigitalProducts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_DocumentsArgs = {
  _append: InputMaybe<Documents_Append_Input>;
  _delete_at_path: InputMaybe<Documents_Delete_At_Path_Input>;
  _delete_elem: InputMaybe<Documents_Delete_Elem_Input>;
  _delete_key: InputMaybe<Documents_Delete_Key_Input>;
  _prepend: InputMaybe<Documents_Prepend_Input>;
  _set: InputMaybe<Documents_Set_Input>;
  where: Documents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Documents_By_PkArgs = {
  _append: InputMaybe<Documents_Append_Input>;
  _delete_at_path: InputMaybe<Documents_Delete_At_Path_Input>;
  _delete_elem: InputMaybe<Documents_Delete_Elem_Input>;
  _delete_key: InputMaybe<Documents_Delete_Key_Input>;
  _prepend: InputMaybe<Documents_Prepend_Input>;
  _set: InputMaybe<Documents_Set_Input>;
  pk_columns: Documents_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ExchangeContentArgs = {
  _set: InputMaybe<ExchangeContent_Set_Input>;
  where: ExchangeContent_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ExchangeContent_By_PkArgs = {
  _set: InputMaybe<ExchangeContent_Set_Input>;
  pk_columns: ExchangeContent_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ExchangesArgs = {
  _set: InputMaybe<Exchanges_Set_Input>;
  where: Exchanges_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Exchanges_By_PkArgs = {
  _set: InputMaybe<Exchanges_Set_Input>;
  pk_columns: Exchanges_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_FilesArgs = {
  _append: InputMaybe<Files_Append_Input>;
  _delete_at_path: InputMaybe<Files_Delete_At_Path_Input>;
  _delete_elem: InputMaybe<Files_Delete_Elem_Input>;
  _delete_key: InputMaybe<Files_Delete_Key_Input>;
  _inc: InputMaybe<Files_Inc_Input>;
  _prepend: InputMaybe<Files_Prepend_Input>;
  _set: InputMaybe<Files_Set_Input>;
  where: Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Files_By_PkArgs = {
  _append: InputMaybe<Files_Append_Input>;
  _delete_at_path: InputMaybe<Files_Delete_At_Path_Input>;
  _delete_elem: InputMaybe<Files_Delete_Elem_Input>;
  _delete_key: InputMaybe<Files_Delete_Key_Input>;
  _inc: InputMaybe<Files_Inc_Input>;
  _prepend: InputMaybe<Files_Prepend_Input>;
  _set: InputMaybe<Files_Set_Input>;
  pk_columns: Files_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_HubspotSyncJobArgs = {
  _inc: InputMaybe<HubspotSyncJob_Inc_Input>;
  _set: InputMaybe<HubspotSyncJob_Set_Input>;
  where: HubspotSyncJob_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_HubspotSyncJob_By_PkArgs = {
  _inc: InputMaybe<HubspotSyncJob_Inc_Input>;
  _set: InputMaybe<HubspotSyncJob_Set_Input>;
  pk_columns: HubspotSyncJob_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_LanguagesArgs = {
  _inc: InputMaybe<Languages_Inc_Input>;
  _set: InputMaybe<Languages_Set_Input>;
  where: Languages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Languages_By_PkArgs = {
  _inc: InputMaybe<Languages_Inc_Input>;
  _set: InputMaybe<Languages_Set_Input>;
  pk_columns: Languages_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_LeadLocksArgs = {
  _set: InputMaybe<LeadLocks_Set_Input>;
  where: LeadLocks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_LeadLocks_By_PkArgs = {
  _set: InputMaybe<LeadLocks_Set_Input>;
  pk_columns: LeadLocks_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_LeadsHistoryArgs = {
  _set: InputMaybe<LeadsHistory_Set_Input>;
  where: LeadsHistory_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_LeadsHistory_By_PkArgs = {
  _set: InputMaybe<LeadsHistory_Set_Input>;
  pk_columns: LeadsHistory_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_LogsArgs = {
  _append: InputMaybe<Logs_Append_Input>;
  _delete_at_path: InputMaybe<Logs_Delete_At_Path_Input>;
  _delete_elem: InputMaybe<Logs_Delete_Elem_Input>;
  _delete_key: InputMaybe<Logs_Delete_Key_Input>;
  _prepend: InputMaybe<Logs_Prepend_Input>;
  _set: InputMaybe<Logs_Set_Input>;
  where: Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Logs_By_PkArgs = {
  _append: InputMaybe<Logs_Append_Input>;
  _delete_at_path: InputMaybe<Logs_Delete_At_Path_Input>;
  _delete_elem: InputMaybe<Logs_Delete_Elem_Input>;
  _delete_key: InputMaybe<Logs_Delete_Key_Input>;
  _prepend: InputMaybe<Logs_Prepend_Input>;
  _set: InputMaybe<Logs_Set_Input>;
  pk_columns: Logs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_OrdersArgs = {
  _append: InputMaybe<Orders_Append_Input>;
  _delete_at_path: InputMaybe<Orders_Delete_At_Path_Input>;
  _delete_elem: InputMaybe<Orders_Delete_Elem_Input>;
  _delete_key: InputMaybe<Orders_Delete_Key_Input>;
  _prepend: InputMaybe<Orders_Prepend_Input>;
  _set: InputMaybe<Orders_Set_Input>;
  where: Orders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Orders_By_PkArgs = {
  _append: InputMaybe<Orders_Append_Input>;
  _delete_at_path: InputMaybe<Orders_Delete_At_Path_Input>;
  _delete_elem: InputMaybe<Orders_Delete_Elem_Input>;
  _delete_key: InputMaybe<Orders_Delete_Key_Input>;
  _prepend: InputMaybe<Orders_Prepend_Input>;
  _set: InputMaybe<Orders_Set_Input>;
  pk_columns: Orders_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_PaymentsArgs = {
  _append: InputMaybe<Payments_Append_Input>;
  _delete_at_path: InputMaybe<Payments_Delete_At_Path_Input>;
  _delete_elem: InputMaybe<Payments_Delete_Elem_Input>;
  _delete_key: InputMaybe<Payments_Delete_Key_Input>;
  _inc: InputMaybe<Payments_Inc_Input>;
  _prepend: InputMaybe<Payments_Prepend_Input>;
  _set: InputMaybe<Payments_Set_Input>;
  where: Payments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Payments_By_PkArgs = {
  _append: InputMaybe<Payments_Append_Input>;
  _delete_at_path: InputMaybe<Payments_Delete_At_Path_Input>;
  _delete_elem: InputMaybe<Payments_Delete_Elem_Input>;
  _delete_key: InputMaybe<Payments_Delete_Key_Input>;
  _inc: InputMaybe<Payments_Inc_Input>;
  _prepend: InputMaybe<Payments_Prepend_Input>;
  _set: InputMaybe<Payments_Set_Input>;
  pk_columns: Payments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ProductsArgs = {
  _append: InputMaybe<Products_Append_Input>;
  _delete_at_path: InputMaybe<Products_Delete_At_Path_Input>;
  _delete_elem: InputMaybe<Products_Delete_Elem_Input>;
  _delete_key: InputMaybe<Products_Delete_Key_Input>;
  _prepend: InputMaybe<Products_Prepend_Input>;
  _set: InputMaybe<Products_Set_Input>;
  where: Products_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Products_By_PkArgs = {
  _append: InputMaybe<Products_Append_Input>;
  _delete_at_path: InputMaybe<Products_Delete_At_Path_Input>;
  _delete_elem: InputMaybe<Products_Delete_Elem_Input>;
  _delete_key: InputMaybe<Products_Delete_Key_Input>;
  _prepend: InputMaybe<Products_Prepend_Input>;
  _set: InputMaybe<Products_Set_Input>;
  pk_columns: Products_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_RolesArgs = {
  _set: InputMaybe<Roles_Set_Input>;
  where: Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Roles_By_PkArgs = {
  _set: InputMaybe<Roles_Set_Input>;
  pk_columns: Roles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_RulesArgs = {
  _append: InputMaybe<Rules_Append_Input>;
  _delete_at_path: InputMaybe<Rules_Delete_At_Path_Input>;
  _delete_elem: InputMaybe<Rules_Delete_Elem_Input>;
  _delete_key: InputMaybe<Rules_Delete_Key_Input>;
  _prepend: InputMaybe<Rules_Prepend_Input>;
  _set: InputMaybe<Rules_Set_Input>;
  where: Rules_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Rules_By_PkArgs = {
  _append: InputMaybe<Rules_Append_Input>;
  _delete_at_path: InputMaybe<Rules_Delete_At_Path_Input>;
  _delete_elem: InputMaybe<Rules_Delete_Elem_Input>;
  _delete_key: InputMaybe<Rules_Delete_Key_Input>;
  _prepend: InputMaybe<Rules_Prepend_Input>;
  _set: InputMaybe<Rules_Set_Input>;
  pk_columns: Rules_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_SettingsArgs = {
  _set: InputMaybe<Settings_Set_Input>;
  where: Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Settings_By_PkArgs = {
  _set: InputMaybe<Settings_Set_Input>;
  pk_columns: Settings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_TrackingEventsArgs = {
  _append: InputMaybe<TrackingEvents_Append_Input>;
  _delete_at_path: InputMaybe<TrackingEvents_Delete_At_Path_Input>;
  _delete_elem: InputMaybe<TrackingEvents_Delete_Elem_Input>;
  _delete_key: InputMaybe<TrackingEvents_Delete_Key_Input>;
  _prepend: InputMaybe<TrackingEvents_Prepend_Input>;
  _set: InputMaybe<TrackingEvents_Set_Input>;
  where: TrackingEvents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_TrackingEvents_By_PkArgs = {
  _append: InputMaybe<TrackingEvents_Append_Input>;
  _delete_at_path: InputMaybe<TrackingEvents_Delete_At_Path_Input>;
  _delete_elem: InputMaybe<TrackingEvents_Delete_Elem_Input>;
  _delete_key: InputMaybe<TrackingEvents_Delete_Key_Input>;
  _prepend: InputMaybe<TrackingEvents_Prepend_Input>;
  _set: InputMaybe<TrackingEvents_Set_Input>;
  pk_columns: TrackingEvents_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_UserDataArgs = {
  _inc: InputMaybe<UserData_Inc_Input>;
  _set: InputMaybe<UserData_Set_Input>;
  where: UserData_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_UserData_By_PkArgs = {
  _inc: InputMaybe<UserData_Inc_Input>;
  _set: InputMaybe<UserData_Set_Input>;
  pk_columns: UserData_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_UserDocumentsArgs = {
  _append: InputMaybe<UserDocuments_Append_Input>;
  _delete_at_path: InputMaybe<UserDocuments_Delete_At_Path_Input>;
  _delete_elem: InputMaybe<UserDocuments_Delete_Elem_Input>;
  _delete_key: InputMaybe<UserDocuments_Delete_Key_Input>;
  _prepend: InputMaybe<UserDocuments_Prepend_Input>;
  _set: InputMaybe<UserDocuments_Set_Input>;
  where: UserDocuments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_UserDocuments_By_PkArgs = {
  _append: InputMaybe<UserDocuments_Append_Input>;
  _delete_at_path: InputMaybe<UserDocuments_Delete_At_Path_Input>;
  _delete_elem: InputMaybe<UserDocuments_Delete_Elem_Input>;
  _delete_key: InputMaybe<UserDocuments_Delete_Key_Input>;
  _prepend: InputMaybe<UserDocuments_Prepend_Input>;
  _set: InputMaybe<UserDocuments_Set_Input>;
  pk_columns: UserDocuments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_UserIdTypesArgs = {
  _set: InputMaybe<UserIdTypes_Set_Input>;
  where: UserIdTypes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_UserIdTypes_By_PkArgs = {
  _set: InputMaybe<UserIdTypes_Set_Input>;
  pk_columns: UserIdTypes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_UserIdsArgs = {
  _set: InputMaybe<UserIds_Set_Input>;
  where: UserIds_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_UserRoleRequestsArgs = {
  _set: InputMaybe<UserRoleRequests_Set_Input>;
  where: UserRoleRequests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_UserRoleRequests_By_PkArgs = {
  _set: InputMaybe<UserRoleRequests_Set_Input>;
  pk_columns: UserRoleRequests_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_UserRolesArgs = {
  _set: InputMaybe<UserRoles_Set_Input>;
  where: UserRoles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_UserRoles_By_PkArgs = {
  _set: InputMaybe<UserRoles_Set_Input>;
  pk_columns: UserRoles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_UserRuleValuesArgs = {
  _append: InputMaybe<UserRuleValues_Append_Input>;
  _delete_at_path: InputMaybe<UserRuleValues_Delete_At_Path_Input>;
  _delete_elem: InputMaybe<UserRuleValues_Delete_Elem_Input>;
  _delete_key: InputMaybe<UserRuleValues_Delete_Key_Input>;
  _prepend: InputMaybe<UserRuleValues_Prepend_Input>;
  _set: InputMaybe<UserRuleValues_Set_Input>;
  where: UserRuleValues_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_UserRuleValues_By_PkArgs = {
  _append: InputMaybe<UserRuleValues_Append_Input>;
  _delete_at_path: InputMaybe<UserRuleValues_Delete_At_Path_Input>;
  _delete_elem: InputMaybe<UserRuleValues_Delete_Elem_Input>;
  _delete_key: InputMaybe<UserRuleValues_Delete_Key_Input>;
  _prepend: InputMaybe<UserRuleValues_Prepend_Input>;
  _set: InputMaybe<UserRuleValues_Set_Input>;
  pk_columns: UserRuleValues_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_UsersArgs = {
  _append: InputMaybe<Users_Append_Input>;
  _delete_at_path: InputMaybe<Users_Delete_At_Path_Input>;
  _delete_elem: InputMaybe<Users_Delete_Elem_Input>;
  _delete_key: InputMaybe<Users_Delete_Key_Input>;
  _prepend: InputMaybe<Users_Prepend_Input>;
  _set: InputMaybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Users_By_PkArgs = {
  _append: InputMaybe<Users_Append_Input>;
  _delete_at_path: InputMaybe<Users_Delete_At_Path_Input>;
  _delete_elem: InputMaybe<Users_Delete_Elem_Input>;
  _delete_key: InputMaybe<Users_Delete_Key_Input>;
  _prepend: InputMaybe<Users_Prepend_Input>;
  _set: InputMaybe<Users_Set_Input>;
  pk_columns: Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_VideosArgs = {
  _set: InputMaybe<Videos_Set_Input>;
  where: Videos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Videos_By_PkArgs = {
  _set: InputMaybe<Videos_Set_Input>;
  pk_columns: Videos_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpsert_UserAndUserData_OneArgs = {
  email: Scalars['String'];
  userData: UserAndUserData_Upsert_Input;
};

/** columns and relationships of "myProducts" */
export type MyProducts = {
  __typename?: 'myProducts';
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  privateInfo: Maybe<Scalars['jsonb']>;
  publicInfo: Maybe<Scalars['jsonb']>;
  userId: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "myProducts" */
export type MyProductsPrivateInfoArgs = {
  path: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "myProducts" */
export type MyProductsPublicInfoArgs = {
  path: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "myProducts" */
export type MyProducts_Aggregate = {
  __typename?: 'myProducts_aggregate';
  aggregate: Maybe<MyProducts_Aggregate_Fields>;
  nodes: Array<MyProducts>;
};

/** aggregate fields of "myProducts" */
export type MyProducts_Aggregate_Fields = {
  __typename?: 'myProducts_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<MyProducts_Max_Fields>;
  min: Maybe<MyProducts_Min_Fields>;
};


/** aggregate fields of "myProducts" */
export type MyProducts_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<MyProducts_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "myProducts". All fields are combined with a logical 'AND'. */
export type MyProducts_Bool_Exp = {
  _and?: InputMaybe<Array<MyProducts_Bool_Exp>>;
  _not?: InputMaybe<MyProducts_Bool_Exp>;
  _or?: InputMaybe<Array<MyProducts_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  privateInfo?: InputMaybe<Jsonb_Comparison_Exp>;
  publicInfo?: InputMaybe<Jsonb_Comparison_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type MyProducts_Max_Fields = {
  __typename?: 'myProducts_max_fields';
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  userId: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type MyProducts_Min_Fields = {
  __typename?: 'myProducts_min_fields';
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  userId: Maybe<Scalars['uuid']>;
};

/** Ordering options when selecting data from "myProducts". */
export type MyProducts_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  privateInfo?: InputMaybe<Order_By>;
  publicInfo?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** select columns of table "myProducts" */
export enum MyProducts_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PrivateInfo = 'privateInfo',
  /** column name */
  PublicInfo = 'publicInfo',
  /** column name */
  UserId = 'userId'
}

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']>;
  _gt?: InputMaybe<Scalars['numeric']>;
  _gte?: InputMaybe<Scalars['numeric']>;
  _in?: InputMaybe<Array<Scalars['numeric']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['numeric']>;
  _lte?: InputMaybe<Scalars['numeric']>;
  _neq?: InputMaybe<Scalars['numeric']>;
  _nin?: InputMaybe<Array<Scalars['numeric']>>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "orders" */
export type Orders = {
  __typename?: 'orders';
  addressJson: Maybe<Scalars['jsonb']>;
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  exchange: Exchanges;
  id: Scalars['uuid'];
  metadata: Maybe<Scalars['jsonb']>;
  paypalJson: Scalars['jsonb'];
  /** An object relationship */
  product: Products;
  productId: Scalars['uuid'];
  storeExchangeId: Scalars['uuid'];
  storeName: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  userDatum: UserData;
  userId: Scalars['uuid'];
};


/** columns and relationships of "orders" */
export type OrdersAddressJsonArgs = {
  path: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "orders" */
export type OrdersMetadataArgs = {
  path: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "orders" */
export type OrdersPaypalJsonArgs = {
  path: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "orders" */
export type Orders_Aggregate = {
  __typename?: 'orders_aggregate';
  aggregate: Maybe<Orders_Aggregate_Fields>;
  nodes: Array<Orders>;
};

/** aggregate fields of "orders" */
export type Orders_Aggregate_Fields = {
  __typename?: 'orders_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Orders_Max_Fields>;
  min: Maybe<Orders_Min_Fields>;
};


/** aggregate fields of "orders" */
export type Orders_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Orders_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "orders" */
export type Orders_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Orders_Max_Order_By>;
  min?: InputMaybe<Orders_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Orders_Append_Input = {
  addressJson?: InputMaybe<Scalars['jsonb']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  paypalJson?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "orders" */
export type Orders_Arr_Rel_Insert_Input = {
  data: Array<Orders_Insert_Input>;
  /** on conflict condition */
  on_conflict?: InputMaybe<Orders_On_Conflict>;
};

/** Boolean expression to filter rows from the table "orders". All fields are combined with a logical 'AND'. */
export type Orders_Bool_Exp = {
  _and?: InputMaybe<Array<Orders_Bool_Exp>>;
  _not?: InputMaybe<Orders_Bool_Exp>;
  _or?: InputMaybe<Array<Orders_Bool_Exp>>;
  addressJson?: InputMaybe<Jsonb_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  exchange?: InputMaybe<Exchanges_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  paypalJson?: InputMaybe<Jsonb_Comparison_Exp>;
  product?: InputMaybe<Products_Bool_Exp>;
  productId?: InputMaybe<Uuid_Comparison_Exp>;
  storeExchangeId?: InputMaybe<Uuid_Comparison_Exp>;
  storeName?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userDatum?: InputMaybe<UserData_Bool_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "orders" */
export enum Orders_Constraint {
  /** unique or primary key constraint */
  OrdersPkey = 'orders_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Orders_Delete_At_Path_Input = {
  addressJson?: InputMaybe<Array<Scalars['String']>>;
  metadata?: InputMaybe<Array<Scalars['String']>>;
  paypalJson?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Orders_Delete_Elem_Input = {
  addressJson?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['Int']>;
  paypalJson?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Orders_Delete_Key_Input = {
  addressJson?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['String']>;
  paypalJson?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "orders" */
export type Orders_Insert_Input = {
  addressJson?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  exchange?: InputMaybe<Exchanges_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  paypalJson?: InputMaybe<Scalars['jsonb']>;
  product?: InputMaybe<Products_Obj_Rel_Insert_Input>;
  productId?: InputMaybe<Scalars['uuid']>;
  storeExchangeId?: InputMaybe<Scalars['uuid']>;
  storeName?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userDatum?: InputMaybe<UserData_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Orders_Max_Fields = {
  __typename?: 'orders_max_fields';
  createdAt: Maybe<Scalars['timestamptz']>;
  id: Maybe<Scalars['uuid']>;
  productId: Maybe<Scalars['uuid']>;
  storeExchangeId: Maybe<Scalars['uuid']>;
  storeName: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
  userId: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "orders" */
export type Orders_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  productId?: InputMaybe<Order_By>;
  storeExchangeId?: InputMaybe<Order_By>;
  storeName?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Orders_Min_Fields = {
  __typename?: 'orders_min_fields';
  createdAt: Maybe<Scalars['timestamptz']>;
  id: Maybe<Scalars['uuid']>;
  productId: Maybe<Scalars['uuid']>;
  storeExchangeId: Maybe<Scalars['uuid']>;
  storeName: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
  userId: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "orders" */
export type Orders_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  productId?: InputMaybe<Order_By>;
  storeExchangeId?: InputMaybe<Order_By>;
  storeName?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "orders" */
export type Orders_Mutation_Response = {
  __typename?: 'orders_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Orders>;
};

/** on conflict condition type for table "orders" */
export type Orders_On_Conflict = {
  constraint: Orders_Constraint;
  update_columns: Array<Orders_Update_Column>;
  where?: InputMaybe<Orders_Bool_Exp>;
};

/** Ordering options when selecting data from "orders". */
export type Orders_Order_By = {
  addressJson?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  exchange?: InputMaybe<Exchanges_Order_By>;
  id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  paypalJson?: InputMaybe<Order_By>;
  product?: InputMaybe<Products_Order_By>;
  productId?: InputMaybe<Order_By>;
  storeExchangeId?: InputMaybe<Order_By>;
  storeName?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userDatum?: InputMaybe<UserData_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: orders */
export type Orders_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Orders_Prepend_Input = {
  addressJson?: InputMaybe<Scalars['jsonb']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  paypalJson?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "orders" */
export enum Orders_Select_Column {
  /** column name */
  AddressJson = 'addressJson',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  PaypalJson = 'paypalJson',
  /** column name */
  ProductId = 'productId',
  /** column name */
  StoreExchangeId = 'storeExchangeId',
  /** column name */
  StoreName = 'storeName',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "orders" */
export type Orders_Set_Input = {
  addressJson?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  paypalJson?: InputMaybe<Scalars['jsonb']>;
  productId?: InputMaybe<Scalars['uuid']>;
  storeExchangeId?: InputMaybe<Scalars['uuid']>;
  storeName?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "orders" */
export enum Orders_Update_Column {
  /** column name */
  AddressJson = 'addressJson',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  PaypalJson = 'paypalJson',
  /** column name */
  ProductId = 'productId',
  /** column name */
  StoreExchangeId = 'storeExchangeId',
  /** column name */
  StoreName = 'storeName',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** columns and relationships of "payments" */
export type Payments = {
  __typename?: 'payments';
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  orderedAt: Scalars['timestamptz'];
  originatingSystemData: Scalars['jsonb'];
  price: Scalars['numeric'];
  quantity: Scalars['Int'];
  shipping: Scalars['numeric'];
  source: Scalars['String'];
  subtotal: Scalars['numeric'];
  tax: Scalars['numeric'];
  total: Scalars['numeric'];
  transactionId: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
  userRoleRequestId: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "payments" */
export type PaymentsOriginatingSystemDataArgs = {
  path: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "payments" */
export type Payments_Aggregate = {
  __typename?: 'payments_aggregate';
  aggregate: Maybe<Payments_Aggregate_Fields>;
  nodes: Array<Payments>;
};

/** aggregate fields of "payments" */
export type Payments_Aggregate_Fields = {
  __typename?: 'payments_aggregate_fields';
  avg: Maybe<Payments_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Payments_Max_Fields>;
  min: Maybe<Payments_Min_Fields>;
  stddev: Maybe<Payments_Stddev_Fields>;
  stddev_pop: Maybe<Payments_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Payments_Stddev_Samp_Fields>;
  sum: Maybe<Payments_Sum_Fields>;
  var_pop: Maybe<Payments_Var_Pop_Fields>;
  var_samp: Maybe<Payments_Var_Samp_Fields>;
  variance: Maybe<Payments_Variance_Fields>;
};


/** aggregate fields of "payments" */
export type Payments_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Payments_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "payments" */
export type Payments_Aggregate_Order_By = {
  avg?: InputMaybe<Payments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Payments_Max_Order_By>;
  min?: InputMaybe<Payments_Min_Order_By>;
  stddev?: InputMaybe<Payments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Payments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Payments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Payments_Sum_Order_By>;
  var_pop?: InputMaybe<Payments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Payments_Var_Samp_Order_By>;
  variance?: InputMaybe<Payments_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Payments_Append_Input = {
  originatingSystemData?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "payments" */
export type Payments_Arr_Rel_Insert_Input = {
  data: Array<Payments_Insert_Input>;
  /** on conflict condition */
  on_conflict?: InputMaybe<Payments_On_Conflict>;
};

/** aggregate avg on columns */
export type Payments_Avg_Fields = {
  __typename?: 'payments_avg_fields';
  price: Maybe<Scalars['Float']>;
  quantity: Maybe<Scalars['Float']>;
  shipping: Maybe<Scalars['Float']>;
  subtotal: Maybe<Scalars['Float']>;
  tax: Maybe<Scalars['Float']>;
  total: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "payments" */
export type Payments_Avg_Order_By = {
  price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  shipping?: InputMaybe<Order_By>;
  subtotal?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "payments". All fields are combined with a logical 'AND'. */
export type Payments_Bool_Exp = {
  _and?: InputMaybe<Array<Payments_Bool_Exp>>;
  _not?: InputMaybe<Payments_Bool_Exp>;
  _or?: InputMaybe<Array<Payments_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  orderedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  originatingSystemData?: InputMaybe<Jsonb_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  quantity?: InputMaybe<Int_Comparison_Exp>;
  shipping?: InputMaybe<Numeric_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  subtotal?: InputMaybe<Numeric_Comparison_Exp>;
  tax?: InputMaybe<Numeric_Comparison_Exp>;
  total?: InputMaybe<Numeric_Comparison_Exp>;
  transactionId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
  userRoleRequestId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "payments" */
export enum Payments_Constraint {
  /** unique or primary key constraint */
  PaymentsPkey = 'payments_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Payments_Delete_At_Path_Input = {
  originatingSystemData?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Payments_Delete_Elem_Input = {
  originatingSystemData?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Payments_Delete_Key_Input = {
  originatingSystemData?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "payments" */
export type Payments_Inc_Input = {
  price?: InputMaybe<Scalars['numeric']>;
  quantity?: InputMaybe<Scalars['Int']>;
  shipping?: InputMaybe<Scalars['numeric']>;
  subtotal?: InputMaybe<Scalars['numeric']>;
  tax?: InputMaybe<Scalars['numeric']>;
  total?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "payments" */
export type Payments_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  orderedAt?: InputMaybe<Scalars['timestamptz']>;
  originatingSystemData?: InputMaybe<Scalars['jsonb']>;
  price?: InputMaybe<Scalars['numeric']>;
  quantity?: InputMaybe<Scalars['Int']>;
  shipping?: InputMaybe<Scalars['numeric']>;
  source?: InputMaybe<Scalars['String']>;
  subtotal?: InputMaybe<Scalars['numeric']>;
  tax?: InputMaybe<Scalars['numeric']>;
  total?: InputMaybe<Scalars['numeric']>;
  transactionId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['uuid']>;
  userRoleRequestId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Payments_Max_Fields = {
  __typename?: 'payments_max_fields';
  createdAt: Maybe<Scalars['timestamptz']>;
  id: Maybe<Scalars['uuid']>;
  orderedAt: Maybe<Scalars['timestamptz']>;
  price: Maybe<Scalars['numeric']>;
  quantity: Maybe<Scalars['Int']>;
  shipping: Maybe<Scalars['numeric']>;
  source: Maybe<Scalars['String']>;
  subtotal: Maybe<Scalars['numeric']>;
  tax: Maybe<Scalars['numeric']>;
  total: Maybe<Scalars['numeric']>;
  transactionId: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
  userId: Maybe<Scalars['uuid']>;
  userRoleRequestId: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "payments" */
export type Payments_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderedAt?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  shipping?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  subtotal?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
  transactionId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  userRoleRequestId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Payments_Min_Fields = {
  __typename?: 'payments_min_fields';
  createdAt: Maybe<Scalars['timestamptz']>;
  id: Maybe<Scalars['uuid']>;
  orderedAt: Maybe<Scalars['timestamptz']>;
  price: Maybe<Scalars['numeric']>;
  quantity: Maybe<Scalars['Int']>;
  shipping: Maybe<Scalars['numeric']>;
  source: Maybe<Scalars['String']>;
  subtotal: Maybe<Scalars['numeric']>;
  tax: Maybe<Scalars['numeric']>;
  total: Maybe<Scalars['numeric']>;
  transactionId: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
  userId: Maybe<Scalars['uuid']>;
  userRoleRequestId: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "payments" */
export type Payments_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderedAt?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  shipping?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  subtotal?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
  transactionId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  userRoleRequestId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "payments" */
export type Payments_Mutation_Response = {
  __typename?: 'payments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Payments>;
};

/** on conflict condition type for table "payments" */
export type Payments_On_Conflict = {
  constraint: Payments_Constraint;
  update_columns: Array<Payments_Update_Column>;
  where?: InputMaybe<Payments_Bool_Exp>;
};

/** Ordering options when selecting data from "payments". */
export type Payments_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderedAt?: InputMaybe<Order_By>;
  originatingSystemData?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  shipping?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  subtotal?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
  transactionId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
  userRoleRequestId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: payments */
export type Payments_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Payments_Prepend_Input = {
  originatingSystemData?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "payments" */
export enum Payments_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  OrderedAt = 'orderedAt',
  /** column name */
  OriginatingSystemData = 'originatingSystemData',
  /** column name */
  Price = 'price',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  Shipping = 'shipping',
  /** column name */
  Source = 'source',
  /** column name */
  Subtotal = 'subtotal',
  /** column name */
  Tax = 'tax',
  /** column name */
  Total = 'total',
  /** column name */
  TransactionId = 'transactionId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId',
  /** column name */
  UserRoleRequestId = 'userRoleRequestId'
}

/** input type for updating data in table "payments" */
export type Payments_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  orderedAt?: InputMaybe<Scalars['timestamptz']>;
  originatingSystemData?: InputMaybe<Scalars['jsonb']>;
  price?: InputMaybe<Scalars['numeric']>;
  quantity?: InputMaybe<Scalars['Int']>;
  shipping?: InputMaybe<Scalars['numeric']>;
  source?: InputMaybe<Scalars['String']>;
  subtotal?: InputMaybe<Scalars['numeric']>;
  tax?: InputMaybe<Scalars['numeric']>;
  total?: InputMaybe<Scalars['numeric']>;
  transactionId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
  userRoleRequestId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Payments_Stddev_Fields = {
  __typename?: 'payments_stddev_fields';
  price: Maybe<Scalars['Float']>;
  quantity: Maybe<Scalars['Float']>;
  shipping: Maybe<Scalars['Float']>;
  subtotal: Maybe<Scalars['Float']>;
  tax: Maybe<Scalars['Float']>;
  total: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "payments" */
export type Payments_Stddev_Order_By = {
  price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  shipping?: InputMaybe<Order_By>;
  subtotal?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Payments_Stddev_Pop_Fields = {
  __typename?: 'payments_stddev_pop_fields';
  price: Maybe<Scalars['Float']>;
  quantity: Maybe<Scalars['Float']>;
  shipping: Maybe<Scalars['Float']>;
  subtotal: Maybe<Scalars['Float']>;
  tax: Maybe<Scalars['Float']>;
  total: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "payments" */
export type Payments_Stddev_Pop_Order_By = {
  price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  shipping?: InputMaybe<Order_By>;
  subtotal?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Payments_Stddev_Samp_Fields = {
  __typename?: 'payments_stddev_samp_fields';
  price: Maybe<Scalars['Float']>;
  quantity: Maybe<Scalars['Float']>;
  shipping: Maybe<Scalars['Float']>;
  subtotal: Maybe<Scalars['Float']>;
  tax: Maybe<Scalars['Float']>;
  total: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "payments" */
export type Payments_Stddev_Samp_Order_By = {
  price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  shipping?: InputMaybe<Order_By>;
  subtotal?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Payments_Sum_Fields = {
  __typename?: 'payments_sum_fields';
  price: Maybe<Scalars['numeric']>;
  quantity: Maybe<Scalars['Int']>;
  shipping: Maybe<Scalars['numeric']>;
  subtotal: Maybe<Scalars['numeric']>;
  tax: Maybe<Scalars['numeric']>;
  total: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "payments" */
export type Payments_Sum_Order_By = {
  price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  shipping?: InputMaybe<Order_By>;
  subtotal?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** update columns of table "payments" */
export enum Payments_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  OrderedAt = 'orderedAt',
  /** column name */
  OriginatingSystemData = 'originatingSystemData',
  /** column name */
  Price = 'price',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  Shipping = 'shipping',
  /** column name */
  Source = 'source',
  /** column name */
  Subtotal = 'subtotal',
  /** column name */
  Tax = 'tax',
  /** column name */
  Total = 'total',
  /** column name */
  TransactionId = 'transactionId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId',
  /** column name */
  UserRoleRequestId = 'userRoleRequestId'
}

/** aggregate var_pop on columns */
export type Payments_Var_Pop_Fields = {
  __typename?: 'payments_var_pop_fields';
  price: Maybe<Scalars['Float']>;
  quantity: Maybe<Scalars['Float']>;
  shipping: Maybe<Scalars['Float']>;
  subtotal: Maybe<Scalars['Float']>;
  tax: Maybe<Scalars['Float']>;
  total: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "payments" */
export type Payments_Var_Pop_Order_By = {
  price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  shipping?: InputMaybe<Order_By>;
  subtotal?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Payments_Var_Samp_Fields = {
  __typename?: 'payments_var_samp_fields';
  price: Maybe<Scalars['Float']>;
  quantity: Maybe<Scalars['Float']>;
  shipping: Maybe<Scalars['Float']>;
  subtotal: Maybe<Scalars['Float']>;
  tax: Maybe<Scalars['Float']>;
  total: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "payments" */
export type Payments_Var_Samp_Order_By = {
  price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  shipping?: InputMaybe<Order_By>;
  subtotal?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Payments_Variance_Fields = {
  __typename?: 'payments_variance_fields';
  price: Maybe<Scalars['Float']>;
  quantity: Maybe<Scalars['Float']>;
  shipping: Maybe<Scalars['Float']>;
  subtotal: Maybe<Scalars['Float']>;
  tax: Maybe<Scalars['Float']>;
  total: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "payments" */
export type Payments_Variance_Order_By = {
  price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  shipping?: InputMaybe<Order_By>;
  subtotal?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "point". All fields are combined with logical 'AND'. */
export type Point_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['point']>;
  _gt?: InputMaybe<Scalars['point']>;
  _gte?: InputMaybe<Scalars['point']>;
  _in?: InputMaybe<Array<Scalars['point']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['point']>;
  _lte?: InputMaybe<Scalars['point']>;
  _neq?: InputMaybe<Scalars['point']>;
  _nin?: InputMaybe<Array<Scalars['point']>>;
};

/** columns and relationships of "products" */
export type Products = {
  __typename?: 'products';
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An array relationship */
  orders: Array<Orders>;
  /** An aggregate relationship */
  orders_aggregate: Orders_Aggregate;
  privateInfo: Maybe<Scalars['jsonb']>;
  publicInfo: Maybe<Scalars['jsonb']>;
};


/** columns and relationships of "products" */
export type ProductsOrdersArgs = {
  distinct_on: InputMaybe<Array<Orders_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Orders_Order_By>>;
  where: InputMaybe<Orders_Bool_Exp>;
};


/** columns and relationships of "products" */
export type ProductsOrders_AggregateArgs = {
  distinct_on: InputMaybe<Array<Orders_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Orders_Order_By>>;
  where: InputMaybe<Orders_Bool_Exp>;
};


/** columns and relationships of "products" */
export type ProductsPrivateInfoArgs = {
  path: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "products" */
export type ProductsPublicInfoArgs = {
  path: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "products" */
export type Products_Aggregate = {
  __typename?: 'products_aggregate';
  aggregate: Maybe<Products_Aggregate_Fields>;
  nodes: Array<Products>;
};

/** aggregate fields of "products" */
export type Products_Aggregate_Fields = {
  __typename?: 'products_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Products_Max_Fields>;
  min: Maybe<Products_Min_Fields>;
};


/** aggregate fields of "products" */
export type Products_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Products_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Products_Append_Input = {
  privateInfo?: InputMaybe<Scalars['jsonb']>;
  publicInfo?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "products". All fields are combined with a logical 'AND'. */
export type Products_Bool_Exp = {
  _and?: InputMaybe<Array<Products_Bool_Exp>>;
  _not?: InputMaybe<Products_Bool_Exp>;
  _or?: InputMaybe<Array<Products_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  orders?: InputMaybe<Orders_Bool_Exp>;
  privateInfo?: InputMaybe<Jsonb_Comparison_Exp>;
  publicInfo?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "products" */
export enum Products_Constraint {
  /** unique or primary key constraint */
  ProductsPkey = 'products_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Products_Delete_At_Path_Input = {
  privateInfo?: InputMaybe<Array<Scalars['String']>>;
  publicInfo?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Products_Delete_Elem_Input = {
  privateInfo?: InputMaybe<Scalars['Int']>;
  publicInfo?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Products_Delete_Key_Input = {
  privateInfo?: InputMaybe<Scalars['String']>;
  publicInfo?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "products" */
export type Products_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  orders?: InputMaybe<Orders_Arr_Rel_Insert_Input>;
  privateInfo?: InputMaybe<Scalars['jsonb']>;
  publicInfo?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type Products_Max_Fields = {
  __typename?: 'products_max_fields';
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Products_Min_Fields = {
  __typename?: 'products_min_fields';
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "products" */
export type Products_Mutation_Response = {
  __typename?: 'products_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Products>;
};

/** input type for inserting object relation for remote table "products" */
export type Products_Obj_Rel_Insert_Input = {
  data: Products_Insert_Input;
  /** on conflict condition */
  on_conflict?: InputMaybe<Products_On_Conflict>;
};

/** on conflict condition type for table "products" */
export type Products_On_Conflict = {
  constraint: Products_Constraint;
  update_columns: Array<Products_Update_Column>;
  where?: InputMaybe<Products_Bool_Exp>;
};

/** Ordering options when selecting data from "products". */
export type Products_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  orders_aggregate?: InputMaybe<Orders_Aggregate_Order_By>;
  privateInfo?: InputMaybe<Order_By>;
  publicInfo?: InputMaybe<Order_By>;
};

/** primary key columns input for table: products */
export type Products_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Products_Prepend_Input = {
  privateInfo?: InputMaybe<Scalars['jsonb']>;
  publicInfo?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "products" */
export enum Products_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PrivateInfo = 'privateInfo',
  /** column name */
  PublicInfo = 'publicInfo'
}

/** input type for updating data in table "products" */
export type Products_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  privateInfo?: InputMaybe<Scalars['jsonb']>;
  publicInfo?: InputMaybe<Scalars['jsonb']>;
};

/** update columns of table "products" */
export enum Products_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PrivateInfo = 'privateInfo',
  /** column name */
  PublicInfo = 'publicInfo'
}

export type Query_Root = {
  __typename?: 'query_root';
  affiliateMetrics: Maybe<AffiliateMetrics>;
  /** An array relationship */
  apiKeys: Array<ApiKeys>;
  /** An aggregate relationship */
  apiKeys_aggregate: ApiKeys_Aggregate;
  /** fetch data from the table: "apiKeys" using primary key columns */
  apiKeys_by_pk: Maybe<ApiKeys>;
  /** fetch data from the table: "callToActionConfigs" */
  callToActionConfigs: Array<CallToActionConfigs>;
  /** fetch aggregated fields from the table: "callToActionConfigs" */
  callToActionConfigs_aggregate: CallToActionConfigs_Aggregate;
  /** fetch data from the table: "callToActionConfigs" using primary key columns */
  callToActionConfigs_by_pk: Maybe<CallToActionConfigs>;
  /** fetch data from the table: "callToActionFields" */
  callToActionFields: Array<CallToActionFields>;
  /** fetch aggregated fields from the table: "callToActionFields" */
  callToActionFields_aggregate: CallToActionFields_Aggregate;
  /** fetch data from the table: "callToActionFields" using primary key columns */
  callToActionFields_by_pk: Maybe<CallToActionFields>;
  /** fetch data from the table: "callToActionGlobalSettings" */
  callToActionGlobalSettings: Array<CallToActionGlobalSettings>;
  /** fetch aggregated fields from the table: "callToActionGlobalSettings" */
  callToActionGlobalSettings_aggregate: CallToActionGlobalSettings_Aggregate;
  /** fetch data from the table: "callToActionGlobalSettings" using primary key columns */
  callToActionGlobalSettings_by_pk: Maybe<CallToActionGlobalSettings>;
  /** An array relationship */
  devicePublicIps: Array<DevicePublicIps>;
  /** An aggregate relationship */
  devicePublicIps_aggregate: DevicePublicIps_Aggregate;
  /** fetch data from the table: "devicePublicIps" using primary key columns */
  devicePublicIps_by_pk: Maybe<DevicePublicIps>;
  /** An array relationship */
  devices: Array<Devices>;
  /** An aggregate relationship */
  devices_aggregate: Devices_Aggregate;
  /** fetch data from the table: "devices" using primary key columns */
  devices_by_pk: Maybe<Devices>;
  /** fetch data from the table: "digitalProducts" */
  digitalProducts: Array<DigitalProducts>;
  /** fetch aggregated fields from the table: "digitalProducts" */
  digitalProducts_aggregate: DigitalProducts_Aggregate;
  /** fetch data from the table: "digitalProducts" using primary key columns */
  digitalProducts_by_pk: Maybe<DigitalProducts>;
  /** An array relationship */
  documents: Array<Documents>;
  /** An aggregate relationship */
  documents_aggregate: Documents_Aggregate;
  /** fetch data from the table: "documents" using primary key columns */
  documents_by_pk: Maybe<Documents>;
  /** fetch data from the table: "exchangeContent" */
  exchangeContent: Array<ExchangeContent>;
  /** fetch aggregated fields from the table: "exchangeContent" */
  exchangeContent_aggregate: ExchangeContent_Aggregate;
  /** fetch data from the table: "exchangeContent" using primary key columns */
  exchangeContent_by_pk: Maybe<ExchangeContent>;
  /** fetch data from the table: "exchanges" */
  exchanges: Array<Exchanges>;
  /** fetch aggregated fields from the table: "exchanges" */
  exchanges_aggregate: Exchanges_Aggregate;
  /** fetch data from the table: "exchanges" using primary key columns */
  exchanges_by_pk: Maybe<Exchanges>;
  /** fetch data from the table: "files" */
  files: Array<Files>;
  /** fetch aggregated fields from the table: "files" */
  files_aggregate: Files_Aggregate;
  /** fetch data from the table: "files" using primary key columns */
  files_by_pk: Maybe<Files>;
  getDigitalProductForCustomerOrder: Maybe<GetDigitalProductForCustomerOrderOutput>;
  getMagentoToken: Maybe<MagentoToken>;
  hubspotBlog: Maybe<Array<Maybe<HubspotBlogOutput>>>;
  /** fetch data from the table: "hubspotSyncJob" */
  hubspotSyncJob: Array<HubspotSyncJob>;
  /** fetch aggregated fields from the table: "hubspotSyncJob" */
  hubspotSyncJob_aggregate: HubspotSyncJob_Aggregate;
  /** fetch data from the table: "hubspotSyncJob" using primary key columns */
  hubspotSyncJob_by_pk: Maybe<HubspotSyncJob>;
  /** fetch data from the table: "languages" */
  languages: Array<Languages>;
  /** fetch aggregated fields from the table: "languages" */
  languages_aggregate: Languages_Aggregate;
  /** fetch data from the table: "languages" using primary key columns */
  languages_by_pk: Maybe<Languages>;
  /** fetch data from the table: "leadLocks" */
  leadLocks: Array<LeadLocks>;
  /** fetch aggregated fields from the table: "leadLocks" */
  leadLocks_aggregate: LeadLocks_Aggregate;
  /** fetch data from the table: "leadLocks" using primary key columns */
  leadLocks_by_pk: Maybe<LeadLocks>;
  /** fetch data from the table: "leadsHistory" */
  leadsHistory: Array<LeadsHistory>;
  /** fetch aggregated fields from the table: "leadsHistory" */
  leadsHistory_aggregate: LeadsHistory_Aggregate;
  /** fetch data from the table: "leadsHistory" using primary key columns */
  leadsHistory_by_pk: Maybe<LeadsHistory>;
  /** fetch data from the table: "lineage" */
  lineage: Array<Lineage>;
  /** fetch aggregated fields from the table: "lineage" */
  lineage_aggregate: Lineage_Aggregate;
  /** An array relationship */
  logTraces: Array<LogTraces>;
  /** An aggregate relationship */
  logTraces_aggregate: LogTraces_Aggregate;
  /** An array relationship */
  logs: Array<Logs>;
  /** An aggregate relationship */
  logs_aggregate: Logs_Aggregate;
  /** fetch data from the table: "logs" using primary key columns */
  logs_by_pk: Maybe<Logs>;
  magentoOrders: Maybe<MagentoOrdersOutput>;
  /** fetch data from the table: "myProducts" */
  myProducts: Array<MyProducts>;
  /** fetch aggregated fields from the table: "myProducts" */
  myProducts_aggregate: MyProducts_Aggregate;
  /** An array relationship */
  orders: Array<Orders>;
  /** An aggregate relationship */
  orders_aggregate: Orders_Aggregate;
  /** fetch data from the table: "orders" using primary key columns */
  orders_by_pk: Maybe<Orders>;
  /** An array relationship */
  payments: Array<Payments>;
  /** An aggregate relationship */
  payments_aggregate: Payments_Aggregate;
  /** fetch data from the table: "payments" using primary key columns */
  payments_by_pk: Maybe<Payments>;
  /** fetch data from the table: "products" */
  products: Array<Products>;
  /** fetch aggregated fields from the table: "products" */
  products_aggregate: Products_Aggregate;
  /** fetch data from the table: "products" using primary key columns */
  products_by_pk: Maybe<Products>;
  /** fetch data from the table: "roles" */
  roles: Array<Roles>;
  /** fetch aggregated fields from the table: "roles" */
  roles_aggregate: Roles_Aggregate;
  /** fetch data from the table: "roles" using primary key columns */
  roles_by_pk: Maybe<Roles>;
  /** An array relationship */
  rules: Array<Rules>;
  /** An aggregate relationship */
  rules_aggregate: Rules_Aggregate;
  /** fetch data from the table: "rules" using primary key columns */
  rules_by_pk: Maybe<Rules>;
  /** fetch data from the table: "settings" */
  settings: Array<Settings>;
  /** fetch aggregated fields from the table: "settings" */
  settings_aggregate: Settings_Aggregate;
  /** fetch data from the table: "settings" using primary key columns */
  settings_by_pk: Maybe<Settings>;
  /** fetch data from the table: "trackingEvents" */
  trackingEvents: Array<TrackingEvents>;
  /** fetch aggregated fields from the table: "trackingEvents" */
  trackingEvents_aggregate: TrackingEvents_Aggregate;
  /** fetch data from the table: "trackingEvents" using primary key columns */
  trackingEvents_by_pk: Maybe<TrackingEvents>;
  unsignedDocuments: Array<UnsignedDocuments>;
  /** An array relationship */
  userData: Array<UserData>;
  /** An aggregate relationship */
  userData_aggregate: UserData_Aggregate;
  /** fetch data from the table: "userData" using primary key columns */
  userData_by_pk: Maybe<UserData>;
  /** An array relationship */
  userDocuments: Array<UserDocuments>;
  /** An aggregate relationship */
  userDocuments_aggregate: UserDocuments_Aggregate;
  /** fetch data from the table: "userDocuments" using primary key columns */
  userDocuments_by_pk: Maybe<UserDocuments>;
  /** fetch data from the table: "userIdTypes" */
  userIdTypes: Array<UserIdTypes>;
  /** fetch aggregated fields from the table: "userIdTypes" */
  userIdTypes_aggregate: UserIdTypes_Aggregate;
  /** fetch data from the table: "userIdTypes" using primary key columns */
  userIdTypes_by_pk: Maybe<UserIdTypes>;
  /** An array relationship */
  userIds: Array<UserIds>;
  /** An aggregate relationship */
  userIds_aggregate: UserIds_Aggregate;
  /** An array relationship */
  userRoleRequests: Array<UserRoleRequests>;
  /** An aggregate relationship */
  userRoleRequests_aggregate: UserRoleRequests_Aggregate;
  /** fetch data from the table: "userRoleRequests" using primary key columns */
  userRoleRequests_by_pk: Maybe<UserRoleRequests>;
  /** An array relationship */
  userRoles: Array<UserRoles>;
  /** fetch data from the table: "userRolesView" */
  userRolesView: Array<UserRolesView>;
  /** fetch aggregated fields from the table: "userRolesView" */
  userRolesView_aggregate: UserRolesView_Aggregate;
  /** An aggregate relationship */
  userRoles_aggregate: UserRoles_Aggregate;
  /** fetch data from the table: "userRoles" using primary key columns */
  userRoles_by_pk: Maybe<UserRoles>;
  /** An array relationship */
  userRuleValues: Array<UserRuleValues>;
  /** An aggregate relationship */
  userRuleValues_aggregate: UserRuleValues_Aggregate;
  /** fetch data from the table: "userRuleValues" using primary key columns */
  userRuleValues_by_pk: Maybe<UserRuleValues>;
  /** fetch data from the table: "userRules" */
  userRules: Array<UserRules>;
  /** fetch aggregated fields from the table: "userRules" */
  userRules_aggregate: UserRules_Aggregate;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk: Maybe<Users>;
  validateAddress: Maybe<AddressValidationOutput>;
  /** fetch data from the table: "videos" */
  videos: Array<Videos>;
  /** fetch aggregated fields from the table: "videos" */
  videos_aggregate: Videos_Aggregate;
  /** fetch data from the table: "videos" using primary key columns */
  videos_by_pk: Maybe<Videos>;
};


export type Query_RootAffiliateMetricsArgs = {
  profileId: Scalars['uuid'];
};


export type Query_RootApiKeysArgs = {
  distinct_on: InputMaybe<Array<ApiKeys_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<ApiKeys_Order_By>>;
  where: InputMaybe<ApiKeys_Bool_Exp>;
};


export type Query_RootApiKeys_AggregateArgs = {
  distinct_on: InputMaybe<Array<ApiKeys_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<ApiKeys_Order_By>>;
  where: InputMaybe<ApiKeys_Bool_Exp>;
};


export type Query_RootApiKeys_By_PkArgs = {
  key: Scalars['uuid'];
};


export type Query_RootCallToActionConfigsArgs = {
  distinct_on: InputMaybe<Array<CallToActionConfigs_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<CallToActionConfigs_Order_By>>;
  where: InputMaybe<CallToActionConfigs_Bool_Exp>;
};


export type Query_RootCallToActionConfigs_AggregateArgs = {
  distinct_on: InputMaybe<Array<CallToActionConfigs_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<CallToActionConfigs_Order_By>>;
  where: InputMaybe<CallToActionConfigs_Bool_Exp>;
};


export type Query_RootCallToActionConfigs_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCallToActionFieldsArgs = {
  distinct_on: InputMaybe<Array<CallToActionFields_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<CallToActionFields_Order_By>>;
  where: InputMaybe<CallToActionFields_Bool_Exp>;
};


export type Query_RootCallToActionFields_AggregateArgs = {
  distinct_on: InputMaybe<Array<CallToActionFields_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<CallToActionFields_Order_By>>;
  where: InputMaybe<CallToActionFields_Bool_Exp>;
};


export type Query_RootCallToActionFields_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCallToActionGlobalSettingsArgs = {
  distinct_on: InputMaybe<Array<CallToActionGlobalSettings_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<CallToActionGlobalSettings_Order_By>>;
  where: InputMaybe<CallToActionGlobalSettings_Bool_Exp>;
};


export type Query_RootCallToActionGlobalSettings_AggregateArgs = {
  distinct_on: InputMaybe<Array<CallToActionGlobalSettings_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<CallToActionGlobalSettings_Order_By>>;
  where: InputMaybe<CallToActionGlobalSettings_Bool_Exp>;
};


export type Query_RootCallToActionGlobalSettings_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootDevicePublicIpsArgs = {
  distinct_on: InputMaybe<Array<DevicePublicIps_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<DevicePublicIps_Order_By>>;
  where: InputMaybe<DevicePublicIps_Bool_Exp>;
};


export type Query_RootDevicePublicIps_AggregateArgs = {
  distinct_on: InputMaybe<Array<DevicePublicIps_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<DevicePublicIps_Order_By>>;
  where: InputMaybe<DevicePublicIps_Bool_Exp>;
};


export type Query_RootDevicePublicIps_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootDevicesArgs = {
  distinct_on: InputMaybe<Array<Devices_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Devices_Order_By>>;
  where: InputMaybe<Devices_Bool_Exp>;
};


export type Query_RootDevices_AggregateArgs = {
  distinct_on: InputMaybe<Array<Devices_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Devices_Order_By>>;
  where: InputMaybe<Devices_Bool_Exp>;
};


export type Query_RootDevices_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootDigitalProductsArgs = {
  distinct_on: InputMaybe<Array<DigitalProducts_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<DigitalProducts_Order_By>>;
  where: InputMaybe<DigitalProducts_Bool_Exp>;
};


export type Query_RootDigitalProducts_AggregateArgs = {
  distinct_on: InputMaybe<Array<DigitalProducts_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<DigitalProducts_Order_By>>;
  where: InputMaybe<DigitalProducts_Bool_Exp>;
};


export type Query_RootDigitalProducts_By_PkArgs = {
  sku: Scalars['String'];
};


export type Query_RootDocumentsArgs = {
  distinct_on: InputMaybe<Array<Documents_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Documents_Order_By>>;
  where: InputMaybe<Documents_Bool_Exp>;
};


export type Query_RootDocuments_AggregateArgs = {
  distinct_on: InputMaybe<Array<Documents_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Documents_Order_By>>;
  where: InputMaybe<Documents_Bool_Exp>;
};


export type Query_RootDocuments_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootExchangeContentArgs = {
  distinct_on: InputMaybe<Array<ExchangeContent_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<ExchangeContent_Order_By>>;
  where: InputMaybe<ExchangeContent_Bool_Exp>;
};


export type Query_RootExchangeContent_AggregateArgs = {
  distinct_on: InputMaybe<Array<ExchangeContent_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<ExchangeContent_Order_By>>;
  where: InputMaybe<ExchangeContent_Bool_Exp>;
};


export type Query_RootExchangeContent_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootExchangesArgs = {
  distinct_on: InputMaybe<Array<Exchanges_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Exchanges_Order_By>>;
  where: InputMaybe<Exchanges_Bool_Exp>;
};


export type Query_RootExchanges_AggregateArgs = {
  distinct_on: InputMaybe<Array<Exchanges_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Exchanges_Order_By>>;
  where: InputMaybe<Exchanges_Bool_Exp>;
};


export type Query_RootExchanges_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootFilesArgs = {
  distinct_on: InputMaybe<Array<Files_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Files_Order_By>>;
  where: InputMaybe<Files_Bool_Exp>;
};


export type Query_RootFiles_AggregateArgs = {
  distinct_on: InputMaybe<Array<Files_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Files_Order_By>>;
  where: InputMaybe<Files_Bool_Exp>;
};


export type Query_RootFiles_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootGetDigitalProductForCustomerOrderArgs = {
  orderNumber: Scalars['String'];
  productSku: Scalars['String'];
};


export type Query_RootHubspotBlogArgs = {
  limit: InputMaybe<Scalars['Int']>;
  tagId: InputMaybe<Scalars['String']>;
};


export type Query_RootHubspotSyncJobArgs = {
  distinct_on: InputMaybe<Array<HubspotSyncJob_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<HubspotSyncJob_Order_By>>;
  where: InputMaybe<HubspotSyncJob_Bool_Exp>;
};


export type Query_RootHubspotSyncJob_AggregateArgs = {
  distinct_on: InputMaybe<Array<HubspotSyncJob_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<HubspotSyncJob_Order_By>>;
  where: InputMaybe<HubspotSyncJob_Bool_Exp>;
};


export type Query_RootHubspotSyncJob_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootLanguagesArgs = {
  distinct_on: InputMaybe<Array<Languages_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Languages_Order_By>>;
  where: InputMaybe<Languages_Bool_Exp>;
};


export type Query_RootLanguages_AggregateArgs = {
  distinct_on: InputMaybe<Array<Languages_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Languages_Order_By>>;
  where: InputMaybe<Languages_Bool_Exp>;
};


export type Query_RootLanguages_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootLeadLocksArgs = {
  distinct_on: InputMaybe<Array<LeadLocks_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<LeadLocks_Order_By>>;
  where: InputMaybe<LeadLocks_Bool_Exp>;
};


export type Query_RootLeadLocks_AggregateArgs = {
  distinct_on: InputMaybe<Array<LeadLocks_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<LeadLocks_Order_By>>;
  where: InputMaybe<LeadLocks_Bool_Exp>;
};


export type Query_RootLeadLocks_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLeadsHistoryArgs = {
  distinct_on: InputMaybe<Array<LeadsHistory_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<LeadsHistory_Order_By>>;
  where: InputMaybe<LeadsHistory_Bool_Exp>;
};


export type Query_RootLeadsHistory_AggregateArgs = {
  distinct_on: InputMaybe<Array<LeadsHistory_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<LeadsHistory_Order_By>>;
  where: InputMaybe<LeadsHistory_Bool_Exp>;
};


export type Query_RootLeadsHistory_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLineageArgs = {
  distinct_on: InputMaybe<Array<Lineage_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Lineage_Order_By>>;
  where: InputMaybe<Lineage_Bool_Exp>;
};


export type Query_RootLineage_AggregateArgs = {
  distinct_on: InputMaybe<Array<Lineage_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Lineage_Order_By>>;
  where: InputMaybe<Lineage_Bool_Exp>;
};


export type Query_RootLogTracesArgs = {
  distinct_on: InputMaybe<Array<LogTraces_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<LogTraces_Order_By>>;
  where: InputMaybe<LogTraces_Bool_Exp>;
};


export type Query_RootLogTraces_AggregateArgs = {
  distinct_on: InputMaybe<Array<LogTraces_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<LogTraces_Order_By>>;
  where: InputMaybe<LogTraces_Bool_Exp>;
};


export type Query_RootLogsArgs = {
  distinct_on: InputMaybe<Array<Logs_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Logs_Order_By>>;
  where: InputMaybe<Logs_Bool_Exp>;
};


export type Query_RootLogs_AggregateArgs = {
  distinct_on: InputMaybe<Array<Logs_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Logs_Order_By>>;
  where: InputMaybe<Logs_Bool_Exp>;
};


export type Query_RootLogs_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootMyProductsArgs = {
  distinct_on: InputMaybe<Array<MyProducts_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<MyProducts_Order_By>>;
  where: InputMaybe<MyProducts_Bool_Exp>;
};


export type Query_RootMyProducts_AggregateArgs = {
  distinct_on: InputMaybe<Array<MyProducts_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<MyProducts_Order_By>>;
  where: InputMaybe<MyProducts_Bool_Exp>;
};


export type Query_RootOrdersArgs = {
  distinct_on: InputMaybe<Array<Orders_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Orders_Order_By>>;
  where: InputMaybe<Orders_Bool_Exp>;
};


export type Query_RootOrders_AggregateArgs = {
  distinct_on: InputMaybe<Array<Orders_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Orders_Order_By>>;
  where: InputMaybe<Orders_Bool_Exp>;
};


export type Query_RootOrders_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPaymentsArgs = {
  distinct_on: InputMaybe<Array<Payments_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Payments_Order_By>>;
  where: InputMaybe<Payments_Bool_Exp>;
};


export type Query_RootPayments_AggregateArgs = {
  distinct_on: InputMaybe<Array<Payments_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Payments_Order_By>>;
  where: InputMaybe<Payments_Bool_Exp>;
};


export type Query_RootPayments_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProductsArgs = {
  distinct_on: InputMaybe<Array<Products_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Products_Order_By>>;
  where: InputMaybe<Products_Bool_Exp>;
};


export type Query_RootProducts_AggregateArgs = {
  distinct_on: InputMaybe<Array<Products_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Products_Order_By>>;
  where: InputMaybe<Products_Bool_Exp>;
};


export type Query_RootProducts_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootRolesArgs = {
  distinct_on: InputMaybe<Array<Roles_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Roles_Order_By>>;
  where: InputMaybe<Roles_Bool_Exp>;
};


export type Query_RootRoles_AggregateArgs = {
  distinct_on: InputMaybe<Array<Roles_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Roles_Order_By>>;
  where: InputMaybe<Roles_Bool_Exp>;
};


export type Query_RootRoles_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootRulesArgs = {
  distinct_on: InputMaybe<Array<Rules_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Rules_Order_By>>;
  where: InputMaybe<Rules_Bool_Exp>;
};


export type Query_RootRules_AggregateArgs = {
  distinct_on: InputMaybe<Array<Rules_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Rules_Order_By>>;
  where: InputMaybe<Rules_Bool_Exp>;
};


export type Query_RootRules_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSettingsArgs = {
  distinct_on: InputMaybe<Array<Settings_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Settings_Order_By>>;
  where: InputMaybe<Settings_Bool_Exp>;
};


export type Query_RootSettings_AggregateArgs = {
  distinct_on: InputMaybe<Array<Settings_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Settings_Order_By>>;
  where: InputMaybe<Settings_Bool_Exp>;
};


export type Query_RootSettings_By_PkArgs = {
  key: Scalars['String'];
};


export type Query_RootTrackingEventsArgs = {
  distinct_on: InputMaybe<Array<TrackingEvents_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<TrackingEvents_Order_By>>;
  where: InputMaybe<TrackingEvents_Bool_Exp>;
};


export type Query_RootTrackingEvents_AggregateArgs = {
  distinct_on: InputMaybe<Array<TrackingEvents_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<TrackingEvents_Order_By>>;
  where: InputMaybe<TrackingEvents_Bool_Exp>;
};


export type Query_RootTrackingEvents_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUnsignedDocumentsArgs = {
  requiredOnly: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['uuid'];
};


export type Query_RootUserDataArgs = {
  distinct_on: InputMaybe<Array<UserData_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserData_Order_By>>;
  where: InputMaybe<UserData_Bool_Exp>;
};


export type Query_RootUserData_AggregateArgs = {
  distinct_on: InputMaybe<Array<UserData_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserData_Order_By>>;
  where: InputMaybe<UserData_Bool_Exp>;
};


export type Query_RootUserData_By_PkArgs = {
  profileId: Scalars['uuid'];
};


export type Query_RootUserDocumentsArgs = {
  distinct_on: InputMaybe<Array<UserDocuments_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserDocuments_Order_By>>;
  where: InputMaybe<UserDocuments_Bool_Exp>;
};


export type Query_RootUserDocuments_AggregateArgs = {
  distinct_on: InputMaybe<Array<UserDocuments_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserDocuments_Order_By>>;
  where: InputMaybe<UserDocuments_Bool_Exp>;
};


export type Query_RootUserDocuments_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserIdTypesArgs = {
  distinct_on: InputMaybe<Array<UserIdTypes_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserIdTypes_Order_By>>;
  where: InputMaybe<UserIdTypes_Bool_Exp>;
};


export type Query_RootUserIdTypes_AggregateArgs = {
  distinct_on: InputMaybe<Array<UserIdTypes_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserIdTypes_Order_By>>;
  where: InputMaybe<UserIdTypes_Bool_Exp>;
};


export type Query_RootUserIdTypes_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserIdsArgs = {
  distinct_on: InputMaybe<Array<UserIds_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserIds_Order_By>>;
  where: InputMaybe<UserIds_Bool_Exp>;
};


export type Query_RootUserIds_AggregateArgs = {
  distinct_on: InputMaybe<Array<UserIds_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserIds_Order_By>>;
  where: InputMaybe<UserIds_Bool_Exp>;
};


export type Query_RootUserRoleRequestsArgs = {
  distinct_on: InputMaybe<Array<UserRoleRequests_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserRoleRequests_Order_By>>;
  where: InputMaybe<UserRoleRequests_Bool_Exp>;
};


export type Query_RootUserRoleRequests_AggregateArgs = {
  distinct_on: InputMaybe<Array<UserRoleRequests_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserRoleRequests_Order_By>>;
  where: InputMaybe<UserRoleRequests_Bool_Exp>;
};


export type Query_RootUserRoleRequests_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserRolesArgs = {
  distinct_on: InputMaybe<Array<UserRoles_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserRoles_Order_By>>;
  where: InputMaybe<UserRoles_Bool_Exp>;
};


export type Query_RootUserRolesViewArgs = {
  distinct_on: InputMaybe<Array<UserRolesView_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserRolesView_Order_By>>;
  where: InputMaybe<UserRolesView_Bool_Exp>;
};


export type Query_RootUserRolesView_AggregateArgs = {
  distinct_on: InputMaybe<Array<UserRolesView_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserRolesView_Order_By>>;
  where: InputMaybe<UserRolesView_Bool_Exp>;
};


export type Query_RootUserRoles_AggregateArgs = {
  distinct_on: InputMaybe<Array<UserRoles_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserRoles_Order_By>>;
  where: InputMaybe<UserRoles_Bool_Exp>;
};


export type Query_RootUserRoles_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserRuleValuesArgs = {
  distinct_on: InputMaybe<Array<UserRuleValues_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserRuleValues_Order_By>>;
  where: InputMaybe<UserRuleValues_Bool_Exp>;
};


export type Query_RootUserRuleValues_AggregateArgs = {
  distinct_on: InputMaybe<Array<UserRuleValues_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserRuleValues_Order_By>>;
  where: InputMaybe<UserRuleValues_Bool_Exp>;
};


export type Query_RootUserRuleValues_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserRulesArgs = {
  distinct_on: InputMaybe<Array<UserRules_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserRules_Order_By>>;
  where: InputMaybe<UserRules_Bool_Exp>;
};


export type Query_RootUserRules_AggregateArgs = {
  distinct_on: InputMaybe<Array<UserRules_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserRules_Order_By>>;
  where: InputMaybe<UserRules_Bool_Exp>;
};


export type Query_RootUsersArgs = {
  distinct_on: InputMaybe<Array<Users_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Users_Order_By>>;
  where: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_AggregateArgs = {
  distinct_on: InputMaybe<Array<Users_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Users_Order_By>>;
  where: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootValidateAddressArgs = {
  address: AddressValidationInput;
};


export type Query_RootVideosArgs = {
  distinct_on: InputMaybe<Array<Videos_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Videos_Order_By>>;
  where: InputMaybe<Videos_Bool_Exp>;
};


export type Query_RootVideos_AggregateArgs = {
  distinct_on: InputMaybe<Array<Videos_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Videos_Order_By>>;
  where: InputMaybe<Videos_Bool_Exp>;
};


export type Query_RootVideos_By_PkArgs = {
  id: Scalars['uuid'];
};

/** columns and relationships of "roles" */
export type Roles = {
  __typename?: 'roles';
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An array relationship */
  rules: Array<Rules>;
  /** An aggregate relationship */
  rules_aggregate: Rules_Aggregate;
  updatedAt: Scalars['timestamptz'];
  /** An array relationship */
  userRoles: Array<UserRoles>;
  /** An aggregate relationship */
  userRoles_aggregate: UserRoles_Aggregate;
};


/** columns and relationships of "roles" */
export type RolesRulesArgs = {
  distinct_on: InputMaybe<Array<Rules_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Rules_Order_By>>;
  where: InputMaybe<Rules_Bool_Exp>;
};


/** columns and relationships of "roles" */
export type RolesRules_AggregateArgs = {
  distinct_on: InputMaybe<Array<Rules_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Rules_Order_By>>;
  where: InputMaybe<Rules_Bool_Exp>;
};


/** columns and relationships of "roles" */
export type RolesUserRolesArgs = {
  distinct_on: InputMaybe<Array<UserRoles_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserRoles_Order_By>>;
  where: InputMaybe<UserRoles_Bool_Exp>;
};


/** columns and relationships of "roles" */
export type RolesUserRoles_AggregateArgs = {
  distinct_on: InputMaybe<Array<UserRoles_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserRoles_Order_By>>;
  where: InputMaybe<UserRoles_Bool_Exp>;
};

/** aggregated selection of "roles" */
export type Roles_Aggregate = {
  __typename?: 'roles_aggregate';
  aggregate: Maybe<Roles_Aggregate_Fields>;
  nodes: Array<Roles>;
};

/** aggregate fields of "roles" */
export type Roles_Aggregate_Fields = {
  __typename?: 'roles_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Roles_Max_Fields>;
  min: Maybe<Roles_Min_Fields>;
};


/** aggregate fields of "roles" */
export type Roles_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Roles_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "roles". All fields are combined with a logical 'AND'. */
export type Roles_Bool_Exp = {
  _and?: InputMaybe<Array<Roles_Bool_Exp>>;
  _not?: InputMaybe<Roles_Bool_Exp>;
  _or?: InputMaybe<Array<Roles_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  rules?: InputMaybe<Rules_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userRoles?: InputMaybe<UserRoles_Bool_Exp>;
};

/** unique or primary key constraints on table "roles" */
export enum Roles_Constraint {
  /** unique or primary key constraint */
  RolesNameKey = 'roles_name_key',
  /** unique or primary key constraint */
  RolesPkey = 'roles_pkey'
}

/** input type for inserting data into table "roles" */
export type Roles_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  rules?: InputMaybe<Rules_Arr_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userRoles?: InputMaybe<UserRoles_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Roles_Max_Fields = {
  __typename?: 'roles_max_fields';
  createdAt: Maybe<Scalars['timestamptz']>;
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Roles_Min_Fields = {
  __typename?: 'roles_min_fields';
  createdAt: Maybe<Scalars['timestamptz']>;
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "roles" */
export type Roles_Mutation_Response = {
  __typename?: 'roles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Roles>;
};

/** input type for inserting object relation for remote table "roles" */
export type Roles_Obj_Rel_Insert_Input = {
  data: Roles_Insert_Input;
  /** on conflict condition */
  on_conflict?: InputMaybe<Roles_On_Conflict>;
};

/** on conflict condition type for table "roles" */
export type Roles_On_Conflict = {
  constraint: Roles_Constraint;
  update_columns: Array<Roles_Update_Column>;
  where?: InputMaybe<Roles_Bool_Exp>;
};

/** Ordering options when selecting data from "roles". */
export type Roles_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  rules_aggregate?: InputMaybe<Rules_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userRoles_aggregate?: InputMaybe<UserRoles_Aggregate_Order_By>;
};

/** primary key columns input for table: roles */
export type Roles_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "roles" */
export enum Roles_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "roles" */
export type Roles_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "roles" */
export enum Roles_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** columns and relationships of "rules" */
export type Rules = {
  __typename?: 'rules';
  createdAt: Scalars['timestamptz'];
  data: Scalars['jsonb'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An object relationship */
  role: Roles;
  roleId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  /** An array relationship */
  userRuleValues: Array<UserRuleValues>;
  /** An aggregate relationship */
  userRuleValues_aggregate: UserRuleValues_Aggregate;
};


/** columns and relationships of "rules" */
export type RulesDataArgs = {
  path: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "rules" */
export type RulesUserRuleValuesArgs = {
  distinct_on: InputMaybe<Array<UserRuleValues_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserRuleValues_Order_By>>;
  where: InputMaybe<UserRuleValues_Bool_Exp>;
};


/** columns and relationships of "rules" */
export type RulesUserRuleValues_AggregateArgs = {
  distinct_on: InputMaybe<Array<UserRuleValues_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserRuleValues_Order_By>>;
  where: InputMaybe<UserRuleValues_Bool_Exp>;
};

/** aggregated selection of "rules" */
export type Rules_Aggregate = {
  __typename?: 'rules_aggregate';
  aggregate: Maybe<Rules_Aggregate_Fields>;
  nodes: Array<Rules>;
};

/** aggregate fields of "rules" */
export type Rules_Aggregate_Fields = {
  __typename?: 'rules_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Rules_Max_Fields>;
  min: Maybe<Rules_Min_Fields>;
};


/** aggregate fields of "rules" */
export type Rules_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Rules_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "rules" */
export type Rules_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Rules_Max_Order_By>;
  min?: InputMaybe<Rules_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Rules_Append_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "rules" */
export type Rules_Arr_Rel_Insert_Input = {
  data: Array<Rules_Insert_Input>;
  /** on conflict condition */
  on_conflict?: InputMaybe<Rules_On_Conflict>;
};

/** Boolean expression to filter rows from the table "rules". All fields are combined with a logical 'AND'. */
export type Rules_Bool_Exp = {
  _and?: InputMaybe<Array<Rules_Bool_Exp>>;
  _not?: InputMaybe<Rules_Bool_Exp>;
  _or?: InputMaybe<Array<Rules_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  role?: InputMaybe<Roles_Bool_Exp>;
  roleId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userRuleValues?: InputMaybe<UserRuleValues_Bool_Exp>;
};

/** unique or primary key constraints on table "rules" */
export enum Rules_Constraint {
  /** unique or primary key constraint */
  RulesPkey = 'rules_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Rules_Delete_At_Path_Input = {
  data?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Rules_Delete_Elem_Input = {
  data?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Rules_Delete_Key_Input = {
  data?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "rules" */
export type Rules_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Roles_Obj_Rel_Insert_Input>;
  roleId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userRuleValues?: InputMaybe<UserRuleValues_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Rules_Max_Fields = {
  __typename?: 'rules_max_fields';
  createdAt: Maybe<Scalars['timestamptz']>;
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  roleId: Maybe<Scalars['uuid']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "rules" */
export type Rules_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  roleId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Rules_Min_Fields = {
  __typename?: 'rules_min_fields';
  createdAt: Maybe<Scalars['timestamptz']>;
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  roleId: Maybe<Scalars['uuid']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "rules" */
export type Rules_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  roleId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "rules" */
export type Rules_Mutation_Response = {
  __typename?: 'rules_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Rules>;
};

/** input type for inserting object relation for remote table "rules" */
export type Rules_Obj_Rel_Insert_Input = {
  data: Rules_Insert_Input;
  /** on conflict condition */
  on_conflict?: InputMaybe<Rules_On_Conflict>;
};

/** on conflict condition type for table "rules" */
export type Rules_On_Conflict = {
  constraint: Rules_Constraint;
  update_columns: Array<Rules_Update_Column>;
  where?: InputMaybe<Rules_Bool_Exp>;
};

/** Ordering options when selecting data from "rules". */
export type Rules_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  role?: InputMaybe<Roles_Order_By>;
  roleId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userRuleValues_aggregate?: InputMaybe<UserRuleValues_Aggregate_Order_By>;
};

/** primary key columns input for table: rules */
export type Rules_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Rules_Prepend_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "rules" */
export enum Rules_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  RoleId = 'roleId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "rules" */
export type Rules_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  roleId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "rules" */
export enum Rules_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  RoleId = 'roleId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** columns and relationships of "settings" */
export type Settings = {
  __typename?: 'settings';
  key: Scalars['String'];
  value: Scalars['String'];
};

/** aggregated selection of "settings" */
export type Settings_Aggregate = {
  __typename?: 'settings_aggregate';
  aggregate: Maybe<Settings_Aggregate_Fields>;
  nodes: Array<Settings>;
};

/** aggregate fields of "settings" */
export type Settings_Aggregate_Fields = {
  __typename?: 'settings_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Settings_Max_Fields>;
  min: Maybe<Settings_Min_Fields>;
};


/** aggregate fields of "settings" */
export type Settings_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Settings_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "settings". All fields are combined with a logical 'AND'. */
export type Settings_Bool_Exp = {
  _and?: InputMaybe<Array<Settings_Bool_Exp>>;
  _not?: InputMaybe<Settings_Bool_Exp>;
  _or?: InputMaybe<Array<Settings_Bool_Exp>>;
  key?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "settings" */
export enum Settings_Constraint {
  /** unique or primary key constraint */
  SettingsPkey = 'settings_pkey'
}

/** input type for inserting data into table "settings" */
export type Settings_Insert_Input = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Settings_Max_Fields = {
  __typename?: 'settings_max_fields';
  key: Maybe<Scalars['String']>;
  value: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Settings_Min_Fields = {
  __typename?: 'settings_min_fields';
  key: Maybe<Scalars['String']>;
  value: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "settings" */
export type Settings_Mutation_Response = {
  __typename?: 'settings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Settings>;
};

/** on conflict condition type for table "settings" */
export type Settings_On_Conflict = {
  constraint: Settings_Constraint;
  update_columns: Array<Settings_Update_Column>;
  where?: InputMaybe<Settings_Bool_Exp>;
};

/** Ordering options when selecting data from "settings". */
export type Settings_Order_By = {
  key?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: settings */
export type Settings_Pk_Columns_Input = {
  key: Scalars['String'];
};

/** select columns of table "settings" */
export enum Settings_Select_Column {
  /** column name */
  Key = 'key',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "settings" */
export type Settings_Set_Input = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "settings" */
export enum Settings_Update_Column {
  /** column name */
  Key = 'key',
  /** column name */
  Value = 'value'
}

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** An array relationship */
  apiKeys: Array<ApiKeys>;
  /** An aggregate relationship */
  apiKeys_aggregate: ApiKeys_Aggregate;
  /** fetch data from the table: "apiKeys" using primary key columns */
  apiKeys_by_pk: Maybe<ApiKeys>;
  /** fetch data from the table: "callToActionConfigs" */
  callToActionConfigs: Array<CallToActionConfigs>;
  /** fetch aggregated fields from the table: "callToActionConfigs" */
  callToActionConfigs_aggregate: CallToActionConfigs_Aggregate;
  /** fetch data from the table: "callToActionConfigs" using primary key columns */
  callToActionConfigs_by_pk: Maybe<CallToActionConfigs>;
  /** fetch data from the table: "callToActionFields" */
  callToActionFields: Array<CallToActionFields>;
  /** fetch aggregated fields from the table: "callToActionFields" */
  callToActionFields_aggregate: CallToActionFields_Aggregate;
  /** fetch data from the table: "callToActionFields" using primary key columns */
  callToActionFields_by_pk: Maybe<CallToActionFields>;
  /** fetch data from the table: "callToActionGlobalSettings" */
  callToActionGlobalSettings: Array<CallToActionGlobalSettings>;
  /** fetch aggregated fields from the table: "callToActionGlobalSettings" */
  callToActionGlobalSettings_aggregate: CallToActionGlobalSettings_Aggregate;
  /** fetch data from the table: "callToActionGlobalSettings" using primary key columns */
  callToActionGlobalSettings_by_pk: Maybe<CallToActionGlobalSettings>;
  /** An array relationship */
  devicePublicIps: Array<DevicePublicIps>;
  /** An aggregate relationship */
  devicePublicIps_aggregate: DevicePublicIps_Aggregate;
  /** fetch data from the table: "devicePublicIps" using primary key columns */
  devicePublicIps_by_pk: Maybe<DevicePublicIps>;
  /** An array relationship */
  devices: Array<Devices>;
  /** An aggregate relationship */
  devices_aggregate: Devices_Aggregate;
  /** fetch data from the table: "devices" using primary key columns */
  devices_by_pk: Maybe<Devices>;
  /** fetch data from the table: "digitalProducts" */
  digitalProducts: Array<DigitalProducts>;
  /** fetch aggregated fields from the table: "digitalProducts" */
  digitalProducts_aggregate: DigitalProducts_Aggregate;
  /** fetch data from the table: "digitalProducts" using primary key columns */
  digitalProducts_by_pk: Maybe<DigitalProducts>;
  /** An array relationship */
  documents: Array<Documents>;
  /** An aggregate relationship */
  documents_aggregate: Documents_Aggregate;
  /** fetch data from the table: "documents" using primary key columns */
  documents_by_pk: Maybe<Documents>;
  /** fetch data from the table: "exchangeContent" */
  exchangeContent: Array<ExchangeContent>;
  /** fetch aggregated fields from the table: "exchangeContent" */
  exchangeContent_aggregate: ExchangeContent_Aggregate;
  /** fetch data from the table: "exchangeContent" using primary key columns */
  exchangeContent_by_pk: Maybe<ExchangeContent>;
  /** fetch data from the table: "exchanges" */
  exchanges: Array<Exchanges>;
  /** fetch aggregated fields from the table: "exchanges" */
  exchanges_aggregate: Exchanges_Aggregate;
  /** fetch data from the table: "exchanges" using primary key columns */
  exchanges_by_pk: Maybe<Exchanges>;
  /** fetch data from the table: "files" */
  files: Array<Files>;
  /** fetch aggregated fields from the table: "files" */
  files_aggregate: Files_Aggregate;
  /** fetch data from the table: "files" using primary key columns */
  files_by_pk: Maybe<Files>;
  /** fetch data from the table: "hubspotSyncJob" */
  hubspotSyncJob: Array<HubspotSyncJob>;
  /** fetch aggregated fields from the table: "hubspotSyncJob" */
  hubspotSyncJob_aggregate: HubspotSyncJob_Aggregate;
  /** fetch data from the table: "hubspotSyncJob" using primary key columns */
  hubspotSyncJob_by_pk: Maybe<HubspotSyncJob>;
  /** fetch data from the table: "languages" */
  languages: Array<Languages>;
  /** fetch aggregated fields from the table: "languages" */
  languages_aggregate: Languages_Aggregate;
  /** fetch data from the table: "languages" using primary key columns */
  languages_by_pk: Maybe<Languages>;
  /** fetch data from the table: "leadLocks" */
  leadLocks: Array<LeadLocks>;
  /** fetch aggregated fields from the table: "leadLocks" */
  leadLocks_aggregate: LeadLocks_Aggregate;
  /** fetch data from the table: "leadLocks" using primary key columns */
  leadLocks_by_pk: Maybe<LeadLocks>;
  /** fetch data from the table: "leadsHistory" */
  leadsHistory: Array<LeadsHistory>;
  /** fetch aggregated fields from the table: "leadsHistory" */
  leadsHistory_aggregate: LeadsHistory_Aggregate;
  /** fetch data from the table: "leadsHistory" using primary key columns */
  leadsHistory_by_pk: Maybe<LeadsHistory>;
  /** fetch data from the table: "lineage" */
  lineage: Array<Lineage>;
  /** fetch aggregated fields from the table: "lineage" */
  lineage_aggregate: Lineage_Aggregate;
  /** An array relationship */
  logTraces: Array<LogTraces>;
  /** An aggregate relationship */
  logTraces_aggregate: LogTraces_Aggregate;
  /** An array relationship */
  logs: Array<Logs>;
  /** An aggregate relationship */
  logs_aggregate: Logs_Aggregate;
  /** fetch data from the table: "logs" using primary key columns */
  logs_by_pk: Maybe<Logs>;
  /** fetch data from the table: "myProducts" */
  myProducts: Array<MyProducts>;
  /** fetch aggregated fields from the table: "myProducts" */
  myProducts_aggregate: MyProducts_Aggregate;
  /** An array relationship */
  orders: Array<Orders>;
  /** An aggregate relationship */
  orders_aggregate: Orders_Aggregate;
  /** fetch data from the table: "orders" using primary key columns */
  orders_by_pk: Maybe<Orders>;
  /** An array relationship */
  payments: Array<Payments>;
  /** An aggregate relationship */
  payments_aggregate: Payments_Aggregate;
  /** fetch data from the table: "payments" using primary key columns */
  payments_by_pk: Maybe<Payments>;
  /** fetch data from the table: "products" */
  products: Array<Products>;
  /** fetch aggregated fields from the table: "products" */
  products_aggregate: Products_Aggregate;
  /** fetch data from the table: "products" using primary key columns */
  products_by_pk: Maybe<Products>;
  /** fetch data from the table: "roles" */
  roles: Array<Roles>;
  /** fetch aggregated fields from the table: "roles" */
  roles_aggregate: Roles_Aggregate;
  /** fetch data from the table: "roles" using primary key columns */
  roles_by_pk: Maybe<Roles>;
  /** An array relationship */
  rules: Array<Rules>;
  /** An aggregate relationship */
  rules_aggregate: Rules_Aggregate;
  /** fetch data from the table: "rules" using primary key columns */
  rules_by_pk: Maybe<Rules>;
  /** fetch data from the table: "settings" */
  settings: Array<Settings>;
  /** fetch aggregated fields from the table: "settings" */
  settings_aggregate: Settings_Aggregate;
  /** fetch data from the table: "settings" using primary key columns */
  settings_by_pk: Maybe<Settings>;
  /** fetch data from the table: "trackingEvents" */
  trackingEvents: Array<TrackingEvents>;
  /** fetch aggregated fields from the table: "trackingEvents" */
  trackingEvents_aggregate: TrackingEvents_Aggregate;
  /** fetch data from the table: "trackingEvents" using primary key columns */
  trackingEvents_by_pk: Maybe<TrackingEvents>;
  /** An array relationship */
  userData: Array<UserData>;
  /** An aggregate relationship */
  userData_aggregate: UserData_Aggregate;
  /** fetch data from the table: "userData" using primary key columns */
  userData_by_pk: Maybe<UserData>;
  /** An array relationship */
  userDocuments: Array<UserDocuments>;
  /** An aggregate relationship */
  userDocuments_aggregate: UserDocuments_Aggregate;
  /** fetch data from the table: "userDocuments" using primary key columns */
  userDocuments_by_pk: Maybe<UserDocuments>;
  /** fetch data from the table: "userIdTypes" */
  userIdTypes: Array<UserIdTypes>;
  /** fetch aggregated fields from the table: "userIdTypes" */
  userIdTypes_aggregate: UserIdTypes_Aggregate;
  /** fetch data from the table: "userIdTypes" using primary key columns */
  userIdTypes_by_pk: Maybe<UserIdTypes>;
  /** An array relationship */
  userIds: Array<UserIds>;
  /** An aggregate relationship */
  userIds_aggregate: UserIds_Aggregate;
  /** An array relationship */
  userRoleRequests: Array<UserRoleRequests>;
  /** An aggregate relationship */
  userRoleRequests_aggregate: UserRoleRequests_Aggregate;
  /** fetch data from the table: "userRoleRequests" using primary key columns */
  userRoleRequests_by_pk: Maybe<UserRoleRequests>;
  /** An array relationship */
  userRoles: Array<UserRoles>;
  /** fetch data from the table: "userRolesView" */
  userRolesView: Array<UserRolesView>;
  /** fetch aggregated fields from the table: "userRolesView" */
  userRolesView_aggregate: UserRolesView_Aggregate;
  /** An aggregate relationship */
  userRoles_aggregate: UserRoles_Aggregate;
  /** fetch data from the table: "userRoles" using primary key columns */
  userRoles_by_pk: Maybe<UserRoles>;
  /** An array relationship */
  userRuleValues: Array<UserRuleValues>;
  /** An aggregate relationship */
  userRuleValues_aggregate: UserRuleValues_Aggregate;
  /** fetch data from the table: "userRuleValues" using primary key columns */
  userRuleValues_by_pk: Maybe<UserRuleValues>;
  /** fetch data from the table: "userRules" */
  userRules: Array<UserRules>;
  /** fetch aggregated fields from the table: "userRules" */
  userRules_aggregate: UserRules_Aggregate;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk: Maybe<Users>;
  /** fetch data from the table: "videos" */
  videos: Array<Videos>;
  /** fetch aggregated fields from the table: "videos" */
  videos_aggregate: Videos_Aggregate;
  /** fetch data from the table: "videos" using primary key columns */
  videos_by_pk: Maybe<Videos>;
};


export type Subscription_RootApiKeysArgs = {
  distinct_on: InputMaybe<Array<ApiKeys_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<ApiKeys_Order_By>>;
  where: InputMaybe<ApiKeys_Bool_Exp>;
};


export type Subscription_RootApiKeys_AggregateArgs = {
  distinct_on: InputMaybe<Array<ApiKeys_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<ApiKeys_Order_By>>;
  where: InputMaybe<ApiKeys_Bool_Exp>;
};


export type Subscription_RootApiKeys_By_PkArgs = {
  key: Scalars['uuid'];
};


export type Subscription_RootCallToActionConfigsArgs = {
  distinct_on: InputMaybe<Array<CallToActionConfigs_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<CallToActionConfigs_Order_By>>;
  where: InputMaybe<CallToActionConfigs_Bool_Exp>;
};


export type Subscription_RootCallToActionConfigs_AggregateArgs = {
  distinct_on: InputMaybe<Array<CallToActionConfigs_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<CallToActionConfigs_Order_By>>;
  where: InputMaybe<CallToActionConfigs_Bool_Exp>;
};


export type Subscription_RootCallToActionConfigs_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCallToActionFieldsArgs = {
  distinct_on: InputMaybe<Array<CallToActionFields_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<CallToActionFields_Order_By>>;
  where: InputMaybe<CallToActionFields_Bool_Exp>;
};


export type Subscription_RootCallToActionFields_AggregateArgs = {
  distinct_on: InputMaybe<Array<CallToActionFields_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<CallToActionFields_Order_By>>;
  where: InputMaybe<CallToActionFields_Bool_Exp>;
};


export type Subscription_RootCallToActionFields_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCallToActionGlobalSettingsArgs = {
  distinct_on: InputMaybe<Array<CallToActionGlobalSettings_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<CallToActionGlobalSettings_Order_By>>;
  where: InputMaybe<CallToActionGlobalSettings_Bool_Exp>;
};


export type Subscription_RootCallToActionGlobalSettings_AggregateArgs = {
  distinct_on: InputMaybe<Array<CallToActionGlobalSettings_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<CallToActionGlobalSettings_Order_By>>;
  where: InputMaybe<CallToActionGlobalSettings_Bool_Exp>;
};


export type Subscription_RootCallToActionGlobalSettings_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootDevicePublicIpsArgs = {
  distinct_on: InputMaybe<Array<DevicePublicIps_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<DevicePublicIps_Order_By>>;
  where: InputMaybe<DevicePublicIps_Bool_Exp>;
};


export type Subscription_RootDevicePublicIps_AggregateArgs = {
  distinct_on: InputMaybe<Array<DevicePublicIps_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<DevicePublicIps_Order_By>>;
  where: InputMaybe<DevicePublicIps_Bool_Exp>;
};


export type Subscription_RootDevicePublicIps_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootDevicesArgs = {
  distinct_on: InputMaybe<Array<Devices_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Devices_Order_By>>;
  where: InputMaybe<Devices_Bool_Exp>;
};


export type Subscription_RootDevices_AggregateArgs = {
  distinct_on: InputMaybe<Array<Devices_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Devices_Order_By>>;
  where: InputMaybe<Devices_Bool_Exp>;
};


export type Subscription_RootDevices_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootDigitalProductsArgs = {
  distinct_on: InputMaybe<Array<DigitalProducts_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<DigitalProducts_Order_By>>;
  where: InputMaybe<DigitalProducts_Bool_Exp>;
};


export type Subscription_RootDigitalProducts_AggregateArgs = {
  distinct_on: InputMaybe<Array<DigitalProducts_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<DigitalProducts_Order_By>>;
  where: InputMaybe<DigitalProducts_Bool_Exp>;
};


export type Subscription_RootDigitalProducts_By_PkArgs = {
  sku: Scalars['String'];
};


export type Subscription_RootDocumentsArgs = {
  distinct_on: InputMaybe<Array<Documents_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Documents_Order_By>>;
  where: InputMaybe<Documents_Bool_Exp>;
};


export type Subscription_RootDocuments_AggregateArgs = {
  distinct_on: InputMaybe<Array<Documents_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Documents_Order_By>>;
  where: InputMaybe<Documents_Bool_Exp>;
};


export type Subscription_RootDocuments_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootExchangeContentArgs = {
  distinct_on: InputMaybe<Array<ExchangeContent_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<ExchangeContent_Order_By>>;
  where: InputMaybe<ExchangeContent_Bool_Exp>;
};


export type Subscription_RootExchangeContent_AggregateArgs = {
  distinct_on: InputMaybe<Array<ExchangeContent_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<ExchangeContent_Order_By>>;
  where: InputMaybe<ExchangeContent_Bool_Exp>;
};


export type Subscription_RootExchangeContent_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootExchangesArgs = {
  distinct_on: InputMaybe<Array<Exchanges_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Exchanges_Order_By>>;
  where: InputMaybe<Exchanges_Bool_Exp>;
};


export type Subscription_RootExchanges_AggregateArgs = {
  distinct_on: InputMaybe<Array<Exchanges_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Exchanges_Order_By>>;
  where: InputMaybe<Exchanges_Bool_Exp>;
};


export type Subscription_RootExchanges_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootFilesArgs = {
  distinct_on: InputMaybe<Array<Files_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Files_Order_By>>;
  where: InputMaybe<Files_Bool_Exp>;
};


export type Subscription_RootFiles_AggregateArgs = {
  distinct_on: InputMaybe<Array<Files_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Files_Order_By>>;
  where: InputMaybe<Files_Bool_Exp>;
};


export type Subscription_RootFiles_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootHubspotSyncJobArgs = {
  distinct_on: InputMaybe<Array<HubspotSyncJob_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<HubspotSyncJob_Order_By>>;
  where: InputMaybe<HubspotSyncJob_Bool_Exp>;
};


export type Subscription_RootHubspotSyncJob_AggregateArgs = {
  distinct_on: InputMaybe<Array<HubspotSyncJob_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<HubspotSyncJob_Order_By>>;
  where: InputMaybe<HubspotSyncJob_Bool_Exp>;
};


export type Subscription_RootHubspotSyncJob_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootLanguagesArgs = {
  distinct_on: InputMaybe<Array<Languages_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Languages_Order_By>>;
  where: InputMaybe<Languages_Bool_Exp>;
};


export type Subscription_RootLanguages_AggregateArgs = {
  distinct_on: InputMaybe<Array<Languages_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Languages_Order_By>>;
  where: InputMaybe<Languages_Bool_Exp>;
};


export type Subscription_RootLanguages_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootLeadLocksArgs = {
  distinct_on: InputMaybe<Array<LeadLocks_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<LeadLocks_Order_By>>;
  where: InputMaybe<LeadLocks_Bool_Exp>;
};


export type Subscription_RootLeadLocks_AggregateArgs = {
  distinct_on: InputMaybe<Array<LeadLocks_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<LeadLocks_Order_By>>;
  where: InputMaybe<LeadLocks_Bool_Exp>;
};


export type Subscription_RootLeadLocks_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLeadsHistoryArgs = {
  distinct_on: InputMaybe<Array<LeadsHistory_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<LeadsHistory_Order_By>>;
  where: InputMaybe<LeadsHistory_Bool_Exp>;
};


export type Subscription_RootLeadsHistory_AggregateArgs = {
  distinct_on: InputMaybe<Array<LeadsHistory_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<LeadsHistory_Order_By>>;
  where: InputMaybe<LeadsHistory_Bool_Exp>;
};


export type Subscription_RootLeadsHistory_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLineageArgs = {
  distinct_on: InputMaybe<Array<Lineage_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Lineage_Order_By>>;
  where: InputMaybe<Lineage_Bool_Exp>;
};


export type Subscription_RootLineage_AggregateArgs = {
  distinct_on: InputMaybe<Array<Lineage_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Lineage_Order_By>>;
  where: InputMaybe<Lineage_Bool_Exp>;
};


export type Subscription_RootLogTracesArgs = {
  distinct_on: InputMaybe<Array<LogTraces_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<LogTraces_Order_By>>;
  where: InputMaybe<LogTraces_Bool_Exp>;
};


export type Subscription_RootLogTraces_AggregateArgs = {
  distinct_on: InputMaybe<Array<LogTraces_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<LogTraces_Order_By>>;
  where: InputMaybe<LogTraces_Bool_Exp>;
};


export type Subscription_RootLogsArgs = {
  distinct_on: InputMaybe<Array<Logs_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Logs_Order_By>>;
  where: InputMaybe<Logs_Bool_Exp>;
};


export type Subscription_RootLogs_AggregateArgs = {
  distinct_on: InputMaybe<Array<Logs_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Logs_Order_By>>;
  where: InputMaybe<Logs_Bool_Exp>;
};


export type Subscription_RootLogs_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootMyProductsArgs = {
  distinct_on: InputMaybe<Array<MyProducts_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<MyProducts_Order_By>>;
  where: InputMaybe<MyProducts_Bool_Exp>;
};


export type Subscription_RootMyProducts_AggregateArgs = {
  distinct_on: InputMaybe<Array<MyProducts_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<MyProducts_Order_By>>;
  where: InputMaybe<MyProducts_Bool_Exp>;
};


export type Subscription_RootOrdersArgs = {
  distinct_on: InputMaybe<Array<Orders_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Orders_Order_By>>;
  where: InputMaybe<Orders_Bool_Exp>;
};


export type Subscription_RootOrders_AggregateArgs = {
  distinct_on: InputMaybe<Array<Orders_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Orders_Order_By>>;
  where: InputMaybe<Orders_Bool_Exp>;
};


export type Subscription_RootOrders_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPaymentsArgs = {
  distinct_on: InputMaybe<Array<Payments_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Payments_Order_By>>;
  where: InputMaybe<Payments_Bool_Exp>;
};


export type Subscription_RootPayments_AggregateArgs = {
  distinct_on: InputMaybe<Array<Payments_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Payments_Order_By>>;
  where: InputMaybe<Payments_Bool_Exp>;
};


export type Subscription_RootPayments_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProductsArgs = {
  distinct_on: InputMaybe<Array<Products_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Products_Order_By>>;
  where: InputMaybe<Products_Bool_Exp>;
};


export type Subscription_RootProducts_AggregateArgs = {
  distinct_on: InputMaybe<Array<Products_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Products_Order_By>>;
  where: InputMaybe<Products_Bool_Exp>;
};


export type Subscription_RootProducts_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootRolesArgs = {
  distinct_on: InputMaybe<Array<Roles_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Roles_Order_By>>;
  where: InputMaybe<Roles_Bool_Exp>;
};


export type Subscription_RootRoles_AggregateArgs = {
  distinct_on: InputMaybe<Array<Roles_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Roles_Order_By>>;
  where: InputMaybe<Roles_Bool_Exp>;
};


export type Subscription_RootRoles_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootRulesArgs = {
  distinct_on: InputMaybe<Array<Rules_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Rules_Order_By>>;
  where: InputMaybe<Rules_Bool_Exp>;
};


export type Subscription_RootRules_AggregateArgs = {
  distinct_on: InputMaybe<Array<Rules_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Rules_Order_By>>;
  where: InputMaybe<Rules_Bool_Exp>;
};


export type Subscription_RootRules_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSettingsArgs = {
  distinct_on: InputMaybe<Array<Settings_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Settings_Order_By>>;
  where: InputMaybe<Settings_Bool_Exp>;
};


export type Subscription_RootSettings_AggregateArgs = {
  distinct_on: InputMaybe<Array<Settings_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Settings_Order_By>>;
  where: InputMaybe<Settings_Bool_Exp>;
};


export type Subscription_RootSettings_By_PkArgs = {
  key: Scalars['String'];
};


export type Subscription_RootTrackingEventsArgs = {
  distinct_on: InputMaybe<Array<TrackingEvents_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<TrackingEvents_Order_By>>;
  where: InputMaybe<TrackingEvents_Bool_Exp>;
};


export type Subscription_RootTrackingEvents_AggregateArgs = {
  distinct_on: InputMaybe<Array<TrackingEvents_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<TrackingEvents_Order_By>>;
  where: InputMaybe<TrackingEvents_Bool_Exp>;
};


export type Subscription_RootTrackingEvents_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserDataArgs = {
  distinct_on: InputMaybe<Array<UserData_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserData_Order_By>>;
  where: InputMaybe<UserData_Bool_Exp>;
};


export type Subscription_RootUserData_AggregateArgs = {
  distinct_on: InputMaybe<Array<UserData_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserData_Order_By>>;
  where: InputMaybe<UserData_Bool_Exp>;
};


export type Subscription_RootUserData_By_PkArgs = {
  profileId: Scalars['uuid'];
};


export type Subscription_RootUserDocumentsArgs = {
  distinct_on: InputMaybe<Array<UserDocuments_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserDocuments_Order_By>>;
  where: InputMaybe<UserDocuments_Bool_Exp>;
};


export type Subscription_RootUserDocuments_AggregateArgs = {
  distinct_on: InputMaybe<Array<UserDocuments_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserDocuments_Order_By>>;
  where: InputMaybe<UserDocuments_Bool_Exp>;
};


export type Subscription_RootUserDocuments_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserIdTypesArgs = {
  distinct_on: InputMaybe<Array<UserIdTypes_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserIdTypes_Order_By>>;
  where: InputMaybe<UserIdTypes_Bool_Exp>;
};


export type Subscription_RootUserIdTypes_AggregateArgs = {
  distinct_on: InputMaybe<Array<UserIdTypes_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserIdTypes_Order_By>>;
  where: InputMaybe<UserIdTypes_Bool_Exp>;
};


export type Subscription_RootUserIdTypes_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserIdsArgs = {
  distinct_on: InputMaybe<Array<UserIds_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserIds_Order_By>>;
  where: InputMaybe<UserIds_Bool_Exp>;
};


export type Subscription_RootUserIds_AggregateArgs = {
  distinct_on: InputMaybe<Array<UserIds_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserIds_Order_By>>;
  where: InputMaybe<UserIds_Bool_Exp>;
};


export type Subscription_RootUserRoleRequestsArgs = {
  distinct_on: InputMaybe<Array<UserRoleRequests_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserRoleRequests_Order_By>>;
  where: InputMaybe<UserRoleRequests_Bool_Exp>;
};


export type Subscription_RootUserRoleRequests_AggregateArgs = {
  distinct_on: InputMaybe<Array<UserRoleRequests_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserRoleRequests_Order_By>>;
  where: InputMaybe<UserRoleRequests_Bool_Exp>;
};


export type Subscription_RootUserRoleRequests_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserRolesArgs = {
  distinct_on: InputMaybe<Array<UserRoles_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserRoles_Order_By>>;
  where: InputMaybe<UserRoles_Bool_Exp>;
};


export type Subscription_RootUserRolesViewArgs = {
  distinct_on: InputMaybe<Array<UserRolesView_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserRolesView_Order_By>>;
  where: InputMaybe<UserRolesView_Bool_Exp>;
};


export type Subscription_RootUserRolesView_AggregateArgs = {
  distinct_on: InputMaybe<Array<UserRolesView_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserRolesView_Order_By>>;
  where: InputMaybe<UserRolesView_Bool_Exp>;
};


export type Subscription_RootUserRoles_AggregateArgs = {
  distinct_on: InputMaybe<Array<UserRoles_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserRoles_Order_By>>;
  where: InputMaybe<UserRoles_Bool_Exp>;
};


export type Subscription_RootUserRoles_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserRuleValuesArgs = {
  distinct_on: InputMaybe<Array<UserRuleValues_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserRuleValues_Order_By>>;
  where: InputMaybe<UserRuleValues_Bool_Exp>;
};


export type Subscription_RootUserRuleValues_AggregateArgs = {
  distinct_on: InputMaybe<Array<UserRuleValues_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserRuleValues_Order_By>>;
  where: InputMaybe<UserRuleValues_Bool_Exp>;
};


export type Subscription_RootUserRuleValues_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserRulesArgs = {
  distinct_on: InputMaybe<Array<UserRules_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserRules_Order_By>>;
  where: InputMaybe<UserRules_Bool_Exp>;
};


export type Subscription_RootUserRules_AggregateArgs = {
  distinct_on: InputMaybe<Array<UserRules_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserRules_Order_By>>;
  where: InputMaybe<UserRules_Bool_Exp>;
};


export type Subscription_RootUsersArgs = {
  distinct_on: InputMaybe<Array<Users_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Users_Order_By>>;
  where: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_AggregateArgs = {
  distinct_on: InputMaybe<Array<Users_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Users_Order_By>>;
  where: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVideosArgs = {
  distinct_on: InputMaybe<Array<Videos_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Videos_Order_By>>;
  where: InputMaybe<Videos_Bool_Exp>;
};


export type Subscription_RootVideos_AggregateArgs = {
  distinct_on: InputMaybe<Array<Videos_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Videos_Order_By>>;
  where: InputMaybe<Videos_Bool_Exp>;
};


export type Subscription_RootVideos_By_PkArgs = {
  id: Scalars['uuid'];
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']>;
  _gt?: InputMaybe<Scalars['timestamptz']>;
  _gte?: InputMaybe<Scalars['timestamptz']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamptz']>;
  _lte?: InputMaybe<Scalars['timestamptz']>;
  _neq?: InputMaybe<Scalars['timestamptz']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']>>;
};

/** columns and relationships of "trackingEvents" */
export type TrackingEvents = {
  __typename?: 'trackingEvents';
  affiliateCode: Maybe<Scalars['String']>;
  agent: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  data: Maybe<Scalars['jsonb']>;
  domain: Scalars['String'];
  fingerprint: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  referrer: Maybe<Scalars['String']>;
  sourceIp: Scalars['String'];
  timestamp: Scalars['timestamptz'];
  trackingId: Scalars['uuid'];
  type: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  url: Scalars['String'];
  userId: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "trackingEvents" */
export type TrackingEventsDataArgs = {
  path: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "trackingEvents" */
export type TrackingEvents_Aggregate = {
  __typename?: 'trackingEvents_aggregate';
  aggregate: Maybe<TrackingEvents_Aggregate_Fields>;
  nodes: Array<TrackingEvents>;
};

/** aggregate fields of "trackingEvents" */
export type TrackingEvents_Aggregate_Fields = {
  __typename?: 'trackingEvents_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<TrackingEvents_Max_Fields>;
  min: Maybe<TrackingEvents_Min_Fields>;
};


/** aggregate fields of "trackingEvents" */
export type TrackingEvents_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<TrackingEvents_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type TrackingEvents_Append_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "trackingEvents". All fields are combined with a logical 'AND'. */
export type TrackingEvents_Bool_Exp = {
  _and?: InputMaybe<Array<TrackingEvents_Bool_Exp>>;
  _not?: InputMaybe<TrackingEvents_Bool_Exp>;
  _or?: InputMaybe<Array<TrackingEvents_Bool_Exp>>;
  affiliateCode?: InputMaybe<String_Comparison_Exp>;
  agent?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  domain?: InputMaybe<String_Comparison_Exp>;
  fingerprint?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  referrer?: InputMaybe<String_Comparison_Exp>;
  sourceIp?: InputMaybe<String_Comparison_Exp>;
  timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  trackingId?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "trackingEvents" */
export enum TrackingEvents_Constraint {
  /** unique or primary key constraint */
  TrackingEventsPkey = 'trackingEvents_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type TrackingEvents_Delete_At_Path_Input = {
  data?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type TrackingEvents_Delete_Elem_Input = {
  data?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type TrackingEvents_Delete_Key_Input = {
  data?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "trackingEvents" */
export type TrackingEvents_Insert_Input = {
  affiliateCode?: InputMaybe<Scalars['String']>;
  agent?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  data?: InputMaybe<Scalars['jsonb']>;
  domain?: InputMaybe<Scalars['String']>;
  fingerprint?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  referrer?: InputMaybe<Scalars['String']>;
  sourceIp?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['timestamptz']>;
  trackingId?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TrackingEvents_Max_Fields = {
  __typename?: 'trackingEvents_max_fields';
  affiliateCode: Maybe<Scalars['String']>;
  agent: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['timestamptz']>;
  domain: Maybe<Scalars['String']>;
  fingerprint: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  referrer: Maybe<Scalars['String']>;
  sourceIp: Maybe<Scalars['String']>;
  timestamp: Maybe<Scalars['timestamptz']>;
  trackingId: Maybe<Scalars['uuid']>;
  type: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
  url: Maybe<Scalars['String']>;
  userId: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type TrackingEvents_Min_Fields = {
  __typename?: 'trackingEvents_min_fields';
  affiliateCode: Maybe<Scalars['String']>;
  agent: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['timestamptz']>;
  domain: Maybe<Scalars['String']>;
  fingerprint: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  referrer: Maybe<Scalars['String']>;
  sourceIp: Maybe<Scalars['String']>;
  timestamp: Maybe<Scalars['timestamptz']>;
  trackingId: Maybe<Scalars['uuid']>;
  type: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
  url: Maybe<Scalars['String']>;
  userId: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "trackingEvents" */
export type TrackingEvents_Mutation_Response = {
  __typename?: 'trackingEvents_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TrackingEvents>;
};

/** on conflict condition type for table "trackingEvents" */
export type TrackingEvents_On_Conflict = {
  constraint: TrackingEvents_Constraint;
  update_columns: Array<TrackingEvents_Update_Column>;
  where?: InputMaybe<TrackingEvents_Bool_Exp>;
};

/** Ordering options when selecting data from "trackingEvents". */
export type TrackingEvents_Order_By = {
  affiliateCode?: InputMaybe<Order_By>;
  agent?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  domain?: InputMaybe<Order_By>;
  fingerprint?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  referrer?: InputMaybe<Order_By>;
  sourceIp?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  trackingId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: trackingEvents */
export type TrackingEvents_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type TrackingEvents_Prepend_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "trackingEvents" */
export enum TrackingEvents_Select_Column {
  /** column name */
  AffiliateCode = 'affiliateCode',
  /** column name */
  Agent = 'agent',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Data = 'data',
  /** column name */
  Domain = 'domain',
  /** column name */
  Fingerprint = 'fingerprint',
  /** column name */
  Id = 'id',
  /** column name */
  Referrer = 'referrer',
  /** column name */
  SourceIp = 'sourceIp',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  TrackingId = 'trackingId',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Url = 'url',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "trackingEvents" */
export type TrackingEvents_Set_Input = {
  affiliateCode?: InputMaybe<Scalars['String']>;
  agent?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  data?: InputMaybe<Scalars['jsonb']>;
  domain?: InputMaybe<Scalars['String']>;
  fingerprint?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  referrer?: InputMaybe<Scalars['String']>;
  sourceIp?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['timestamptz']>;
  trackingId?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "trackingEvents" */
export enum TrackingEvents_Update_Column {
  /** column name */
  AffiliateCode = 'affiliateCode',
  /** column name */
  Agent = 'agent',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Data = 'data',
  /** column name */
  Domain = 'domain',
  /** column name */
  Fingerprint = 'fingerprint',
  /** column name */
  Id = 'id',
  /** column name */
  Referrer = 'referrer',
  /** column name */
  SourceIp = 'sourceIp',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  TrackingId = 'trackingId',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Url = 'url',
  /** column name */
  UserId = 'userId'
}

export type UnsignedDocuments = {
  __typename?: 'unsignedDocuments';
  /** An object relationship */
  document: Documents;
  id: Scalars['uuid'];
};

export type Upsert_UserAndUserData_Response = {
  __typename?: 'upsert_UserAndUserData_response';
  personPrimaryTpnUsername: Maybe<Scalars['String']>;
  profileId: Maybe<Scalars['uuid']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  userData: UserData;
};

export type UserAndUserData_Upsert_Input = {
  personPrimaryTpnUsername?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "userData" */
export type UserData = {
  __typename?: 'userData';
  affiliateDashboardUrl: Maybe<Scalars['String']>;
  agreementIsSigned: Scalars['Boolean'];
  createdAt: Scalars['timestamptz'];
  hubspotVid: Maybe<Scalars['numeric']>;
  kycStatus: Maybe<Scalars['String']>;
  ndaIsSigned: Scalars['Boolean'];
  /** An array relationship */
  orders: Array<Orders>;
  /** An aggregate relationship */
  orders_aggregate: Orders_Aggregate;
  personCommunicationConsent: Scalars['Boolean'];
  personDateOfBirth: Maybe<Scalars['date']>;
  personDid: Maybe<Scalars['String']>;
  personFamilyName: Maybe<Scalars['String']>;
  personFirstName: Maybe<Scalars['String']>;
  personGender: Maybe<Scalars['String']>;
  personHandleName: Maybe<Scalars['String']>;
  personLastName: Maybe<Scalars['String']>;
  personMasterNftId: Maybe<Scalars['String']>;
  personMiddleName: Maybe<Scalars['String']>;
  personNameSuffix: Maybe<Scalars['String']>;
  personParentSigmaId: Maybe<Scalars['uuid']>;
  personPrimaryAddress1: Maybe<Scalars['String']>;
  personPrimaryAddress2: Maybe<Scalars['String']>;
  personPrimaryBio: Maybe<Scalars['String']>;
  personPrimaryBlogLink: Maybe<Scalars['String']>;
  personPrimaryBooks: Maybe<Scalars['String']>;
  personPrimaryCity: Maybe<Scalars['String']>;
  personPrimaryCountry: Maybe<Scalars['String']>;
  personPrimaryEmail: Maybe<Scalars['String']>;
  personPrimaryEmailIsVerified: Scalars['Boolean'];
  personPrimaryFacePhoto: Maybe<Scalars['String']>;
  personPrimaryFacebook: Maybe<Scalars['String']>;
  personPrimaryGis: Maybe<Scalars['point']>;
  personPrimaryHeaderImage: Maybe<Scalars['String']>;
  personPrimaryInstagram: Maybe<Scalars['String']>;
  personPrimaryIpAddress: Maybe<Scalars['String']>;
  personPrimaryKycStatus: Scalars['String'];
  personPrimaryLanguageId: Maybe<Scalars['Int']>;
  personPrimaryLinkedin: Maybe<Scalars['String']>;
  personPrimaryMobile: Maybe<Scalars['String']>;
  personPrimaryMyersBriggs: Maybe<Scalars['String']>;
  personPrimaryPhone: Maybe<Scalars['String']>;
  personPrimaryPinterest: Maybe<Scalars['String']>;
  personPrimaryPostal4: Maybe<Scalars['String']>;
  personPrimaryPostalCode: Maybe<Scalars['String']>;
  personPrimaryProfileDetail: Maybe<Scalars['String']>;
  personPrimaryProfileMessage: Maybe<Scalars['String']>;
  personPrimaryProvinceState: Maybe<Scalars['String']>;
  personPrimaryRegionCounty: Maybe<Scalars['String']>;
  personPrimarySector: Maybe<Scalars['String']>;
  personPrimaryTpnUsername: Maybe<Scalars['String']>;
  personPrimaryTwitter: Maybe<Scalars['String']>;
  personPrimaryVideo: Maybe<Scalars['String']>;
  personPrimaryVueit: Maybe<Scalars['String']>;
  personPrimaryWebLink: Maybe<Scalars['String']>;
  personPrimaryWebList: Maybe<Scalars['String']>;
  personPrimaryWhy: Maybe<Scalars['String']>;
  personPrivacyPolicy: Scalars['Boolean'];
  personReferredBy: Maybe<Scalars['uuid']>;
  personReferredByAffiliateId: Maybe<Scalars['String']>;
  personRelatedCompany: Maybe<Scalars['String']>;
  personRelatedCompanyUrl: Maybe<Scalars['String']>;
  personSelfPassionName: Maybe<Scalars['String']>;
  personStatus: Maybe<Scalars['String']>;
  personTitleName: Maybe<Scalars['String']>;
  personUniversalAffiliateId: Maybe<Scalars['String']>;
  /** An object relationship */
  primaryLanguage: Maybe<Languages>;
  profileId: Scalars['uuid'];
  profileSigmaId: Maybe<Scalars['String']>;
  /** An array relationship */
  referrals: Array<UserData>;
  /** An aggregate relationship */
  referrals_aggregate: UserData_Aggregate;
  /** An object relationship */
  referrer: Maybe<UserData>;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  /** An array relationship */
  userIds: Array<UserIds>;
  /** An aggregate relationship */
  userIds_aggregate: UserIds_Aggregate;
};


/** columns and relationships of "userData" */
export type UserDataOrdersArgs = {
  distinct_on: InputMaybe<Array<Orders_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Orders_Order_By>>;
  where: InputMaybe<Orders_Bool_Exp>;
};


/** columns and relationships of "userData" */
export type UserDataOrders_AggregateArgs = {
  distinct_on: InputMaybe<Array<Orders_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Orders_Order_By>>;
  where: InputMaybe<Orders_Bool_Exp>;
};


/** columns and relationships of "userData" */
export type UserDataReferralsArgs = {
  distinct_on: InputMaybe<Array<UserData_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserData_Order_By>>;
  where: InputMaybe<UserData_Bool_Exp>;
};


/** columns and relationships of "userData" */
export type UserDataReferrals_AggregateArgs = {
  distinct_on: InputMaybe<Array<UserData_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserData_Order_By>>;
  where: InputMaybe<UserData_Bool_Exp>;
};


/** columns and relationships of "userData" */
export type UserDataUserIdsArgs = {
  distinct_on: InputMaybe<Array<UserIds_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserIds_Order_By>>;
  where: InputMaybe<UserIds_Bool_Exp>;
};


/** columns and relationships of "userData" */
export type UserDataUserIds_AggregateArgs = {
  distinct_on: InputMaybe<Array<UserIds_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserIds_Order_By>>;
  where: InputMaybe<UserIds_Bool_Exp>;
};

/** aggregated selection of "userData" */
export type UserData_Aggregate = {
  __typename?: 'userData_aggregate';
  aggregate: Maybe<UserData_Aggregate_Fields>;
  nodes: Array<UserData>;
};

/** aggregate fields of "userData" */
export type UserData_Aggregate_Fields = {
  __typename?: 'userData_aggregate_fields';
  avg: Maybe<UserData_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<UserData_Max_Fields>;
  min: Maybe<UserData_Min_Fields>;
  stddev: Maybe<UserData_Stddev_Fields>;
  stddev_pop: Maybe<UserData_Stddev_Pop_Fields>;
  stddev_samp: Maybe<UserData_Stddev_Samp_Fields>;
  sum: Maybe<UserData_Sum_Fields>;
  var_pop: Maybe<UserData_Var_Pop_Fields>;
  var_samp: Maybe<UserData_Var_Samp_Fields>;
  variance: Maybe<UserData_Variance_Fields>;
};


/** aggregate fields of "userData" */
export type UserData_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<UserData_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "userData" */
export type UserData_Aggregate_Order_By = {
  avg?: InputMaybe<UserData_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<UserData_Max_Order_By>;
  min?: InputMaybe<UserData_Min_Order_By>;
  stddev?: InputMaybe<UserData_Stddev_Order_By>;
  stddev_pop?: InputMaybe<UserData_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<UserData_Stddev_Samp_Order_By>;
  sum?: InputMaybe<UserData_Sum_Order_By>;
  var_pop?: InputMaybe<UserData_Var_Pop_Order_By>;
  var_samp?: InputMaybe<UserData_Var_Samp_Order_By>;
  variance?: InputMaybe<UserData_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "userData" */
export type UserData_Arr_Rel_Insert_Input = {
  data: Array<UserData_Insert_Input>;
  /** on conflict condition */
  on_conflict?: InputMaybe<UserData_On_Conflict>;
};

/** aggregate avg on columns */
export type UserData_Avg_Fields = {
  __typename?: 'userData_avg_fields';
  hubspotVid: Maybe<Scalars['Float']>;
  personPrimaryLanguageId: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "userData" */
export type UserData_Avg_Order_By = {
  hubspotVid?: InputMaybe<Order_By>;
  personPrimaryLanguageId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "userData". All fields are combined with a logical 'AND'. */
export type UserData_Bool_Exp = {
  _and?: InputMaybe<Array<UserData_Bool_Exp>>;
  _not?: InputMaybe<UserData_Bool_Exp>;
  _or?: InputMaybe<Array<UserData_Bool_Exp>>;
  affiliateDashboardUrl?: InputMaybe<String_Comparison_Exp>;
  agreementIsSigned?: InputMaybe<Boolean_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  hubspotVid?: InputMaybe<Numeric_Comparison_Exp>;
  kycStatus?: InputMaybe<String_Comparison_Exp>;
  ndaIsSigned?: InputMaybe<Boolean_Comparison_Exp>;
  orders?: InputMaybe<Orders_Bool_Exp>;
  personCommunicationConsent?: InputMaybe<Boolean_Comparison_Exp>;
  personDateOfBirth?: InputMaybe<Date_Comparison_Exp>;
  personDid?: InputMaybe<String_Comparison_Exp>;
  personFamilyName?: InputMaybe<String_Comparison_Exp>;
  personFirstName?: InputMaybe<String_Comparison_Exp>;
  personGender?: InputMaybe<String_Comparison_Exp>;
  personHandleName?: InputMaybe<String_Comparison_Exp>;
  personLastName?: InputMaybe<String_Comparison_Exp>;
  personMasterNftId?: InputMaybe<String_Comparison_Exp>;
  personMiddleName?: InputMaybe<String_Comparison_Exp>;
  personNameSuffix?: InputMaybe<String_Comparison_Exp>;
  personParentSigmaId?: InputMaybe<Uuid_Comparison_Exp>;
  personPrimaryAddress1?: InputMaybe<String_Comparison_Exp>;
  personPrimaryAddress2?: InputMaybe<String_Comparison_Exp>;
  personPrimaryBio?: InputMaybe<String_Comparison_Exp>;
  personPrimaryBlogLink?: InputMaybe<String_Comparison_Exp>;
  personPrimaryBooks?: InputMaybe<String_Comparison_Exp>;
  personPrimaryCity?: InputMaybe<String_Comparison_Exp>;
  personPrimaryCountry?: InputMaybe<String_Comparison_Exp>;
  personPrimaryEmail?: InputMaybe<String_Comparison_Exp>;
  personPrimaryEmailIsVerified?: InputMaybe<Boolean_Comparison_Exp>;
  personPrimaryFacePhoto?: InputMaybe<String_Comparison_Exp>;
  personPrimaryFacebook?: InputMaybe<String_Comparison_Exp>;
  personPrimaryGis?: InputMaybe<Point_Comparison_Exp>;
  personPrimaryHeaderImage?: InputMaybe<String_Comparison_Exp>;
  personPrimaryInstagram?: InputMaybe<String_Comparison_Exp>;
  personPrimaryIpAddress?: InputMaybe<String_Comparison_Exp>;
  personPrimaryKycStatus?: InputMaybe<String_Comparison_Exp>;
  personPrimaryLanguageId?: InputMaybe<Int_Comparison_Exp>;
  personPrimaryLinkedin?: InputMaybe<String_Comparison_Exp>;
  personPrimaryMobile?: InputMaybe<String_Comparison_Exp>;
  personPrimaryMyersBriggs?: InputMaybe<String_Comparison_Exp>;
  personPrimaryPhone?: InputMaybe<String_Comparison_Exp>;
  personPrimaryPinterest?: InputMaybe<String_Comparison_Exp>;
  personPrimaryPostal4?: InputMaybe<String_Comparison_Exp>;
  personPrimaryPostalCode?: InputMaybe<String_Comparison_Exp>;
  personPrimaryProfileDetail?: InputMaybe<String_Comparison_Exp>;
  personPrimaryProfileMessage?: InputMaybe<String_Comparison_Exp>;
  personPrimaryProvinceState?: InputMaybe<String_Comparison_Exp>;
  personPrimaryRegionCounty?: InputMaybe<String_Comparison_Exp>;
  personPrimarySector?: InputMaybe<String_Comparison_Exp>;
  personPrimaryTpnUsername?: InputMaybe<String_Comparison_Exp>;
  personPrimaryTwitter?: InputMaybe<String_Comparison_Exp>;
  personPrimaryVideo?: InputMaybe<String_Comparison_Exp>;
  personPrimaryVueit?: InputMaybe<String_Comparison_Exp>;
  personPrimaryWebLink?: InputMaybe<String_Comparison_Exp>;
  personPrimaryWebList?: InputMaybe<String_Comparison_Exp>;
  personPrimaryWhy?: InputMaybe<String_Comparison_Exp>;
  personPrivacyPolicy?: InputMaybe<Boolean_Comparison_Exp>;
  personReferredBy?: InputMaybe<Uuid_Comparison_Exp>;
  personReferredByAffiliateId?: InputMaybe<String_Comparison_Exp>;
  personRelatedCompany?: InputMaybe<String_Comparison_Exp>;
  personRelatedCompanyUrl?: InputMaybe<String_Comparison_Exp>;
  personSelfPassionName?: InputMaybe<String_Comparison_Exp>;
  personStatus?: InputMaybe<String_Comparison_Exp>;
  personTitleName?: InputMaybe<String_Comparison_Exp>;
  personUniversalAffiliateId?: InputMaybe<String_Comparison_Exp>;
  primaryLanguage?: InputMaybe<Languages_Bool_Exp>;
  profileId?: InputMaybe<Uuid_Comparison_Exp>;
  profileSigmaId?: InputMaybe<String_Comparison_Exp>;
  referrals?: InputMaybe<UserData_Bool_Exp>;
  referrer?: InputMaybe<UserData_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userIds?: InputMaybe<UserIds_Bool_Exp>;
};

/** unique or primary key constraints on table "userData" */
export enum UserData_Constraint {
  /** unique or primary key constraint */
  UserDataPkey = 'userData_pkey',
  /** unique or primary key constraint */
  UserDataTpnUsernameKey = 'userData_tpnUsername_key'
}

/** input type for incrementing numeric columns in table "userData" */
export type UserData_Inc_Input = {
  hubspotVid?: InputMaybe<Scalars['numeric']>;
  personPrimaryLanguageId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "userData" */
export type UserData_Insert_Input = {
  affiliateDashboardUrl?: InputMaybe<Scalars['String']>;
  agreementIsSigned?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  hubspotVid?: InputMaybe<Scalars['numeric']>;
  kycStatus?: InputMaybe<Scalars['String']>;
  ndaIsSigned?: InputMaybe<Scalars['Boolean']>;
  orders?: InputMaybe<Orders_Arr_Rel_Insert_Input>;
  personCommunicationConsent?: InputMaybe<Scalars['Boolean']>;
  personDateOfBirth?: InputMaybe<Scalars['date']>;
  personDid?: InputMaybe<Scalars['String']>;
  personFamilyName?: InputMaybe<Scalars['String']>;
  personFirstName?: InputMaybe<Scalars['String']>;
  personGender?: InputMaybe<Scalars['String']>;
  personHandleName?: InputMaybe<Scalars['String']>;
  personLastName?: InputMaybe<Scalars['String']>;
  personMasterNftId?: InputMaybe<Scalars['String']>;
  personMiddleName?: InputMaybe<Scalars['String']>;
  personNameSuffix?: InputMaybe<Scalars['String']>;
  personParentSigmaId?: InputMaybe<Scalars['uuid']>;
  personPrimaryAddress1?: InputMaybe<Scalars['String']>;
  personPrimaryAddress2?: InputMaybe<Scalars['String']>;
  personPrimaryBio?: InputMaybe<Scalars['String']>;
  personPrimaryBlogLink?: InputMaybe<Scalars['String']>;
  personPrimaryBooks?: InputMaybe<Scalars['String']>;
  personPrimaryCity?: InputMaybe<Scalars['String']>;
  personPrimaryCountry?: InputMaybe<Scalars['String']>;
  personPrimaryEmail?: InputMaybe<Scalars['String']>;
  personPrimaryEmailIsVerified?: InputMaybe<Scalars['Boolean']>;
  personPrimaryFacePhoto?: InputMaybe<Scalars['String']>;
  personPrimaryFacebook?: InputMaybe<Scalars['String']>;
  personPrimaryGis?: InputMaybe<Scalars['point']>;
  personPrimaryHeaderImage?: InputMaybe<Scalars['String']>;
  personPrimaryInstagram?: InputMaybe<Scalars['String']>;
  personPrimaryIpAddress?: InputMaybe<Scalars['String']>;
  personPrimaryKycStatus?: InputMaybe<Scalars['String']>;
  personPrimaryLanguageId?: InputMaybe<Scalars['Int']>;
  personPrimaryLinkedin?: InputMaybe<Scalars['String']>;
  personPrimaryMobile?: InputMaybe<Scalars['String']>;
  personPrimaryMyersBriggs?: InputMaybe<Scalars['String']>;
  personPrimaryPhone?: InputMaybe<Scalars['String']>;
  personPrimaryPinterest?: InputMaybe<Scalars['String']>;
  personPrimaryPostal4?: InputMaybe<Scalars['String']>;
  personPrimaryPostalCode?: InputMaybe<Scalars['String']>;
  personPrimaryProfileDetail?: InputMaybe<Scalars['String']>;
  personPrimaryProfileMessage?: InputMaybe<Scalars['String']>;
  personPrimaryProvinceState?: InputMaybe<Scalars['String']>;
  personPrimaryRegionCounty?: InputMaybe<Scalars['String']>;
  personPrimarySector?: InputMaybe<Scalars['String']>;
  personPrimaryTpnUsername?: InputMaybe<Scalars['String']>;
  personPrimaryTwitter?: InputMaybe<Scalars['String']>;
  personPrimaryVideo?: InputMaybe<Scalars['String']>;
  personPrimaryVueit?: InputMaybe<Scalars['String']>;
  personPrimaryWebLink?: InputMaybe<Scalars['String']>;
  personPrimaryWebList?: InputMaybe<Scalars['String']>;
  personPrimaryWhy?: InputMaybe<Scalars['String']>;
  personPrivacyPolicy?: InputMaybe<Scalars['Boolean']>;
  personReferredBy?: InputMaybe<Scalars['uuid']>;
  personReferredByAffiliateId?: InputMaybe<Scalars['String']>;
  personRelatedCompany?: InputMaybe<Scalars['String']>;
  personRelatedCompanyUrl?: InputMaybe<Scalars['String']>;
  personSelfPassionName?: InputMaybe<Scalars['String']>;
  personStatus?: InputMaybe<Scalars['String']>;
  personTitleName?: InputMaybe<Scalars['String']>;
  personUniversalAffiliateId?: InputMaybe<Scalars['String']>;
  primaryLanguage?: InputMaybe<Languages_Obj_Rel_Insert_Input>;
  profileId?: InputMaybe<Scalars['uuid']>;
  profileSigmaId?: InputMaybe<Scalars['String']>;
  referrals?: InputMaybe<UserData_Arr_Rel_Insert_Input>;
  referrer?: InputMaybe<UserData_Obj_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userIds?: InputMaybe<UserIds_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type UserData_Max_Fields = {
  __typename?: 'userData_max_fields';
  affiliateDashboardUrl: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['timestamptz']>;
  hubspotVid: Maybe<Scalars['numeric']>;
  kycStatus: Maybe<Scalars['String']>;
  personDateOfBirth: Maybe<Scalars['date']>;
  personDid: Maybe<Scalars['String']>;
  personFamilyName: Maybe<Scalars['String']>;
  personFirstName: Maybe<Scalars['String']>;
  personGender: Maybe<Scalars['String']>;
  personHandleName: Maybe<Scalars['String']>;
  personLastName: Maybe<Scalars['String']>;
  personMasterNftId: Maybe<Scalars['String']>;
  personMiddleName: Maybe<Scalars['String']>;
  personNameSuffix: Maybe<Scalars['String']>;
  personParentSigmaId: Maybe<Scalars['uuid']>;
  personPrimaryAddress1: Maybe<Scalars['String']>;
  personPrimaryAddress2: Maybe<Scalars['String']>;
  personPrimaryBio: Maybe<Scalars['String']>;
  personPrimaryBlogLink: Maybe<Scalars['String']>;
  personPrimaryBooks: Maybe<Scalars['String']>;
  personPrimaryCity: Maybe<Scalars['String']>;
  personPrimaryCountry: Maybe<Scalars['String']>;
  personPrimaryEmail: Maybe<Scalars['String']>;
  personPrimaryFacePhoto: Maybe<Scalars['String']>;
  personPrimaryFacebook: Maybe<Scalars['String']>;
  personPrimaryHeaderImage: Maybe<Scalars['String']>;
  personPrimaryInstagram: Maybe<Scalars['String']>;
  personPrimaryIpAddress: Maybe<Scalars['String']>;
  personPrimaryKycStatus: Maybe<Scalars['String']>;
  personPrimaryLanguageId: Maybe<Scalars['Int']>;
  personPrimaryLinkedin: Maybe<Scalars['String']>;
  personPrimaryMobile: Maybe<Scalars['String']>;
  personPrimaryMyersBriggs: Maybe<Scalars['String']>;
  personPrimaryPhone: Maybe<Scalars['String']>;
  personPrimaryPinterest: Maybe<Scalars['String']>;
  personPrimaryPostal4: Maybe<Scalars['String']>;
  personPrimaryPostalCode: Maybe<Scalars['String']>;
  personPrimaryProfileDetail: Maybe<Scalars['String']>;
  personPrimaryProfileMessage: Maybe<Scalars['String']>;
  personPrimaryProvinceState: Maybe<Scalars['String']>;
  personPrimaryRegionCounty: Maybe<Scalars['String']>;
  personPrimarySector: Maybe<Scalars['String']>;
  personPrimaryTpnUsername: Maybe<Scalars['String']>;
  personPrimaryTwitter: Maybe<Scalars['String']>;
  personPrimaryVideo: Maybe<Scalars['String']>;
  personPrimaryVueit: Maybe<Scalars['String']>;
  personPrimaryWebLink: Maybe<Scalars['String']>;
  personPrimaryWebList: Maybe<Scalars['String']>;
  personPrimaryWhy: Maybe<Scalars['String']>;
  personReferredBy: Maybe<Scalars['uuid']>;
  personReferredByAffiliateId: Maybe<Scalars['String']>;
  personRelatedCompany: Maybe<Scalars['String']>;
  personRelatedCompanyUrl: Maybe<Scalars['String']>;
  personSelfPassionName: Maybe<Scalars['String']>;
  personStatus: Maybe<Scalars['String']>;
  personTitleName: Maybe<Scalars['String']>;
  personUniversalAffiliateId: Maybe<Scalars['String']>;
  profileId: Maybe<Scalars['uuid']>;
  profileSigmaId: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "userData" */
export type UserData_Max_Order_By = {
  affiliateDashboardUrl?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  hubspotVid?: InputMaybe<Order_By>;
  kycStatus?: InputMaybe<Order_By>;
  personDateOfBirth?: InputMaybe<Order_By>;
  personDid?: InputMaybe<Order_By>;
  personFamilyName?: InputMaybe<Order_By>;
  personFirstName?: InputMaybe<Order_By>;
  personGender?: InputMaybe<Order_By>;
  personHandleName?: InputMaybe<Order_By>;
  personLastName?: InputMaybe<Order_By>;
  personMasterNftId?: InputMaybe<Order_By>;
  personMiddleName?: InputMaybe<Order_By>;
  personNameSuffix?: InputMaybe<Order_By>;
  personParentSigmaId?: InputMaybe<Order_By>;
  personPrimaryAddress1?: InputMaybe<Order_By>;
  personPrimaryAddress2?: InputMaybe<Order_By>;
  personPrimaryBio?: InputMaybe<Order_By>;
  personPrimaryBlogLink?: InputMaybe<Order_By>;
  personPrimaryBooks?: InputMaybe<Order_By>;
  personPrimaryCity?: InputMaybe<Order_By>;
  personPrimaryCountry?: InputMaybe<Order_By>;
  personPrimaryEmail?: InputMaybe<Order_By>;
  personPrimaryFacePhoto?: InputMaybe<Order_By>;
  personPrimaryFacebook?: InputMaybe<Order_By>;
  personPrimaryHeaderImage?: InputMaybe<Order_By>;
  personPrimaryInstagram?: InputMaybe<Order_By>;
  personPrimaryIpAddress?: InputMaybe<Order_By>;
  personPrimaryKycStatus?: InputMaybe<Order_By>;
  personPrimaryLanguageId?: InputMaybe<Order_By>;
  personPrimaryLinkedin?: InputMaybe<Order_By>;
  personPrimaryMobile?: InputMaybe<Order_By>;
  personPrimaryMyersBriggs?: InputMaybe<Order_By>;
  personPrimaryPhone?: InputMaybe<Order_By>;
  personPrimaryPinterest?: InputMaybe<Order_By>;
  personPrimaryPostal4?: InputMaybe<Order_By>;
  personPrimaryPostalCode?: InputMaybe<Order_By>;
  personPrimaryProfileDetail?: InputMaybe<Order_By>;
  personPrimaryProfileMessage?: InputMaybe<Order_By>;
  personPrimaryProvinceState?: InputMaybe<Order_By>;
  personPrimaryRegionCounty?: InputMaybe<Order_By>;
  personPrimarySector?: InputMaybe<Order_By>;
  personPrimaryTpnUsername?: InputMaybe<Order_By>;
  personPrimaryTwitter?: InputMaybe<Order_By>;
  personPrimaryVideo?: InputMaybe<Order_By>;
  personPrimaryVueit?: InputMaybe<Order_By>;
  personPrimaryWebLink?: InputMaybe<Order_By>;
  personPrimaryWebList?: InputMaybe<Order_By>;
  personPrimaryWhy?: InputMaybe<Order_By>;
  personReferredBy?: InputMaybe<Order_By>;
  personReferredByAffiliateId?: InputMaybe<Order_By>;
  personRelatedCompany?: InputMaybe<Order_By>;
  personRelatedCompanyUrl?: InputMaybe<Order_By>;
  personSelfPassionName?: InputMaybe<Order_By>;
  personStatus?: InputMaybe<Order_By>;
  personTitleName?: InputMaybe<Order_By>;
  personUniversalAffiliateId?: InputMaybe<Order_By>;
  profileId?: InputMaybe<Order_By>;
  profileSigmaId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type UserData_Min_Fields = {
  __typename?: 'userData_min_fields';
  affiliateDashboardUrl: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['timestamptz']>;
  hubspotVid: Maybe<Scalars['numeric']>;
  kycStatus: Maybe<Scalars['String']>;
  personDateOfBirth: Maybe<Scalars['date']>;
  personDid: Maybe<Scalars['String']>;
  personFamilyName: Maybe<Scalars['String']>;
  personFirstName: Maybe<Scalars['String']>;
  personGender: Maybe<Scalars['String']>;
  personHandleName: Maybe<Scalars['String']>;
  personLastName: Maybe<Scalars['String']>;
  personMasterNftId: Maybe<Scalars['String']>;
  personMiddleName: Maybe<Scalars['String']>;
  personNameSuffix: Maybe<Scalars['String']>;
  personParentSigmaId: Maybe<Scalars['uuid']>;
  personPrimaryAddress1: Maybe<Scalars['String']>;
  personPrimaryAddress2: Maybe<Scalars['String']>;
  personPrimaryBio: Maybe<Scalars['String']>;
  personPrimaryBlogLink: Maybe<Scalars['String']>;
  personPrimaryBooks: Maybe<Scalars['String']>;
  personPrimaryCity: Maybe<Scalars['String']>;
  personPrimaryCountry: Maybe<Scalars['String']>;
  personPrimaryEmail: Maybe<Scalars['String']>;
  personPrimaryFacePhoto: Maybe<Scalars['String']>;
  personPrimaryFacebook: Maybe<Scalars['String']>;
  personPrimaryHeaderImage: Maybe<Scalars['String']>;
  personPrimaryInstagram: Maybe<Scalars['String']>;
  personPrimaryIpAddress: Maybe<Scalars['String']>;
  personPrimaryKycStatus: Maybe<Scalars['String']>;
  personPrimaryLanguageId: Maybe<Scalars['Int']>;
  personPrimaryLinkedin: Maybe<Scalars['String']>;
  personPrimaryMobile: Maybe<Scalars['String']>;
  personPrimaryMyersBriggs: Maybe<Scalars['String']>;
  personPrimaryPhone: Maybe<Scalars['String']>;
  personPrimaryPinterest: Maybe<Scalars['String']>;
  personPrimaryPostal4: Maybe<Scalars['String']>;
  personPrimaryPostalCode: Maybe<Scalars['String']>;
  personPrimaryProfileDetail: Maybe<Scalars['String']>;
  personPrimaryProfileMessage: Maybe<Scalars['String']>;
  personPrimaryProvinceState: Maybe<Scalars['String']>;
  personPrimaryRegionCounty: Maybe<Scalars['String']>;
  personPrimarySector: Maybe<Scalars['String']>;
  personPrimaryTpnUsername: Maybe<Scalars['String']>;
  personPrimaryTwitter: Maybe<Scalars['String']>;
  personPrimaryVideo: Maybe<Scalars['String']>;
  personPrimaryVueit: Maybe<Scalars['String']>;
  personPrimaryWebLink: Maybe<Scalars['String']>;
  personPrimaryWebList: Maybe<Scalars['String']>;
  personPrimaryWhy: Maybe<Scalars['String']>;
  personReferredBy: Maybe<Scalars['uuid']>;
  personReferredByAffiliateId: Maybe<Scalars['String']>;
  personRelatedCompany: Maybe<Scalars['String']>;
  personRelatedCompanyUrl: Maybe<Scalars['String']>;
  personSelfPassionName: Maybe<Scalars['String']>;
  personStatus: Maybe<Scalars['String']>;
  personTitleName: Maybe<Scalars['String']>;
  personUniversalAffiliateId: Maybe<Scalars['String']>;
  profileId: Maybe<Scalars['uuid']>;
  profileSigmaId: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "userData" */
export type UserData_Min_Order_By = {
  affiliateDashboardUrl?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  hubspotVid?: InputMaybe<Order_By>;
  kycStatus?: InputMaybe<Order_By>;
  personDateOfBirth?: InputMaybe<Order_By>;
  personDid?: InputMaybe<Order_By>;
  personFamilyName?: InputMaybe<Order_By>;
  personFirstName?: InputMaybe<Order_By>;
  personGender?: InputMaybe<Order_By>;
  personHandleName?: InputMaybe<Order_By>;
  personLastName?: InputMaybe<Order_By>;
  personMasterNftId?: InputMaybe<Order_By>;
  personMiddleName?: InputMaybe<Order_By>;
  personNameSuffix?: InputMaybe<Order_By>;
  personParentSigmaId?: InputMaybe<Order_By>;
  personPrimaryAddress1?: InputMaybe<Order_By>;
  personPrimaryAddress2?: InputMaybe<Order_By>;
  personPrimaryBio?: InputMaybe<Order_By>;
  personPrimaryBlogLink?: InputMaybe<Order_By>;
  personPrimaryBooks?: InputMaybe<Order_By>;
  personPrimaryCity?: InputMaybe<Order_By>;
  personPrimaryCountry?: InputMaybe<Order_By>;
  personPrimaryEmail?: InputMaybe<Order_By>;
  personPrimaryFacePhoto?: InputMaybe<Order_By>;
  personPrimaryFacebook?: InputMaybe<Order_By>;
  personPrimaryHeaderImage?: InputMaybe<Order_By>;
  personPrimaryInstagram?: InputMaybe<Order_By>;
  personPrimaryIpAddress?: InputMaybe<Order_By>;
  personPrimaryKycStatus?: InputMaybe<Order_By>;
  personPrimaryLanguageId?: InputMaybe<Order_By>;
  personPrimaryLinkedin?: InputMaybe<Order_By>;
  personPrimaryMobile?: InputMaybe<Order_By>;
  personPrimaryMyersBriggs?: InputMaybe<Order_By>;
  personPrimaryPhone?: InputMaybe<Order_By>;
  personPrimaryPinterest?: InputMaybe<Order_By>;
  personPrimaryPostal4?: InputMaybe<Order_By>;
  personPrimaryPostalCode?: InputMaybe<Order_By>;
  personPrimaryProfileDetail?: InputMaybe<Order_By>;
  personPrimaryProfileMessage?: InputMaybe<Order_By>;
  personPrimaryProvinceState?: InputMaybe<Order_By>;
  personPrimaryRegionCounty?: InputMaybe<Order_By>;
  personPrimarySector?: InputMaybe<Order_By>;
  personPrimaryTpnUsername?: InputMaybe<Order_By>;
  personPrimaryTwitter?: InputMaybe<Order_By>;
  personPrimaryVideo?: InputMaybe<Order_By>;
  personPrimaryVueit?: InputMaybe<Order_By>;
  personPrimaryWebLink?: InputMaybe<Order_By>;
  personPrimaryWebList?: InputMaybe<Order_By>;
  personPrimaryWhy?: InputMaybe<Order_By>;
  personReferredBy?: InputMaybe<Order_By>;
  personReferredByAffiliateId?: InputMaybe<Order_By>;
  personRelatedCompany?: InputMaybe<Order_By>;
  personRelatedCompanyUrl?: InputMaybe<Order_By>;
  personSelfPassionName?: InputMaybe<Order_By>;
  personStatus?: InputMaybe<Order_By>;
  personTitleName?: InputMaybe<Order_By>;
  personUniversalAffiliateId?: InputMaybe<Order_By>;
  profileId?: InputMaybe<Order_By>;
  profileSigmaId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "userData" */
export type UserData_Mutation_Response = {
  __typename?: 'userData_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserData>;
};

/** input type for inserting object relation for remote table "userData" */
export type UserData_Obj_Rel_Insert_Input = {
  data: UserData_Insert_Input;
  /** on conflict condition */
  on_conflict?: InputMaybe<UserData_On_Conflict>;
};

/** on conflict condition type for table "userData" */
export type UserData_On_Conflict = {
  constraint: UserData_Constraint;
  update_columns: Array<UserData_Update_Column>;
  where?: InputMaybe<UserData_Bool_Exp>;
};

/** Ordering options when selecting data from "userData". */
export type UserData_Order_By = {
  affiliateDashboardUrl?: InputMaybe<Order_By>;
  agreementIsSigned?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  hubspotVid?: InputMaybe<Order_By>;
  kycStatus?: InputMaybe<Order_By>;
  ndaIsSigned?: InputMaybe<Order_By>;
  orders_aggregate?: InputMaybe<Orders_Aggregate_Order_By>;
  personCommunicationConsent?: InputMaybe<Order_By>;
  personDateOfBirth?: InputMaybe<Order_By>;
  personDid?: InputMaybe<Order_By>;
  personFamilyName?: InputMaybe<Order_By>;
  personFirstName?: InputMaybe<Order_By>;
  personGender?: InputMaybe<Order_By>;
  personHandleName?: InputMaybe<Order_By>;
  personLastName?: InputMaybe<Order_By>;
  personMasterNftId?: InputMaybe<Order_By>;
  personMiddleName?: InputMaybe<Order_By>;
  personNameSuffix?: InputMaybe<Order_By>;
  personParentSigmaId?: InputMaybe<Order_By>;
  personPrimaryAddress1?: InputMaybe<Order_By>;
  personPrimaryAddress2?: InputMaybe<Order_By>;
  personPrimaryBio?: InputMaybe<Order_By>;
  personPrimaryBlogLink?: InputMaybe<Order_By>;
  personPrimaryBooks?: InputMaybe<Order_By>;
  personPrimaryCity?: InputMaybe<Order_By>;
  personPrimaryCountry?: InputMaybe<Order_By>;
  personPrimaryEmail?: InputMaybe<Order_By>;
  personPrimaryEmailIsVerified?: InputMaybe<Order_By>;
  personPrimaryFacePhoto?: InputMaybe<Order_By>;
  personPrimaryFacebook?: InputMaybe<Order_By>;
  personPrimaryGis?: InputMaybe<Order_By>;
  personPrimaryHeaderImage?: InputMaybe<Order_By>;
  personPrimaryInstagram?: InputMaybe<Order_By>;
  personPrimaryIpAddress?: InputMaybe<Order_By>;
  personPrimaryKycStatus?: InputMaybe<Order_By>;
  personPrimaryLanguageId?: InputMaybe<Order_By>;
  personPrimaryLinkedin?: InputMaybe<Order_By>;
  personPrimaryMobile?: InputMaybe<Order_By>;
  personPrimaryMyersBriggs?: InputMaybe<Order_By>;
  personPrimaryPhone?: InputMaybe<Order_By>;
  personPrimaryPinterest?: InputMaybe<Order_By>;
  personPrimaryPostal4?: InputMaybe<Order_By>;
  personPrimaryPostalCode?: InputMaybe<Order_By>;
  personPrimaryProfileDetail?: InputMaybe<Order_By>;
  personPrimaryProfileMessage?: InputMaybe<Order_By>;
  personPrimaryProvinceState?: InputMaybe<Order_By>;
  personPrimaryRegionCounty?: InputMaybe<Order_By>;
  personPrimarySector?: InputMaybe<Order_By>;
  personPrimaryTpnUsername?: InputMaybe<Order_By>;
  personPrimaryTwitter?: InputMaybe<Order_By>;
  personPrimaryVideo?: InputMaybe<Order_By>;
  personPrimaryVueit?: InputMaybe<Order_By>;
  personPrimaryWebLink?: InputMaybe<Order_By>;
  personPrimaryWebList?: InputMaybe<Order_By>;
  personPrimaryWhy?: InputMaybe<Order_By>;
  personPrivacyPolicy?: InputMaybe<Order_By>;
  personReferredBy?: InputMaybe<Order_By>;
  personReferredByAffiliateId?: InputMaybe<Order_By>;
  personRelatedCompany?: InputMaybe<Order_By>;
  personRelatedCompanyUrl?: InputMaybe<Order_By>;
  personSelfPassionName?: InputMaybe<Order_By>;
  personStatus?: InputMaybe<Order_By>;
  personTitleName?: InputMaybe<Order_By>;
  personUniversalAffiliateId?: InputMaybe<Order_By>;
  primaryLanguage?: InputMaybe<Languages_Order_By>;
  profileId?: InputMaybe<Order_By>;
  profileSigmaId?: InputMaybe<Order_By>;
  referrals_aggregate?: InputMaybe<UserData_Aggregate_Order_By>;
  referrer?: InputMaybe<UserData_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userIds_aggregate?: InputMaybe<UserIds_Aggregate_Order_By>;
};

/** primary key columns input for table: userData */
export type UserData_Pk_Columns_Input = {
  profileId: Scalars['uuid'];
};

/** select columns of table "userData" */
export enum UserData_Select_Column {
  /** column name */
  AffiliateDashboardUrl = 'affiliateDashboardUrl',
  /** column name */
  AgreementIsSigned = 'agreementIsSigned',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  HubspotVid = 'hubspotVid',
  /** column name */
  KycStatus = 'kycStatus',
  /** column name */
  NdaIsSigned = 'ndaIsSigned',
  /** column name */
  PersonCommunicationConsent = 'personCommunicationConsent',
  /** column name */
  PersonDateOfBirth = 'personDateOfBirth',
  /** column name */
  PersonDid = 'personDid',
  /** column name */
  PersonFamilyName = 'personFamilyName',
  /** column name */
  PersonFirstName = 'personFirstName',
  /** column name */
  PersonGender = 'personGender',
  /** column name */
  PersonHandleName = 'personHandleName',
  /** column name */
  PersonLastName = 'personLastName',
  /** column name */
  PersonMasterNftId = 'personMasterNftId',
  /** column name */
  PersonMiddleName = 'personMiddleName',
  /** column name */
  PersonNameSuffix = 'personNameSuffix',
  /** column name */
  PersonParentSigmaId = 'personParentSigmaId',
  /** column name */
  PersonPrimaryAddress1 = 'personPrimaryAddress1',
  /** column name */
  PersonPrimaryAddress2 = 'personPrimaryAddress2',
  /** column name */
  PersonPrimaryBio = 'personPrimaryBio',
  /** column name */
  PersonPrimaryBlogLink = 'personPrimaryBlogLink',
  /** column name */
  PersonPrimaryBooks = 'personPrimaryBooks',
  /** column name */
  PersonPrimaryCity = 'personPrimaryCity',
  /** column name */
  PersonPrimaryCountry = 'personPrimaryCountry',
  /** column name */
  PersonPrimaryEmail = 'personPrimaryEmail',
  /** column name */
  PersonPrimaryEmailIsVerified = 'personPrimaryEmailIsVerified',
  /** column name */
  PersonPrimaryFacePhoto = 'personPrimaryFacePhoto',
  /** column name */
  PersonPrimaryFacebook = 'personPrimaryFacebook',
  /** column name */
  PersonPrimaryGis = 'personPrimaryGis',
  /** column name */
  PersonPrimaryHeaderImage = 'personPrimaryHeaderImage',
  /** column name */
  PersonPrimaryInstagram = 'personPrimaryInstagram',
  /** column name */
  PersonPrimaryIpAddress = 'personPrimaryIpAddress',
  /** column name */
  PersonPrimaryKycStatus = 'personPrimaryKycStatus',
  /** column name */
  PersonPrimaryLanguageId = 'personPrimaryLanguageId',
  /** column name */
  PersonPrimaryLinkedin = 'personPrimaryLinkedin',
  /** column name */
  PersonPrimaryMobile = 'personPrimaryMobile',
  /** column name */
  PersonPrimaryMyersBriggs = 'personPrimaryMyersBriggs',
  /** column name */
  PersonPrimaryPhone = 'personPrimaryPhone',
  /** column name */
  PersonPrimaryPinterest = 'personPrimaryPinterest',
  /** column name */
  PersonPrimaryPostal4 = 'personPrimaryPostal4',
  /** column name */
  PersonPrimaryPostalCode = 'personPrimaryPostalCode',
  /** column name */
  PersonPrimaryProfileDetail = 'personPrimaryProfileDetail',
  /** column name */
  PersonPrimaryProfileMessage = 'personPrimaryProfileMessage',
  /** column name */
  PersonPrimaryProvinceState = 'personPrimaryProvinceState',
  /** column name */
  PersonPrimaryRegionCounty = 'personPrimaryRegionCounty',
  /** column name */
  PersonPrimarySector = 'personPrimarySector',
  /** column name */
  PersonPrimaryTpnUsername = 'personPrimaryTpnUsername',
  /** column name */
  PersonPrimaryTwitter = 'personPrimaryTwitter',
  /** column name */
  PersonPrimaryVideo = 'personPrimaryVideo',
  /** column name */
  PersonPrimaryVueit = 'personPrimaryVueit',
  /** column name */
  PersonPrimaryWebLink = 'personPrimaryWebLink',
  /** column name */
  PersonPrimaryWebList = 'personPrimaryWebList',
  /** column name */
  PersonPrimaryWhy = 'personPrimaryWhy',
  /** column name */
  PersonPrivacyPolicy = 'personPrivacyPolicy',
  /** column name */
  PersonReferredBy = 'personReferredBy',
  /** column name */
  PersonReferredByAffiliateId = 'personReferredByAffiliateId',
  /** column name */
  PersonRelatedCompany = 'personRelatedCompany',
  /** column name */
  PersonRelatedCompanyUrl = 'personRelatedCompanyUrl',
  /** column name */
  PersonSelfPassionName = 'personSelfPassionName',
  /** column name */
  PersonStatus = 'personStatus',
  /** column name */
  PersonTitleName = 'personTitleName',
  /** column name */
  PersonUniversalAffiliateId = 'personUniversalAffiliateId',
  /** column name */
  ProfileId = 'profileId',
  /** column name */
  ProfileSigmaId = 'profileSigmaId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "userData" */
export type UserData_Set_Input = {
  affiliateDashboardUrl?: InputMaybe<Scalars['String']>;
  agreementIsSigned?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  hubspotVid?: InputMaybe<Scalars['numeric']>;
  kycStatus?: InputMaybe<Scalars['String']>;
  ndaIsSigned?: InputMaybe<Scalars['Boolean']>;
  personCommunicationConsent?: InputMaybe<Scalars['Boolean']>;
  personDateOfBirth?: InputMaybe<Scalars['date']>;
  personDid?: InputMaybe<Scalars['String']>;
  personFamilyName?: InputMaybe<Scalars['String']>;
  personFirstName?: InputMaybe<Scalars['String']>;
  personGender?: InputMaybe<Scalars['String']>;
  personHandleName?: InputMaybe<Scalars['String']>;
  personLastName?: InputMaybe<Scalars['String']>;
  personMasterNftId?: InputMaybe<Scalars['String']>;
  personMiddleName?: InputMaybe<Scalars['String']>;
  personNameSuffix?: InputMaybe<Scalars['String']>;
  personParentSigmaId?: InputMaybe<Scalars['uuid']>;
  personPrimaryAddress1?: InputMaybe<Scalars['String']>;
  personPrimaryAddress2?: InputMaybe<Scalars['String']>;
  personPrimaryBio?: InputMaybe<Scalars['String']>;
  personPrimaryBlogLink?: InputMaybe<Scalars['String']>;
  personPrimaryBooks?: InputMaybe<Scalars['String']>;
  personPrimaryCity?: InputMaybe<Scalars['String']>;
  personPrimaryCountry?: InputMaybe<Scalars['String']>;
  personPrimaryEmail?: InputMaybe<Scalars['String']>;
  personPrimaryEmailIsVerified?: InputMaybe<Scalars['Boolean']>;
  personPrimaryFacePhoto?: InputMaybe<Scalars['String']>;
  personPrimaryFacebook?: InputMaybe<Scalars['String']>;
  personPrimaryGis?: InputMaybe<Scalars['point']>;
  personPrimaryHeaderImage?: InputMaybe<Scalars['String']>;
  personPrimaryInstagram?: InputMaybe<Scalars['String']>;
  personPrimaryIpAddress?: InputMaybe<Scalars['String']>;
  personPrimaryKycStatus?: InputMaybe<Scalars['String']>;
  personPrimaryLanguageId?: InputMaybe<Scalars['Int']>;
  personPrimaryLinkedin?: InputMaybe<Scalars['String']>;
  personPrimaryMobile?: InputMaybe<Scalars['String']>;
  personPrimaryMyersBriggs?: InputMaybe<Scalars['String']>;
  personPrimaryPhone?: InputMaybe<Scalars['String']>;
  personPrimaryPinterest?: InputMaybe<Scalars['String']>;
  personPrimaryPostal4?: InputMaybe<Scalars['String']>;
  personPrimaryPostalCode?: InputMaybe<Scalars['String']>;
  personPrimaryProfileDetail?: InputMaybe<Scalars['String']>;
  personPrimaryProfileMessage?: InputMaybe<Scalars['String']>;
  personPrimaryProvinceState?: InputMaybe<Scalars['String']>;
  personPrimaryRegionCounty?: InputMaybe<Scalars['String']>;
  personPrimarySector?: InputMaybe<Scalars['String']>;
  personPrimaryTpnUsername?: InputMaybe<Scalars['String']>;
  personPrimaryTwitter?: InputMaybe<Scalars['String']>;
  personPrimaryVideo?: InputMaybe<Scalars['String']>;
  personPrimaryVueit?: InputMaybe<Scalars['String']>;
  personPrimaryWebLink?: InputMaybe<Scalars['String']>;
  personPrimaryWebList?: InputMaybe<Scalars['String']>;
  personPrimaryWhy?: InputMaybe<Scalars['String']>;
  personPrivacyPolicy?: InputMaybe<Scalars['Boolean']>;
  personReferredBy?: InputMaybe<Scalars['uuid']>;
  personReferredByAffiliateId?: InputMaybe<Scalars['String']>;
  personRelatedCompany?: InputMaybe<Scalars['String']>;
  personRelatedCompanyUrl?: InputMaybe<Scalars['String']>;
  personSelfPassionName?: InputMaybe<Scalars['String']>;
  personStatus?: InputMaybe<Scalars['String']>;
  personTitleName?: InputMaybe<Scalars['String']>;
  personUniversalAffiliateId?: InputMaybe<Scalars['String']>;
  profileId?: InputMaybe<Scalars['uuid']>;
  profileSigmaId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

export type UserData_Set_Input_Custom = {
  affiliateDashboardUrl?: InputMaybe<Scalars['String']>;
  agreementIsSigned?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  hubspotVid?: InputMaybe<Scalars['numeric']>;
  kycStatus?: InputMaybe<Scalars['String']>;
  ndaIsSigned?: InputMaybe<Scalars['Boolean']>;
  personCommunicationConsent?: InputMaybe<Scalars['Boolean']>;
  personDateOfBirth?: InputMaybe<Scalars['date']>;
  personDid?: InputMaybe<Scalars['String']>;
  personFamilyName?: InputMaybe<Scalars['String']>;
  personFirstName?: InputMaybe<Scalars['String']>;
  personGender?: InputMaybe<Scalars['String']>;
  personHandleName?: InputMaybe<Scalars['String']>;
  personLastName?: InputMaybe<Scalars['String']>;
  personMasterNftId?: InputMaybe<Scalars['String']>;
  personMiddleName?: InputMaybe<Scalars['String']>;
  personNameSuffix?: InputMaybe<Scalars['String']>;
  personParentSigmaId?: InputMaybe<Scalars['uuid']>;
  personPrimaryAddress1?: InputMaybe<Scalars['String']>;
  personPrimaryAddress2?: InputMaybe<Scalars['String']>;
  personPrimaryBio?: InputMaybe<Scalars['String']>;
  personPrimaryBlogLink?: InputMaybe<Scalars['String']>;
  personPrimaryBooks?: InputMaybe<Scalars['String']>;
  personPrimaryCity?: InputMaybe<Scalars['String']>;
  personPrimaryCountry?: InputMaybe<Scalars['String']>;
  personPrimaryEmail?: InputMaybe<Scalars['String']>;
  personPrimaryEmailIsVerified?: InputMaybe<Scalars['Boolean']>;
  personPrimaryFacePhoto?: InputMaybe<Scalars['String']>;
  personPrimaryFacebook?: InputMaybe<Scalars['String']>;
  personPrimaryGis?: InputMaybe<Scalars['point']>;
  personPrimaryHeaderImage?: InputMaybe<Scalars['String']>;
  personPrimaryInstagram?: InputMaybe<Scalars['String']>;
  personPrimaryIpAddress?: InputMaybe<Scalars['String']>;
  personPrimaryKycStatus?: InputMaybe<Scalars['String']>;
  personPrimaryLanguageId?: InputMaybe<Scalars['Int']>;
  personPrimaryLinkedin?: InputMaybe<Scalars['String']>;
  personPrimaryMobile?: InputMaybe<Scalars['String']>;
  personPrimaryMyersBriggs?: InputMaybe<Scalars['String']>;
  personPrimaryPhone?: InputMaybe<Scalars['String']>;
  personPrimaryPinterest?: InputMaybe<Scalars['String']>;
  personPrimaryPostal4?: InputMaybe<Scalars['String']>;
  personPrimaryPostalCode?: InputMaybe<Scalars['String']>;
  personPrimaryProfileDetail?: InputMaybe<Scalars['String']>;
  personPrimaryProfileMessage?: InputMaybe<Scalars['String']>;
  personPrimaryProvinceState?: InputMaybe<Scalars['String']>;
  personPrimaryRegionCounty?: InputMaybe<Scalars['String']>;
  personPrimarySector?: InputMaybe<Scalars['String']>;
  personPrimaryTpnUsername?: InputMaybe<Scalars['String']>;
  personPrimaryTwitter?: InputMaybe<Scalars['String']>;
  personPrimaryVideo?: InputMaybe<Scalars['String']>;
  personPrimaryVueit?: InputMaybe<Scalars['String']>;
  personPrimaryWebLink?: InputMaybe<Scalars['String']>;
  personPrimaryWebList?: InputMaybe<Scalars['String']>;
  personPrimaryWhy?: InputMaybe<Scalars['String']>;
  personPrivacyPolicy?: InputMaybe<Scalars['Boolean']>;
  personReferredBy?: InputMaybe<Scalars['uuid']>;
  personReferredByAffiliateId?: InputMaybe<Scalars['String']>;
  personSelfPassionName?: InputMaybe<Scalars['String']>;
  personStatus?: InputMaybe<Scalars['String']>;
  personTitleName?: InputMaybe<Scalars['String']>;
  personUniversalAffiliateId?: InputMaybe<Scalars['String']>;
  profileId?: InputMaybe<Scalars['uuid']>;
  profileSigmaId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type UserData_Stddev_Fields = {
  __typename?: 'userData_stddev_fields';
  hubspotVid: Maybe<Scalars['Float']>;
  personPrimaryLanguageId: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "userData" */
export type UserData_Stddev_Order_By = {
  hubspotVid?: InputMaybe<Order_By>;
  personPrimaryLanguageId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type UserData_Stddev_Pop_Fields = {
  __typename?: 'userData_stddev_pop_fields';
  hubspotVid: Maybe<Scalars['Float']>;
  personPrimaryLanguageId: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "userData" */
export type UserData_Stddev_Pop_Order_By = {
  hubspotVid?: InputMaybe<Order_By>;
  personPrimaryLanguageId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type UserData_Stddev_Samp_Fields = {
  __typename?: 'userData_stddev_samp_fields';
  hubspotVid: Maybe<Scalars['Float']>;
  personPrimaryLanguageId: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "userData" */
export type UserData_Stddev_Samp_Order_By = {
  hubspotVid?: InputMaybe<Order_By>;
  personPrimaryLanguageId?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type UserData_Sum_Fields = {
  __typename?: 'userData_sum_fields';
  hubspotVid: Maybe<Scalars['numeric']>;
  personPrimaryLanguageId: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "userData" */
export type UserData_Sum_Order_By = {
  hubspotVid?: InputMaybe<Order_By>;
  personPrimaryLanguageId?: InputMaybe<Order_By>;
};

/** update columns of table "userData" */
export enum UserData_Update_Column {
  /** column name */
  AffiliateDashboardUrl = 'affiliateDashboardUrl',
  /** column name */
  AgreementIsSigned = 'agreementIsSigned',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  HubspotVid = 'hubspotVid',
  /** column name */
  KycStatus = 'kycStatus',
  /** column name */
  NdaIsSigned = 'ndaIsSigned',
  /** column name */
  PersonCommunicationConsent = 'personCommunicationConsent',
  /** column name */
  PersonDateOfBirth = 'personDateOfBirth',
  /** column name */
  PersonDid = 'personDid',
  /** column name */
  PersonFamilyName = 'personFamilyName',
  /** column name */
  PersonFirstName = 'personFirstName',
  /** column name */
  PersonGender = 'personGender',
  /** column name */
  PersonHandleName = 'personHandleName',
  /** column name */
  PersonLastName = 'personLastName',
  /** column name */
  PersonMasterNftId = 'personMasterNftId',
  /** column name */
  PersonMiddleName = 'personMiddleName',
  /** column name */
  PersonNameSuffix = 'personNameSuffix',
  /** column name */
  PersonParentSigmaId = 'personParentSigmaId',
  /** column name */
  PersonPrimaryAddress1 = 'personPrimaryAddress1',
  /** column name */
  PersonPrimaryAddress2 = 'personPrimaryAddress2',
  /** column name */
  PersonPrimaryBio = 'personPrimaryBio',
  /** column name */
  PersonPrimaryBlogLink = 'personPrimaryBlogLink',
  /** column name */
  PersonPrimaryBooks = 'personPrimaryBooks',
  /** column name */
  PersonPrimaryCity = 'personPrimaryCity',
  /** column name */
  PersonPrimaryCountry = 'personPrimaryCountry',
  /** column name */
  PersonPrimaryEmail = 'personPrimaryEmail',
  /** column name */
  PersonPrimaryEmailIsVerified = 'personPrimaryEmailIsVerified',
  /** column name */
  PersonPrimaryFacePhoto = 'personPrimaryFacePhoto',
  /** column name */
  PersonPrimaryFacebook = 'personPrimaryFacebook',
  /** column name */
  PersonPrimaryGis = 'personPrimaryGis',
  /** column name */
  PersonPrimaryHeaderImage = 'personPrimaryHeaderImage',
  /** column name */
  PersonPrimaryInstagram = 'personPrimaryInstagram',
  /** column name */
  PersonPrimaryIpAddress = 'personPrimaryIpAddress',
  /** column name */
  PersonPrimaryKycStatus = 'personPrimaryKycStatus',
  /** column name */
  PersonPrimaryLanguageId = 'personPrimaryLanguageId',
  /** column name */
  PersonPrimaryLinkedin = 'personPrimaryLinkedin',
  /** column name */
  PersonPrimaryMobile = 'personPrimaryMobile',
  /** column name */
  PersonPrimaryMyersBriggs = 'personPrimaryMyersBriggs',
  /** column name */
  PersonPrimaryPhone = 'personPrimaryPhone',
  /** column name */
  PersonPrimaryPinterest = 'personPrimaryPinterest',
  /** column name */
  PersonPrimaryPostal4 = 'personPrimaryPostal4',
  /** column name */
  PersonPrimaryPostalCode = 'personPrimaryPostalCode',
  /** column name */
  PersonPrimaryProfileDetail = 'personPrimaryProfileDetail',
  /** column name */
  PersonPrimaryProfileMessage = 'personPrimaryProfileMessage',
  /** column name */
  PersonPrimaryProvinceState = 'personPrimaryProvinceState',
  /** column name */
  PersonPrimaryRegionCounty = 'personPrimaryRegionCounty',
  /** column name */
  PersonPrimarySector = 'personPrimarySector',
  /** column name */
  PersonPrimaryTpnUsername = 'personPrimaryTpnUsername',
  /** column name */
  PersonPrimaryTwitter = 'personPrimaryTwitter',
  /** column name */
  PersonPrimaryVideo = 'personPrimaryVideo',
  /** column name */
  PersonPrimaryVueit = 'personPrimaryVueit',
  /** column name */
  PersonPrimaryWebLink = 'personPrimaryWebLink',
  /** column name */
  PersonPrimaryWebList = 'personPrimaryWebList',
  /** column name */
  PersonPrimaryWhy = 'personPrimaryWhy',
  /** column name */
  PersonPrivacyPolicy = 'personPrivacyPolicy',
  /** column name */
  PersonReferredBy = 'personReferredBy',
  /** column name */
  PersonReferredByAffiliateId = 'personReferredByAffiliateId',
  /** column name */
  PersonRelatedCompany = 'personRelatedCompany',
  /** column name */
  PersonRelatedCompanyUrl = 'personRelatedCompanyUrl',
  /** column name */
  PersonSelfPassionName = 'personSelfPassionName',
  /** column name */
  PersonStatus = 'personStatus',
  /** column name */
  PersonTitleName = 'personTitleName',
  /** column name */
  PersonUniversalAffiliateId = 'personUniversalAffiliateId',
  /** column name */
  ProfileId = 'profileId',
  /** column name */
  ProfileSigmaId = 'profileSigmaId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** aggregate var_pop on columns */
export type UserData_Var_Pop_Fields = {
  __typename?: 'userData_var_pop_fields';
  hubspotVid: Maybe<Scalars['Float']>;
  personPrimaryLanguageId: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "userData" */
export type UserData_Var_Pop_Order_By = {
  hubspotVid?: InputMaybe<Order_By>;
  personPrimaryLanguageId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type UserData_Var_Samp_Fields = {
  __typename?: 'userData_var_samp_fields';
  hubspotVid: Maybe<Scalars['Float']>;
  personPrimaryLanguageId: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "userData" */
export type UserData_Var_Samp_Order_By = {
  hubspotVid?: InputMaybe<Order_By>;
  personPrimaryLanguageId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type UserData_Variance_Fields = {
  __typename?: 'userData_variance_fields';
  hubspotVid: Maybe<Scalars['Float']>;
  personPrimaryLanguageId: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "userData" */
export type UserData_Variance_Order_By = {
  hubspotVid?: InputMaybe<Order_By>;
  personPrimaryLanguageId?: InputMaybe<Order_By>;
};

/** columns and relationships of "userDocuments" */
export type UserDocuments = {
  __typename?: 'userDocuments';
  createdAt: Scalars['timestamptz'];
  data: Scalars['jsonb'];
  /** An object relationship */
  document: Documents;
  documentId: Scalars['uuid'];
  id: Scalars['uuid'];
  signedAt: Scalars['timestamptz'];
  updatedAt: Scalars['timestamptz'];
  userId: Scalars['uuid'];
};


/** columns and relationships of "userDocuments" */
export type UserDocumentsDataArgs = {
  path: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "userDocuments" */
export type UserDocuments_Aggregate = {
  __typename?: 'userDocuments_aggregate';
  aggregate: Maybe<UserDocuments_Aggregate_Fields>;
  nodes: Array<UserDocuments>;
};

/** aggregate fields of "userDocuments" */
export type UserDocuments_Aggregate_Fields = {
  __typename?: 'userDocuments_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<UserDocuments_Max_Fields>;
  min: Maybe<UserDocuments_Min_Fields>;
};


/** aggregate fields of "userDocuments" */
export type UserDocuments_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<UserDocuments_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "userDocuments" */
export type UserDocuments_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<UserDocuments_Max_Order_By>;
  min?: InputMaybe<UserDocuments_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type UserDocuments_Append_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "userDocuments" */
export type UserDocuments_Arr_Rel_Insert_Input = {
  data: Array<UserDocuments_Insert_Input>;
  /** on conflict condition */
  on_conflict?: InputMaybe<UserDocuments_On_Conflict>;
};

/** Boolean expression to filter rows from the table "userDocuments". All fields are combined with a logical 'AND'. */
export type UserDocuments_Bool_Exp = {
  _and?: InputMaybe<Array<UserDocuments_Bool_Exp>>;
  _not?: InputMaybe<UserDocuments_Bool_Exp>;
  _or?: InputMaybe<Array<UserDocuments_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  document?: InputMaybe<Documents_Bool_Exp>;
  documentId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  signedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "userDocuments" */
export enum UserDocuments_Constraint {
  /** unique or primary key constraint */
  UserDocumentsPkey = 'userDocuments_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type UserDocuments_Delete_At_Path_Input = {
  data?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type UserDocuments_Delete_Elem_Input = {
  data?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type UserDocuments_Delete_Key_Input = {
  data?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "userDocuments" */
export type UserDocuments_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  data?: InputMaybe<Scalars['jsonb']>;
  document?: InputMaybe<Documents_Obj_Rel_Insert_Input>;
  documentId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  signedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type UserDocuments_Max_Fields = {
  __typename?: 'userDocuments_max_fields';
  createdAt: Maybe<Scalars['timestamptz']>;
  documentId: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  signedAt: Maybe<Scalars['timestamptz']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
  userId: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "userDocuments" */
export type UserDocuments_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  documentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  signedAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type UserDocuments_Min_Fields = {
  __typename?: 'userDocuments_min_fields';
  createdAt: Maybe<Scalars['timestamptz']>;
  documentId: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  signedAt: Maybe<Scalars['timestamptz']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
  userId: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "userDocuments" */
export type UserDocuments_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  documentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  signedAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "userDocuments" */
export type UserDocuments_Mutation_Response = {
  __typename?: 'userDocuments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserDocuments>;
};

/** on conflict condition type for table "userDocuments" */
export type UserDocuments_On_Conflict = {
  constraint: UserDocuments_Constraint;
  update_columns: Array<UserDocuments_Update_Column>;
  where?: InputMaybe<UserDocuments_Bool_Exp>;
};

/** Ordering options when selecting data from "userDocuments". */
export type UserDocuments_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  document?: InputMaybe<Documents_Order_By>;
  documentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  signedAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: userDocuments */
export type UserDocuments_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type UserDocuments_Prepend_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "userDocuments" */
export enum UserDocuments_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Data = 'data',
  /** column name */
  DocumentId = 'documentId',
  /** column name */
  Id = 'id',
  /** column name */
  SignedAt = 'signedAt',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "userDocuments" */
export type UserDocuments_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  data?: InputMaybe<Scalars['jsonb']>;
  documentId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  signedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "userDocuments" */
export enum UserDocuments_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Data = 'data',
  /** column name */
  DocumentId = 'documentId',
  /** column name */
  Id = 'id',
  /** column name */
  SignedAt = 'signedAt',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** columns and relationships of "userIdTypes" */
export type UserIdTypes = {
  __typename?: 'userIdTypes';
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An array relationship */
  userIds: Array<UserIds>;
  /** An aggregate relationship */
  userIds_aggregate: UserIds_Aggregate;
};


/** columns and relationships of "userIdTypes" */
export type UserIdTypesUserIdsArgs = {
  distinct_on: InputMaybe<Array<UserIds_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserIds_Order_By>>;
  where: InputMaybe<UserIds_Bool_Exp>;
};


/** columns and relationships of "userIdTypes" */
export type UserIdTypesUserIds_AggregateArgs = {
  distinct_on: InputMaybe<Array<UserIds_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserIds_Order_By>>;
  where: InputMaybe<UserIds_Bool_Exp>;
};

/** aggregated selection of "userIdTypes" */
export type UserIdTypes_Aggregate = {
  __typename?: 'userIdTypes_aggregate';
  aggregate: Maybe<UserIdTypes_Aggregate_Fields>;
  nodes: Array<UserIdTypes>;
};

/** aggregate fields of "userIdTypes" */
export type UserIdTypes_Aggregate_Fields = {
  __typename?: 'userIdTypes_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<UserIdTypes_Max_Fields>;
  min: Maybe<UserIdTypes_Min_Fields>;
};


/** aggregate fields of "userIdTypes" */
export type UserIdTypes_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<UserIdTypes_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "userIdTypes". All fields are combined with a logical 'AND'. */
export type UserIdTypes_Bool_Exp = {
  _and?: InputMaybe<Array<UserIdTypes_Bool_Exp>>;
  _not?: InputMaybe<UserIdTypes_Bool_Exp>;
  _or?: InputMaybe<Array<UserIdTypes_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  userIds?: InputMaybe<UserIds_Bool_Exp>;
};

/** unique or primary key constraints on table "userIdTypes" */
export enum UserIdTypes_Constraint {
  /** unique or primary key constraint */
  UserIdTypesPkey = 'userIdTypes_pkey'
}

/** input type for inserting data into table "userIdTypes" */
export type UserIdTypes_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  userIds?: InputMaybe<UserIds_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type UserIdTypes_Max_Fields = {
  __typename?: 'userIdTypes_max_fields';
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type UserIdTypes_Min_Fields = {
  __typename?: 'userIdTypes_min_fields';
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "userIdTypes" */
export type UserIdTypes_Mutation_Response = {
  __typename?: 'userIdTypes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserIdTypes>;
};

/** input type for inserting object relation for remote table "userIdTypes" */
export type UserIdTypes_Obj_Rel_Insert_Input = {
  data: UserIdTypes_Insert_Input;
  /** on conflict condition */
  on_conflict?: InputMaybe<UserIdTypes_On_Conflict>;
};

/** on conflict condition type for table "userIdTypes" */
export type UserIdTypes_On_Conflict = {
  constraint: UserIdTypes_Constraint;
  update_columns: Array<UserIdTypes_Update_Column>;
  where?: InputMaybe<UserIdTypes_Bool_Exp>;
};

/** Ordering options when selecting data from "userIdTypes". */
export type UserIdTypes_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  userIds_aggregate?: InputMaybe<UserIds_Aggregate_Order_By>;
};

/** primary key columns input for table: userIdTypes */
export type UserIdTypes_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "userIdTypes" */
export enum UserIdTypes_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "userIdTypes" */
export type UserIdTypes_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "userIdTypes" */
export enum UserIdTypes_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** columns and relationships of "userIds" */
export type UserIds = {
  __typename?: 'userIds';
  country: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  state: Maybe<Scalars['String']>;
  typeId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  userData: UserData;
  userId: Scalars['uuid'];
  /** An object relationship */
  userIdType: UserIdTypes;
  value: Scalars['String'];
};

/** aggregated selection of "userIds" */
export type UserIds_Aggregate = {
  __typename?: 'userIds_aggregate';
  aggregate: Maybe<UserIds_Aggregate_Fields>;
  nodes: Array<UserIds>;
};

/** aggregate fields of "userIds" */
export type UserIds_Aggregate_Fields = {
  __typename?: 'userIds_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<UserIds_Max_Fields>;
  min: Maybe<UserIds_Min_Fields>;
};


/** aggregate fields of "userIds" */
export type UserIds_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<UserIds_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "userIds" */
export type UserIds_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<UserIds_Max_Order_By>;
  min?: InputMaybe<UserIds_Min_Order_By>;
};

/** input type for inserting array relation for remote table "userIds" */
export type UserIds_Arr_Rel_Insert_Input = {
  data: Array<UserIds_Insert_Input>;
};

/** Boolean expression to filter rows from the table "userIds". All fields are combined with a logical 'AND'. */
export type UserIds_Bool_Exp = {
  _and?: InputMaybe<Array<UserIds_Bool_Exp>>;
  _not?: InputMaybe<UserIds_Bool_Exp>;
  _or?: InputMaybe<Array<UserIds_Bool_Exp>>;
  country?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  typeId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userData?: InputMaybe<UserData_Bool_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
  userIdType?: InputMaybe<UserIdTypes_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** input type for inserting data into table "userIds" */
export type UserIds_Insert_Input = {
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  typeId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userData?: InputMaybe<UserData_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['uuid']>;
  userIdType?: InputMaybe<UserIdTypes_Obj_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type UserIds_Max_Fields = {
  __typename?: 'userIds_max_fields';
  country: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['timestamptz']>;
  id: Maybe<Scalars['uuid']>;
  state: Maybe<Scalars['String']>;
  typeId: Maybe<Scalars['uuid']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
  userId: Maybe<Scalars['uuid']>;
  value: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "userIds" */
export type UserIds_Max_Order_By = {
  country?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  typeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type UserIds_Min_Fields = {
  __typename?: 'userIds_min_fields';
  country: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['timestamptz']>;
  id: Maybe<Scalars['uuid']>;
  state: Maybe<Scalars['String']>;
  typeId: Maybe<Scalars['uuid']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
  userId: Maybe<Scalars['uuid']>;
  value: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "userIds" */
export type UserIds_Min_Order_By = {
  country?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  typeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "userIds" */
export type UserIds_Mutation_Response = {
  __typename?: 'userIds_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserIds>;
};

/** Ordering options when selecting data from "userIds". */
export type UserIds_Order_By = {
  country?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  typeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userData?: InputMaybe<UserData_Order_By>;
  userId?: InputMaybe<Order_By>;
  userIdType?: InputMaybe<UserIdTypes_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "userIds" */
export enum UserIds_Select_Column {
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  State = 'state',
  /** column name */
  TypeId = 'typeId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "userIds" */
export type UserIds_Set_Input = {
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  typeId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
  value?: InputMaybe<Scalars['String']>;
};

export type UserRoleRequestByNameInput = {
  exchangeName: Scalars['String'];
  roleName: Scalars['String'];
};

/** columns and relationships of "userRoleRequests" */
export type UserRoleRequests = {
  __typename?: 'userRoleRequests';
  agreementIsSigned: Scalars['Boolean'];
  approvedAt: Maybe<Scalars['timestamptz']>;
  approvedById: Maybe<Scalars['uuid']>;
  /** An object relationship */
  approver: Maybe<Users>;
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  enrolledExchange: Maybe<Exchanges>;
  enrolledExchangeId: Maybe<Scalars['uuid']>;
  /** An object relationship */
  enrolledRole: Maybe<Roles>;
  enrolledRoleId: Maybe<Scalars['uuid']>;
  /** An object relationship */
  exchange: Exchanges;
  exchangeId: Scalars['uuid'];
  hubSpotDealId: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  isApproved: Scalars['Boolean'];
  /** An array relationship */
  payments: Array<Payments>;
  /** An aggregate relationship */
  payments_aggregate: Payments_Aggregate;
  /** An object relationship */
  role: Roles;
  roleId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
};


/** columns and relationships of "userRoleRequests" */
export type UserRoleRequestsPaymentsArgs = {
  distinct_on: InputMaybe<Array<Payments_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Payments_Order_By>>;
  where: InputMaybe<Payments_Bool_Exp>;
};


/** columns and relationships of "userRoleRequests" */
export type UserRoleRequestsPayments_AggregateArgs = {
  distinct_on: InputMaybe<Array<Payments_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Payments_Order_By>>;
  where: InputMaybe<Payments_Bool_Exp>;
};

/** aggregated selection of "userRoleRequests" */
export type UserRoleRequests_Aggregate = {
  __typename?: 'userRoleRequests_aggregate';
  aggregate: Maybe<UserRoleRequests_Aggregate_Fields>;
  nodes: Array<UserRoleRequests>;
};

/** aggregate fields of "userRoleRequests" */
export type UserRoleRequests_Aggregate_Fields = {
  __typename?: 'userRoleRequests_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<UserRoleRequests_Max_Fields>;
  min: Maybe<UserRoleRequests_Min_Fields>;
};


/** aggregate fields of "userRoleRequests" */
export type UserRoleRequests_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<UserRoleRequests_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "userRoleRequests" */
export type UserRoleRequests_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<UserRoleRequests_Max_Order_By>;
  min?: InputMaybe<UserRoleRequests_Min_Order_By>;
};

/** input type for inserting array relation for remote table "userRoleRequests" */
export type UserRoleRequests_Arr_Rel_Insert_Input = {
  data: Array<UserRoleRequests_Insert_Input>;
  /** on conflict condition */
  on_conflict?: InputMaybe<UserRoleRequests_On_Conflict>;
};

/** Boolean expression to filter rows from the table "userRoleRequests". All fields are combined with a logical 'AND'. */
export type UserRoleRequests_Bool_Exp = {
  _and?: InputMaybe<Array<UserRoleRequests_Bool_Exp>>;
  _not?: InputMaybe<UserRoleRequests_Bool_Exp>;
  _or?: InputMaybe<Array<UserRoleRequests_Bool_Exp>>;
  agreementIsSigned?: InputMaybe<Boolean_Comparison_Exp>;
  approvedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  approvedById?: InputMaybe<Uuid_Comparison_Exp>;
  approver?: InputMaybe<Users_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  enrolledExchange?: InputMaybe<Exchanges_Bool_Exp>;
  enrolledExchangeId?: InputMaybe<Uuid_Comparison_Exp>;
  enrolledRole?: InputMaybe<Roles_Bool_Exp>;
  enrolledRoleId?: InputMaybe<Uuid_Comparison_Exp>;
  exchange?: InputMaybe<Exchanges_Bool_Exp>;
  exchangeId?: InputMaybe<Uuid_Comparison_Exp>;
  hubSpotDealId?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isApproved?: InputMaybe<Boolean_Comparison_Exp>;
  payments?: InputMaybe<Payments_Bool_Exp>;
  role?: InputMaybe<Roles_Bool_Exp>;
  roleId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "userRoleRequests" */
export enum UserRoleRequests_Constraint {
  /** unique or primary key constraint */
  UserRoleRequestsPkey = 'userRoleRequests_pkey',
  /** unique or primary key constraint */
  UserRoleRequestsUserIdRoleIdExchangeIdKey = 'userRoleRequests_userId_roleId_exchangeId_key'
}

/** input type for inserting data into table "userRoleRequests" */
export type UserRoleRequests_Insert_Input = {
  agreementIsSigned?: InputMaybe<Scalars['Boolean']>;
  approvedAt?: InputMaybe<Scalars['timestamptz']>;
  approvedById?: InputMaybe<Scalars['uuid']>;
  approver?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  enrolledExchange?: InputMaybe<Exchanges_Obj_Rel_Insert_Input>;
  enrolledExchangeId?: InputMaybe<Scalars['uuid']>;
  enrolledRole?: InputMaybe<Roles_Obj_Rel_Insert_Input>;
  enrolledRoleId?: InputMaybe<Scalars['uuid']>;
  exchange?: InputMaybe<Exchanges_Obj_Rel_Insert_Input>;
  exchangeId?: InputMaybe<Scalars['uuid']>;
  hubSpotDealId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isApproved?: InputMaybe<Scalars['Boolean']>;
  payments?: InputMaybe<Payments_Arr_Rel_Insert_Input>;
  role?: InputMaybe<Roles_Obj_Rel_Insert_Input>;
  roleId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type UserRoleRequests_Max_Fields = {
  __typename?: 'userRoleRequests_max_fields';
  approvedAt: Maybe<Scalars['timestamptz']>;
  approvedById: Maybe<Scalars['uuid']>;
  createdAt: Maybe<Scalars['timestamptz']>;
  enrolledExchangeId: Maybe<Scalars['uuid']>;
  enrolledRoleId: Maybe<Scalars['uuid']>;
  exchangeId: Maybe<Scalars['uuid']>;
  hubSpotDealId: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  roleId: Maybe<Scalars['uuid']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
  userId: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "userRoleRequests" */
export type UserRoleRequests_Max_Order_By = {
  approvedAt?: InputMaybe<Order_By>;
  approvedById?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  enrolledExchangeId?: InputMaybe<Order_By>;
  enrolledRoleId?: InputMaybe<Order_By>;
  exchangeId?: InputMaybe<Order_By>;
  hubSpotDealId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  roleId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type UserRoleRequests_Min_Fields = {
  __typename?: 'userRoleRequests_min_fields';
  approvedAt: Maybe<Scalars['timestamptz']>;
  approvedById: Maybe<Scalars['uuid']>;
  createdAt: Maybe<Scalars['timestamptz']>;
  enrolledExchangeId: Maybe<Scalars['uuid']>;
  enrolledRoleId: Maybe<Scalars['uuid']>;
  exchangeId: Maybe<Scalars['uuid']>;
  hubSpotDealId: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  roleId: Maybe<Scalars['uuid']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
  userId: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "userRoleRequests" */
export type UserRoleRequests_Min_Order_By = {
  approvedAt?: InputMaybe<Order_By>;
  approvedById?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  enrolledExchangeId?: InputMaybe<Order_By>;
  enrolledRoleId?: InputMaybe<Order_By>;
  exchangeId?: InputMaybe<Order_By>;
  hubSpotDealId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  roleId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "userRoleRequests" */
export type UserRoleRequests_Mutation_Response = {
  __typename?: 'userRoleRequests_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserRoleRequests>;
};

/** on conflict condition type for table "userRoleRequests" */
export type UserRoleRequests_On_Conflict = {
  constraint: UserRoleRequests_Constraint;
  update_columns: Array<UserRoleRequests_Update_Column>;
  where?: InputMaybe<UserRoleRequests_Bool_Exp>;
};

/** Ordering options when selecting data from "userRoleRequests". */
export type UserRoleRequests_Order_By = {
  agreementIsSigned?: InputMaybe<Order_By>;
  approvedAt?: InputMaybe<Order_By>;
  approvedById?: InputMaybe<Order_By>;
  approver?: InputMaybe<Users_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  enrolledExchange?: InputMaybe<Exchanges_Order_By>;
  enrolledExchangeId?: InputMaybe<Order_By>;
  enrolledRole?: InputMaybe<Roles_Order_By>;
  enrolledRoleId?: InputMaybe<Order_By>;
  exchange?: InputMaybe<Exchanges_Order_By>;
  exchangeId?: InputMaybe<Order_By>;
  hubSpotDealId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isApproved?: InputMaybe<Order_By>;
  payments_aggregate?: InputMaybe<Payments_Aggregate_Order_By>;
  role?: InputMaybe<Roles_Order_By>;
  roleId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: userRoleRequests */
export type UserRoleRequests_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "userRoleRequests" */
export enum UserRoleRequests_Select_Column {
  /** column name */
  AgreementIsSigned = 'agreementIsSigned',
  /** column name */
  ApprovedAt = 'approvedAt',
  /** column name */
  ApprovedById = 'approvedById',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EnrolledExchangeId = 'enrolledExchangeId',
  /** column name */
  EnrolledRoleId = 'enrolledRoleId',
  /** column name */
  ExchangeId = 'exchangeId',
  /** column name */
  HubSpotDealId = 'hubSpotDealId',
  /** column name */
  Id = 'id',
  /** column name */
  IsApproved = 'isApproved',
  /** column name */
  RoleId = 'roleId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "userRoleRequests" */
export type UserRoleRequests_Set_Input = {
  agreementIsSigned?: InputMaybe<Scalars['Boolean']>;
  approvedAt?: InputMaybe<Scalars['timestamptz']>;
  approvedById?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  enrolledExchangeId?: InputMaybe<Scalars['uuid']>;
  enrolledRoleId?: InputMaybe<Scalars['uuid']>;
  exchangeId?: InputMaybe<Scalars['uuid']>;
  hubSpotDealId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isApproved?: InputMaybe<Scalars['Boolean']>;
  roleId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "userRoleRequests" */
export enum UserRoleRequests_Update_Column {
  /** column name */
  AgreementIsSigned = 'agreementIsSigned',
  /** column name */
  ApprovedAt = 'approvedAt',
  /** column name */
  ApprovedById = 'approvedById',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EnrolledExchangeId = 'enrolledExchangeId',
  /** column name */
  EnrolledRoleId = 'enrolledRoleId',
  /** column name */
  ExchangeId = 'exchangeId',
  /** column name */
  HubSpotDealId = 'hubSpotDealId',
  /** column name */
  Id = 'id',
  /** column name */
  IsApproved = 'isApproved',
  /** column name */
  RoleId = 'roleId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** columns and relationships of "userRoles" */
export type UserRoles = {
  __typename?: 'userRoles';
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  exchange: Exchanges;
  exchangeId: Scalars['uuid'];
  hubSpotDealId: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  /** An object relationship */
  role: Roles;
  roleId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
};

/** columns and relationships of "userRolesView" */
export type UserRolesView = {
  __typename?: 'userRolesView';
  createdAt: Maybe<Scalars['timestamptz']>;
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
  userId: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "userRolesView" */
export type UserRolesView_Aggregate = {
  __typename?: 'userRolesView_aggregate';
  aggregate: Maybe<UserRolesView_Aggregate_Fields>;
  nodes: Array<UserRolesView>;
};

/** aggregate fields of "userRolesView" */
export type UserRolesView_Aggregate_Fields = {
  __typename?: 'userRolesView_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<UserRolesView_Max_Fields>;
  min: Maybe<UserRolesView_Min_Fields>;
};


/** aggregate fields of "userRolesView" */
export type UserRolesView_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<UserRolesView_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "userRolesView" */
export type UserRolesView_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<UserRolesView_Max_Order_By>;
  min?: InputMaybe<UserRolesView_Min_Order_By>;
};

/** input type for inserting array relation for remote table "userRolesView" */
export type UserRolesView_Arr_Rel_Insert_Input = {
  data: Array<UserRolesView_Insert_Input>;
};

/** Boolean expression to filter rows from the table "userRolesView". All fields are combined with a logical 'AND'. */
export type UserRolesView_Bool_Exp = {
  _and?: InputMaybe<Array<UserRolesView_Bool_Exp>>;
  _not?: InputMaybe<UserRolesView_Bool_Exp>;
  _or?: InputMaybe<Array<UserRolesView_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** input type for inserting data into table "userRolesView" */
export type UserRolesView_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type UserRolesView_Max_Fields = {
  __typename?: 'userRolesView_max_fields';
  createdAt: Maybe<Scalars['timestamptz']>;
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
  userId: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "userRolesView" */
export type UserRolesView_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type UserRolesView_Min_Fields = {
  __typename?: 'userRolesView_min_fields';
  createdAt: Maybe<Scalars['timestamptz']>;
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
  userId: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "userRolesView" */
export type UserRolesView_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "userRolesView". */
export type UserRolesView_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** select columns of table "userRolesView" */
export enum UserRolesView_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** aggregated selection of "userRoles" */
export type UserRoles_Aggregate = {
  __typename?: 'userRoles_aggregate';
  aggregate: Maybe<UserRoles_Aggregate_Fields>;
  nodes: Array<UserRoles>;
};

/** aggregate fields of "userRoles" */
export type UserRoles_Aggregate_Fields = {
  __typename?: 'userRoles_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<UserRoles_Max_Fields>;
  min: Maybe<UserRoles_Min_Fields>;
};


/** aggregate fields of "userRoles" */
export type UserRoles_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<UserRoles_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "userRoles" */
export type UserRoles_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<UserRoles_Max_Order_By>;
  min?: InputMaybe<UserRoles_Min_Order_By>;
};

/** input type for inserting array relation for remote table "userRoles" */
export type UserRoles_Arr_Rel_Insert_Input = {
  data: Array<UserRoles_Insert_Input>;
  /** on conflict condition */
  on_conflict?: InputMaybe<UserRoles_On_Conflict>;
};

/** Boolean expression to filter rows from the table "userRoles". All fields are combined with a logical 'AND'. */
export type UserRoles_Bool_Exp = {
  _and?: InputMaybe<Array<UserRoles_Bool_Exp>>;
  _not?: InputMaybe<UserRoles_Bool_Exp>;
  _or?: InputMaybe<Array<UserRoles_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  exchange?: InputMaybe<Exchanges_Bool_Exp>;
  exchangeId?: InputMaybe<Uuid_Comparison_Exp>;
  hubSpotDealId?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  role?: InputMaybe<Roles_Bool_Exp>;
  roleId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "userRoles" */
export enum UserRoles_Constraint {
  /** unique or primary key constraint */
  UserRolesPkey = 'userRoles_pkey',
  /** unique or primary key constraint */
  UserRolesUserIdRoleIdExchangeIdKey = 'userRoles_userId_roleId_exchangeId_key'
}

/** input type for inserting data into table "userRoles" */
export type UserRoles_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  exchange?: InputMaybe<Exchanges_Obj_Rel_Insert_Input>;
  exchangeId?: InputMaybe<Scalars['uuid']>;
  hubSpotDealId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  role?: InputMaybe<Roles_Obj_Rel_Insert_Input>;
  roleId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type UserRoles_Max_Fields = {
  __typename?: 'userRoles_max_fields';
  createdAt: Maybe<Scalars['timestamptz']>;
  exchangeId: Maybe<Scalars['uuid']>;
  hubSpotDealId: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  roleId: Maybe<Scalars['uuid']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
  userId: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "userRoles" */
export type UserRoles_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  exchangeId?: InputMaybe<Order_By>;
  hubSpotDealId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  roleId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type UserRoles_Min_Fields = {
  __typename?: 'userRoles_min_fields';
  createdAt: Maybe<Scalars['timestamptz']>;
  exchangeId: Maybe<Scalars['uuid']>;
  hubSpotDealId: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  roleId: Maybe<Scalars['uuid']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
  userId: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "userRoles" */
export type UserRoles_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  exchangeId?: InputMaybe<Order_By>;
  hubSpotDealId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  roleId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "userRoles" */
export type UserRoles_Mutation_Response = {
  __typename?: 'userRoles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserRoles>;
};

/** on conflict condition type for table "userRoles" */
export type UserRoles_On_Conflict = {
  constraint: UserRoles_Constraint;
  update_columns: Array<UserRoles_Update_Column>;
  where?: InputMaybe<UserRoles_Bool_Exp>;
};

/** Ordering options when selecting data from "userRoles". */
export type UserRoles_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  exchange?: InputMaybe<Exchanges_Order_By>;
  exchangeId?: InputMaybe<Order_By>;
  hubSpotDealId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role?: InputMaybe<Roles_Order_By>;
  roleId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: userRoles */
export type UserRoles_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "userRoles" */
export enum UserRoles_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExchangeId = 'exchangeId',
  /** column name */
  HubSpotDealId = 'hubSpotDealId',
  /** column name */
  Id = 'id',
  /** column name */
  RoleId = 'roleId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "userRoles" */
export type UserRoles_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  exchangeId?: InputMaybe<Scalars['uuid']>;
  hubSpotDealId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  roleId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "userRoles" */
export enum UserRoles_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExchangeId = 'exchangeId',
  /** column name */
  HubSpotDealId = 'hubSpotDealId',
  /** column name */
  Id = 'id',
  /** column name */
  RoleId = 'roleId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** columns and relationships of "userRuleValues" */
export type UserRuleValues = {
  __typename?: 'userRuleValues';
  createdAt: Scalars['timestamptz'];
  data: Scalars['jsonb'];
  id: Scalars['uuid'];
  /** An object relationship */
  rule: Rules;
  ruleId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
};


/** columns and relationships of "userRuleValues" */
export type UserRuleValuesDataArgs = {
  path: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "userRuleValues" */
export type UserRuleValues_Aggregate = {
  __typename?: 'userRuleValues_aggregate';
  aggregate: Maybe<UserRuleValues_Aggregate_Fields>;
  nodes: Array<UserRuleValues>;
};

/** aggregate fields of "userRuleValues" */
export type UserRuleValues_Aggregate_Fields = {
  __typename?: 'userRuleValues_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<UserRuleValues_Max_Fields>;
  min: Maybe<UserRuleValues_Min_Fields>;
};


/** aggregate fields of "userRuleValues" */
export type UserRuleValues_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<UserRuleValues_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "userRuleValues" */
export type UserRuleValues_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<UserRuleValues_Max_Order_By>;
  min?: InputMaybe<UserRuleValues_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type UserRuleValues_Append_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "userRuleValues" */
export type UserRuleValues_Arr_Rel_Insert_Input = {
  data: Array<UserRuleValues_Insert_Input>;
  /** on conflict condition */
  on_conflict?: InputMaybe<UserRuleValues_On_Conflict>;
};

/** Boolean expression to filter rows from the table "userRuleValues". All fields are combined with a logical 'AND'. */
export type UserRuleValues_Bool_Exp = {
  _and?: InputMaybe<Array<UserRuleValues_Bool_Exp>>;
  _not?: InputMaybe<UserRuleValues_Bool_Exp>;
  _or?: InputMaybe<Array<UserRuleValues_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  rule?: InputMaybe<Rules_Bool_Exp>;
  ruleId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "userRuleValues" */
export enum UserRuleValues_Constraint {
  /** unique or primary key constraint */
  UserRuleValuesPkey = 'userRuleValues_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type UserRuleValues_Delete_At_Path_Input = {
  data?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type UserRuleValues_Delete_Elem_Input = {
  data?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type UserRuleValues_Delete_Key_Input = {
  data?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "userRuleValues" */
export type UserRuleValues_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  rule?: InputMaybe<Rules_Obj_Rel_Insert_Input>;
  ruleId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type UserRuleValues_Max_Fields = {
  __typename?: 'userRuleValues_max_fields';
  createdAt: Maybe<Scalars['timestamptz']>;
  id: Maybe<Scalars['uuid']>;
  ruleId: Maybe<Scalars['uuid']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
  userId: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "userRuleValues" */
export type UserRuleValues_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ruleId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type UserRuleValues_Min_Fields = {
  __typename?: 'userRuleValues_min_fields';
  createdAt: Maybe<Scalars['timestamptz']>;
  id: Maybe<Scalars['uuid']>;
  ruleId: Maybe<Scalars['uuid']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
  userId: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "userRuleValues" */
export type UserRuleValues_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ruleId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "userRuleValues" */
export type UserRuleValues_Mutation_Response = {
  __typename?: 'userRuleValues_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserRuleValues>;
};

/** on conflict condition type for table "userRuleValues" */
export type UserRuleValues_On_Conflict = {
  constraint: UserRuleValues_Constraint;
  update_columns: Array<UserRuleValues_Update_Column>;
  where?: InputMaybe<UserRuleValues_Bool_Exp>;
};

/** Ordering options when selecting data from "userRuleValues". */
export type UserRuleValues_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rule?: InputMaybe<Rules_Order_By>;
  ruleId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: userRuleValues */
export type UserRuleValues_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type UserRuleValues_Prepend_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "userRuleValues" */
export enum UserRuleValues_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  RuleId = 'ruleId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "userRuleValues" */
export type UserRuleValues_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  ruleId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "userRuleValues" */
export enum UserRuleValues_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  RuleId = 'ruleId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** columns and relationships of "userRules" */
export type UserRules = {
  __typename?: 'userRules';
  createdAt: Maybe<Scalars['timestamptz']>;
  data: Maybe<Scalars['jsonb']>;
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  /** An object relationship */
  role: Maybe<Roles>;
  roleId: Maybe<Scalars['uuid']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
  userId: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "userRules" */
export type UserRulesDataArgs = {
  path: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "userRules" */
export type UserRules_Aggregate = {
  __typename?: 'userRules_aggregate';
  aggregate: Maybe<UserRules_Aggregate_Fields>;
  nodes: Array<UserRules>;
};

/** aggregate fields of "userRules" */
export type UserRules_Aggregate_Fields = {
  __typename?: 'userRules_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<UserRules_Max_Fields>;
  min: Maybe<UserRules_Min_Fields>;
};


/** aggregate fields of "userRules" */
export type UserRules_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<UserRules_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "userRules" */
export type UserRules_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<UserRules_Max_Order_By>;
  min?: InputMaybe<UserRules_Min_Order_By>;
};

/** input type for inserting array relation for remote table "userRules" */
export type UserRules_Arr_Rel_Insert_Input = {
  data: Array<UserRules_Insert_Input>;
};

/** Boolean expression to filter rows from the table "userRules". All fields are combined with a logical 'AND'. */
export type UserRules_Bool_Exp = {
  _and?: InputMaybe<Array<UserRules_Bool_Exp>>;
  _not?: InputMaybe<UserRules_Bool_Exp>;
  _or?: InputMaybe<Array<UserRules_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  role?: InputMaybe<Roles_Bool_Exp>;
  roleId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** input type for inserting data into table "userRules" */
export type UserRules_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Roles_Obj_Rel_Insert_Input>;
  roleId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type UserRules_Max_Fields = {
  __typename?: 'userRules_max_fields';
  createdAt: Maybe<Scalars['timestamptz']>;
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  roleId: Maybe<Scalars['uuid']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
  userId: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "userRules" */
export type UserRules_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  roleId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type UserRules_Min_Fields = {
  __typename?: 'userRules_min_fields';
  createdAt: Maybe<Scalars['timestamptz']>;
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  roleId: Maybe<Scalars['uuid']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
  userId: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "userRules" */
export type UserRules_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  roleId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "userRules". */
export type UserRules_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  role?: InputMaybe<Roles_Order_By>;
  roleId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** select columns of table "userRules" */
export enum UserRules_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  RoleId = 'roleId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** columns and relationships of "users" */
export type Users = {
  __typename?: 'users';
  /** An array relationship */
  apiKeys: Array<ApiKeys>;
  /** An aggregate relationship */
  apiKeys_aggregate: ApiKeys_Aggregate;
  auth0Data: Scalars['jsonb'];
  createdAt: Scalars['timestamptz'];
  /** An array relationship */
  devices: Array<Devices>;
  /** An aggregate relationship */
  devices_aggregate: Devices_Aggregate;
  /** A computed field, executes function "get_users_userdocuments_count" */
  documentCount: Maybe<Scalars['Int']>;
  email: Scalars['String'];
  id: Scalars['uuid'];
  /** An array relationship */
  leadLocksAdmin: Array<LeadLocks>;
  /** An aggregate relationship */
  leadLocksAdmin_aggregate: LeadLocks_Aggregate;
  /** An array relationship */
  leadLocksGranted: Array<LeadLocks>;
  /** An aggregate relationship */
  leadLocksGranted_aggregate: LeadLocks_Aggregate;
  /** An array relationship */
  leadsHistories: Array<LeadsHistory>;
  /** An aggregate relationship */
  leadsHistories_aggregate: LeadsHistory_Aggregate;
  /** An array relationship */
  logTraces: Array<LogTraces>;
  /** An aggregate relationship */
  logTraces_aggregate: LogTraces_Aggregate;
  /** An array relationship */
  logs: Array<Logs>;
  /** An aggregate relationship */
  logs_aggregate: Logs_Aggregate;
  name: Maybe<Scalars['String']>;
  /** An array relationship */
  payments: Array<Payments>;
  /** A computed field, executes function "get_users_payments_total" */
  paymentsTotal: Maybe<Scalars['Int']>;
  /** An aggregate relationship */
  payments_aggregate: Payments_Aggregate;
  /** An array relationship */
  referrals: Array<Users>;
  /** An aggregate relationship */
  referrals_aggregate: Users_Aggregate;
  /** An object relationship */
  referrer: Maybe<Users>;
  referrerId: Maybe<Scalars['uuid']>;
  /** An array relationship */
  roles: Array<UserRolesView>;
  /** An aggregate relationship */
  roles_aggregate: UserRolesView_Aggregate;
  /** An array relationship */
  ruleValues: Array<UserRuleValues>;
  /** An aggregate relationship */
  ruleValues_aggregate: UserRuleValues_Aggregate;
  /** An array relationship */
  rules: Array<UserRules>;
  /** An aggregate relationship */
  rules_aggregate: UserRules_Aggregate;
  /** An object relationship */
  sigmaPrime: Maybe<UserData>;
  updatedAt: Scalars['timestamptz'];
  /** An array relationship */
  userData: Array<UserData>;
  /** An aggregate relationship */
  userData_aggregate: UserData_Aggregate;
  /** An array relationship */
  userDocuments: Array<UserDocuments>;
  /** An aggregate relationship */
  userDocuments_aggregate: UserDocuments_Aggregate;
  /** An array relationship */
  userRoleRequestApprovals: Array<UserRoleRequests>;
  /** An aggregate relationship */
  userRoleRequestApprovals_aggregate: UserRoleRequests_Aggregate;
  /** An array relationship */
  userRoleRequests: Array<UserRoleRequests>;
  /** An aggregate relationship */
  userRoleRequests_aggregate: UserRoleRequests_Aggregate;
  /** An array relationship */
  userRoles: Array<UserRoles>;
  /** An aggregate relationship */
  userRoles_aggregate: UserRoles_Aggregate;
};


/** columns and relationships of "users" */
export type UsersApiKeysArgs = {
  distinct_on: InputMaybe<Array<ApiKeys_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<ApiKeys_Order_By>>;
  where: InputMaybe<ApiKeys_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersApiKeys_AggregateArgs = {
  distinct_on: InputMaybe<Array<ApiKeys_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<ApiKeys_Order_By>>;
  where: InputMaybe<ApiKeys_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersAuth0DataArgs = {
  path: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "users" */
export type UsersDevicesArgs = {
  distinct_on: InputMaybe<Array<Devices_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Devices_Order_By>>;
  where: InputMaybe<Devices_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersDevices_AggregateArgs = {
  distinct_on: InputMaybe<Array<Devices_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Devices_Order_By>>;
  where: InputMaybe<Devices_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersLeadLocksAdminArgs = {
  distinct_on: InputMaybe<Array<LeadLocks_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<LeadLocks_Order_By>>;
  where: InputMaybe<LeadLocks_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersLeadLocksAdmin_AggregateArgs = {
  distinct_on: InputMaybe<Array<LeadLocks_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<LeadLocks_Order_By>>;
  where: InputMaybe<LeadLocks_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersLeadLocksGrantedArgs = {
  distinct_on: InputMaybe<Array<LeadLocks_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<LeadLocks_Order_By>>;
  where: InputMaybe<LeadLocks_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersLeadLocksGranted_AggregateArgs = {
  distinct_on: InputMaybe<Array<LeadLocks_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<LeadLocks_Order_By>>;
  where: InputMaybe<LeadLocks_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersLeadsHistoriesArgs = {
  distinct_on: InputMaybe<Array<LeadsHistory_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<LeadsHistory_Order_By>>;
  where: InputMaybe<LeadsHistory_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersLeadsHistories_AggregateArgs = {
  distinct_on: InputMaybe<Array<LeadsHistory_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<LeadsHistory_Order_By>>;
  where: InputMaybe<LeadsHistory_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersLogTracesArgs = {
  distinct_on: InputMaybe<Array<LogTraces_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<LogTraces_Order_By>>;
  where: InputMaybe<LogTraces_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersLogTraces_AggregateArgs = {
  distinct_on: InputMaybe<Array<LogTraces_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<LogTraces_Order_By>>;
  where: InputMaybe<LogTraces_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersLogsArgs = {
  distinct_on: InputMaybe<Array<Logs_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Logs_Order_By>>;
  where: InputMaybe<Logs_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersLogs_AggregateArgs = {
  distinct_on: InputMaybe<Array<Logs_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Logs_Order_By>>;
  where: InputMaybe<Logs_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPaymentsArgs = {
  distinct_on: InputMaybe<Array<Payments_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Payments_Order_By>>;
  where: InputMaybe<Payments_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPayments_AggregateArgs = {
  distinct_on: InputMaybe<Array<Payments_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Payments_Order_By>>;
  where: InputMaybe<Payments_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersReferralsArgs = {
  distinct_on: InputMaybe<Array<Users_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Users_Order_By>>;
  where: InputMaybe<Users_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersReferrals_AggregateArgs = {
  distinct_on: InputMaybe<Array<Users_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<Users_Order_By>>;
  where: InputMaybe<Users_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersRolesArgs = {
  distinct_on: InputMaybe<Array<UserRolesView_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserRolesView_Order_By>>;
  where: InputMaybe<UserRolesView_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersRoles_AggregateArgs = {
  distinct_on: InputMaybe<Array<UserRolesView_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserRolesView_Order_By>>;
  where: InputMaybe<UserRolesView_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersRuleValuesArgs = {
  distinct_on: InputMaybe<Array<UserRuleValues_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserRuleValues_Order_By>>;
  where: InputMaybe<UserRuleValues_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersRuleValues_AggregateArgs = {
  distinct_on: InputMaybe<Array<UserRuleValues_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserRuleValues_Order_By>>;
  where: InputMaybe<UserRuleValues_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersRulesArgs = {
  distinct_on: InputMaybe<Array<UserRules_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserRules_Order_By>>;
  where: InputMaybe<UserRules_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersRules_AggregateArgs = {
  distinct_on: InputMaybe<Array<UserRules_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserRules_Order_By>>;
  where: InputMaybe<UserRules_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUserDataArgs = {
  distinct_on: InputMaybe<Array<UserData_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserData_Order_By>>;
  where: InputMaybe<UserData_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUserData_AggregateArgs = {
  distinct_on: InputMaybe<Array<UserData_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserData_Order_By>>;
  where: InputMaybe<UserData_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUserDocumentsArgs = {
  distinct_on: InputMaybe<Array<UserDocuments_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserDocuments_Order_By>>;
  where: InputMaybe<UserDocuments_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUserDocuments_AggregateArgs = {
  distinct_on: InputMaybe<Array<UserDocuments_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserDocuments_Order_By>>;
  where: InputMaybe<UserDocuments_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUserRoleRequestApprovalsArgs = {
  distinct_on: InputMaybe<Array<UserRoleRequests_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserRoleRequests_Order_By>>;
  where: InputMaybe<UserRoleRequests_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUserRoleRequestApprovals_AggregateArgs = {
  distinct_on: InputMaybe<Array<UserRoleRequests_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserRoleRequests_Order_By>>;
  where: InputMaybe<UserRoleRequests_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUserRoleRequestsArgs = {
  distinct_on: InputMaybe<Array<UserRoleRequests_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserRoleRequests_Order_By>>;
  where: InputMaybe<UserRoleRequests_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUserRoleRequests_AggregateArgs = {
  distinct_on: InputMaybe<Array<UserRoleRequests_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserRoleRequests_Order_By>>;
  where: InputMaybe<UserRoleRequests_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUserRolesArgs = {
  distinct_on: InputMaybe<Array<UserRoles_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserRoles_Order_By>>;
  where: InputMaybe<UserRoles_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUserRoles_AggregateArgs = {
  distinct_on: InputMaybe<Array<UserRoles_Select_Column>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order_by: InputMaybe<Array<UserRoles_Order_By>>;
  where: InputMaybe<UserRoles_Bool_Exp>;
};

/** aggregated selection of "users" */
export type Users_Aggregate = {
  __typename?: 'users_aggregate';
  aggregate: Maybe<Users_Aggregate_Fields>;
  nodes: Array<Users>;
};

/** aggregate fields of "users" */
export type Users_Aggregate_Fields = {
  __typename?: 'users_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Users_Max_Fields>;
  min: Maybe<Users_Min_Fields>;
};


/** aggregate fields of "users" */
export type Users_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Users_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "users" */
export type Users_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Users_Max_Order_By>;
  min?: InputMaybe<Users_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Users_Append_Input = {
  auth0Data?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "users" */
export type Users_Arr_Rel_Insert_Input = {
  data: Array<Users_Insert_Input>;
  /** on conflict condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Bool_Exp>>;
  _not?: InputMaybe<Users_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Bool_Exp>>;
  apiKeys?: InputMaybe<ApiKeys_Bool_Exp>;
  auth0Data?: InputMaybe<Jsonb_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  devices?: InputMaybe<Devices_Bool_Exp>;
  documentCount?: InputMaybe<Int_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  leadLocksAdmin?: InputMaybe<LeadLocks_Bool_Exp>;
  leadLocksGranted?: InputMaybe<LeadLocks_Bool_Exp>;
  leadsHistories?: InputMaybe<LeadsHistory_Bool_Exp>;
  logTraces?: InputMaybe<LogTraces_Bool_Exp>;
  logs?: InputMaybe<Logs_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  payments?: InputMaybe<Payments_Bool_Exp>;
  paymentsTotal?: InputMaybe<Int_Comparison_Exp>;
  referrals?: InputMaybe<Users_Bool_Exp>;
  referrer?: InputMaybe<Users_Bool_Exp>;
  referrerId?: InputMaybe<Uuid_Comparison_Exp>;
  roles?: InputMaybe<UserRolesView_Bool_Exp>;
  ruleValues?: InputMaybe<UserRuleValues_Bool_Exp>;
  rules?: InputMaybe<UserRules_Bool_Exp>;
  sigmaPrime?: InputMaybe<UserData_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userData?: InputMaybe<UserData_Bool_Exp>;
  userDocuments?: InputMaybe<UserDocuments_Bool_Exp>;
  userRoleRequestApprovals?: InputMaybe<UserRoleRequests_Bool_Exp>;
  userRoleRequests?: InputMaybe<UserRoleRequests_Bool_Exp>;
  userRoles?: InputMaybe<UserRoles_Bool_Exp>;
};

/** unique or primary key constraints on table "users" */
export enum Users_Constraint {
  /** unique or primary key constraint */
  UsersEmailKey = 'users_email_key',
  /** unique or primary key constraint */
  UsersPkey = 'users_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Users_Delete_At_Path_Input = {
  auth0Data?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Users_Delete_Elem_Input = {
  auth0Data?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Users_Delete_Key_Input = {
  auth0Data?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "users" */
export type Users_Insert_Input = {
  apiKeys?: InputMaybe<ApiKeys_Arr_Rel_Insert_Input>;
  auth0Data?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  devices?: InputMaybe<Devices_Arr_Rel_Insert_Input>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  leadLocksAdmin?: InputMaybe<LeadLocks_Arr_Rel_Insert_Input>;
  leadLocksGranted?: InputMaybe<LeadLocks_Arr_Rel_Insert_Input>;
  leadsHistories?: InputMaybe<LeadsHistory_Arr_Rel_Insert_Input>;
  logTraces?: InputMaybe<LogTraces_Arr_Rel_Insert_Input>;
  logs?: InputMaybe<Logs_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  payments?: InputMaybe<Payments_Arr_Rel_Insert_Input>;
  referrals?: InputMaybe<Users_Arr_Rel_Insert_Input>;
  referrer?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  referrerId?: InputMaybe<Scalars['uuid']>;
  roles?: InputMaybe<UserRolesView_Arr_Rel_Insert_Input>;
  ruleValues?: InputMaybe<UserRuleValues_Arr_Rel_Insert_Input>;
  rules?: InputMaybe<UserRules_Arr_Rel_Insert_Input>;
  sigmaPrime?: InputMaybe<UserData_Obj_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userData?: InputMaybe<UserData_Arr_Rel_Insert_Input>;
  userDocuments?: InputMaybe<UserDocuments_Arr_Rel_Insert_Input>;
  userRoleRequestApprovals?: InputMaybe<UserRoleRequests_Arr_Rel_Insert_Input>;
  userRoleRequests?: InputMaybe<UserRoleRequests_Arr_Rel_Insert_Input>;
  userRoles?: InputMaybe<UserRoles_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Users_Max_Fields = {
  __typename?: 'users_max_fields';
  createdAt: Maybe<Scalars['timestamptz']>;
  email: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  referrerId: Maybe<Scalars['uuid']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "users" */
export type Users_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  referrerId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Users_Min_Fields = {
  __typename?: 'users_min_fields';
  createdAt: Maybe<Scalars['timestamptz']>;
  email: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  referrerId: Maybe<Scalars['uuid']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "users" */
export type Users_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  referrerId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "users" */
export type Users_Mutation_Response = {
  __typename?: 'users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Users>;
};

/** input type for inserting object relation for remote table "users" */
export type Users_Obj_Rel_Insert_Input = {
  data: Users_Insert_Input;
  /** on conflict condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** on conflict condition type for table "users" */
export type Users_On_Conflict = {
  constraint: Users_Constraint;
  update_columns: Array<Users_Update_Column>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** Ordering options when selecting data from "users". */
export type Users_Order_By = {
  apiKeys_aggregate?: InputMaybe<ApiKeys_Aggregate_Order_By>;
  auth0Data?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  devices_aggregate?: InputMaybe<Devices_Aggregate_Order_By>;
  documentCount?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  leadLocksAdmin_aggregate?: InputMaybe<LeadLocks_Aggregate_Order_By>;
  leadLocksGranted_aggregate?: InputMaybe<LeadLocks_Aggregate_Order_By>;
  leadsHistories_aggregate?: InputMaybe<LeadsHistory_Aggregate_Order_By>;
  logTraces_aggregate?: InputMaybe<LogTraces_Aggregate_Order_By>;
  logs_aggregate?: InputMaybe<Logs_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  paymentsTotal?: InputMaybe<Order_By>;
  payments_aggregate?: InputMaybe<Payments_Aggregate_Order_By>;
  referrals_aggregate?: InputMaybe<Users_Aggregate_Order_By>;
  referrer?: InputMaybe<Users_Order_By>;
  referrerId?: InputMaybe<Order_By>;
  roles_aggregate?: InputMaybe<UserRolesView_Aggregate_Order_By>;
  ruleValues_aggregate?: InputMaybe<UserRuleValues_Aggregate_Order_By>;
  rules_aggregate?: InputMaybe<UserRules_Aggregate_Order_By>;
  sigmaPrime?: InputMaybe<UserData_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userData_aggregate?: InputMaybe<UserData_Aggregate_Order_By>;
  userDocuments_aggregate?: InputMaybe<UserDocuments_Aggregate_Order_By>;
  userRoleRequestApprovals_aggregate?: InputMaybe<UserRoleRequests_Aggregate_Order_By>;
  userRoleRequests_aggregate?: InputMaybe<UserRoleRequests_Aggregate_Order_By>;
  userRoles_aggregate?: InputMaybe<UserRoles_Aggregate_Order_By>;
};

/** primary key columns input for table: users */
export type Users_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Users_Prepend_Input = {
  auth0Data?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "users" */
export enum Users_Select_Column {
  /** column name */
  Auth0Data = 'auth0Data',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ReferrerId = 'referrerId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "users" */
export type Users_Set_Input = {
  auth0Data?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  referrerId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "users" */
export enum Users_Update_Column {
  /** column name */
  Auth0Data = 'auth0Data',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ReferrerId = 'referrerId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']>;
  _gt?: InputMaybe<Scalars['uuid']>;
  _gte?: InputMaybe<Scalars['uuid']>;
  _in?: InputMaybe<Array<Scalars['uuid']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['uuid']>;
  _lte?: InputMaybe<Scalars['uuid']>;
  _neq?: InputMaybe<Scalars['uuid']>;
  _nin?: InputMaybe<Array<Scalars['uuid']>>;
};

/** columns and relationships of "videos" */
export type Videos = {
  __typename?: 'videos';
  category: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  description: Scalars['String'];
  id: Scalars['uuid'];
  title: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  url: Scalars['String'];
};

/** aggregated selection of "videos" */
export type Videos_Aggregate = {
  __typename?: 'videos_aggregate';
  aggregate: Maybe<Videos_Aggregate_Fields>;
  nodes: Array<Videos>;
};

/** aggregate fields of "videos" */
export type Videos_Aggregate_Fields = {
  __typename?: 'videos_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Videos_Max_Fields>;
  min: Maybe<Videos_Min_Fields>;
};


/** aggregate fields of "videos" */
export type Videos_Aggregate_FieldsCountArgs = {
  columns: InputMaybe<Array<Videos_Select_Column>>;
  distinct: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "videos". All fields are combined with a logical 'AND'. */
export type Videos_Bool_Exp = {
  _and?: InputMaybe<Array<Videos_Bool_Exp>>;
  _not?: InputMaybe<Videos_Bool_Exp>;
  _or?: InputMaybe<Array<Videos_Bool_Exp>>;
  category?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "videos" */
export enum Videos_Constraint {
  /** unique or primary key constraint */
  VideosPkey = 'videos_pkey'
}

/** input type for inserting data into table "videos" */
export type Videos_Insert_Input = {
  category?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Videos_Max_Fields = {
  __typename?: 'videos_max_fields';
  category: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['timestamptz']>;
  description: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  title: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
  url: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Videos_Min_Fields = {
  __typename?: 'videos_min_fields';
  category: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['timestamptz']>;
  description: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  title: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['timestamptz']>;
  url: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "videos" */
export type Videos_Mutation_Response = {
  __typename?: 'videos_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Videos>;
};

/** on conflict condition type for table "videos" */
export type Videos_On_Conflict = {
  constraint: Videos_Constraint;
  update_columns: Array<Videos_Update_Column>;
  where?: InputMaybe<Videos_Bool_Exp>;
};

/** Ordering options when selecting data from "videos". */
export type Videos_Order_By = {
  category?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: videos */
export type Videos_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "videos" */
export enum Videos_Select_Column {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "videos" */
export type Videos_Set_Input = {
  category?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
};

/** update columns of table "videos" */
export enum Videos_Update_Column {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Url = 'url'
}

export type UpdateUserDataMutationVariables = Exact<{
  id: Scalars['uuid'];
  userData: UserData_Set_Input;
}>;


export type UpdateUserDataMutation = { __typename?: 'mutation_root', update_userData_by_pk: { __typename?: 'userData', profileId: any } };

export type RegisterAndLoginUserMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
  userData: InputMaybe<UserData_Set_Input_Custom>;
  userRoleRequestsByName: InputMaybe<Array<UserRoleRequestByNameInput> | UserRoleRequestByNameInput>;
}>;


export type RegisterAndLoginUserMutation = { __typename?: 'mutation_root', registerAndLoginUser: { __typename?: 'RegisterAndLoginOutput', token: string, userId: string } };

export type GetUserDataQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetUserDataQuery = { __typename?: 'query_root', userData_by_pk: { __typename?: 'userData', profileId: any, personFirstName: string, personLastName: string, personPrimaryEmail: string, personPrimaryMobile: string, personPrimaryAddress1: string, personPrimaryAddress2: string, personPrimaryCity: string, personPrimaryProvinceState: string, personPrimaryPostalCode: string, personPrimaryCountry: string } };

export type MagentoOrdersQueryVariables = Exact<{ [key: string]: never; }>;


export type MagentoOrdersQuery = { __typename?: 'query_root', magentoOrders: { __typename?: 'MagentoOrdersOutput', orders: any } };

export type GetDigitalProductsForCustomerOrderQueryVariables = Exact<{
  orderNumber: Scalars['String'];
  productSku: Scalars['String'];
}>;


export type GetDigitalProductsForCustomerOrderQuery = { __typename?: 'query_root', getDigitalProductForCustomerOrder: { __typename?: 'GetDigitalProductForCustomerOrderOutput', sku: string, name: string, description: string, createdAt: any, updatedAt: any, groups: any } };

export type ValidateAddressQueryVariables = Exact<{
  address: AddressValidationInput;
}>;


export type ValidateAddressQuery = { __typename?: 'query_root', validateAddress: { __typename?: 'AddressValidationOutput', error: string, address1: string, address2: string, city: string, state: string, zip: string, zip4: string } };

export type HubSpotBlogQueryVariables = Exact<{
  tagId: Scalars['String'];
}>;


export type HubSpotBlogQuery = { __typename?: 'query_root', hubspotBlog: Array<{ __typename?: 'HubspotBlogOutput', postSummary: string, useFeaturedImage: boolean, state: string, rssBody: string, authorName: string, publishDate: any, slug: string, publishImmediately: boolean, created: any, postBody: string, domain: string, contentGroupId: string, url: string, metaDescription: string, updatedById: string, blogAuthorId: string, currentState: string, createdById: string, currentlyPublished: boolean, tagIds: number, featuredImage: string, widgets: string, name: string, language: string, archivedInDashboard: boolean, categoryId: number, htmlTitle: string, id: string, updated: any, layoutSections: string, deletedAt: any, widgetContainers: string, featuredImageAltText: string, rssSummary: string, archived: boolean, contentTypeCategory: number, attachedStylesheets: string }> };


export const UpdateUserDataDocument = gql`
    mutation updateUserData($id: uuid!, $userData: userData_set_input!) {
  update_userData_by_pk(pk_columns: {profileId: $id}, _set: $userData) {
    profileId
  }
}
    `;

export function useUpdateUserDataMutation() {
  return Urql.useMutation<UpdateUserDataMutation, UpdateUserDataMutationVariables>(UpdateUserDataDocument);
};
export const RegisterAndLoginUserDocument = gql`
    mutation registerAndLoginUser($email: String!, $password: String!, $userData: userData_set_input_custom, $userRoleRequestsByName: [userRoleRequestByNameInput!]) {
  registerAndLoginUser(
    email: $email
    password: $password
    userData: $userData
    userRoleRequestsByName: $userRoleRequestsByName
  ) {
    token
    userId
  }
}
    `;

export function useRegisterAndLoginUserMutation() {
  return Urql.useMutation<RegisterAndLoginUserMutation, RegisterAndLoginUserMutationVariables>(RegisterAndLoginUserDocument);
};
export const GetUserDataDocument = gql`
    query getUserData($id: uuid!) {
  userData_by_pk(profileId: $id) {
    profileId
    personFirstName
    personLastName
    personPrimaryEmail
    personPrimaryMobile
    personPrimaryAddress1
    personPrimaryAddress2
    personPrimaryCity
    personPrimaryProvinceState
    personPrimaryPostalCode
    personPrimaryCountry
  }
}
    `;

export function useGetUserDataQuery(options: Omit<Urql.UseQueryArgs<GetUserDataQueryVariables>, 'query'>) {
  return Urql.useQuery<GetUserDataQuery>({ query: GetUserDataDocument, ...options });
};
export const MagentoOrdersDocument = gql`
    query magentoOrders {
  magentoOrders {
    orders
  }
}
    `;

export function useMagentoOrdersQuery(options?: Omit<Urql.UseQueryArgs<MagentoOrdersQueryVariables>, 'query'>) {
  return Urql.useQuery<MagentoOrdersQuery>({ query: MagentoOrdersDocument, ...options });
};
export const GetDigitalProductsForCustomerOrderDocument = gql`
    query getDigitalProductsForCustomerOrder($orderNumber: String!, $productSku: String!) {
  getDigitalProductForCustomerOrder(
    orderNumber: $orderNumber
    productSku: $productSku
  ) {
    sku
    name
    description
    createdAt
    updatedAt
    groups
  }
}
    `;

export function useGetDigitalProductsForCustomerOrderQuery(options: Omit<Urql.UseQueryArgs<GetDigitalProductsForCustomerOrderQueryVariables>, 'query'>) {
  return Urql.useQuery<GetDigitalProductsForCustomerOrderQuery>({ query: GetDigitalProductsForCustomerOrderDocument, ...options });
};
export const ValidateAddressDocument = gql`
    query validateAddress($address: AddressValidationInput!) {
  validateAddress(address: $address) {
    error
    address1
    address2
    city
    state
    zip
    zip4
  }
}
    `;

export function useValidateAddressQuery(options: Omit<Urql.UseQueryArgs<ValidateAddressQueryVariables>, 'query'>) {
  return Urql.useQuery<ValidateAddressQuery>({ query: ValidateAddressDocument, ...options });
};
export const HubSpotBlogDocument = gql`
    query HubSpotBlog($tagId: String!) {
  hubspotBlog(tagId: $tagId) {
    postSummary
    useFeaturedImage
    state
    rssBody
    authorName
    publishDate
    slug
    publishImmediately
    created
    postBody
    domain
    contentGroupId
    url
    metaDescription
    updatedById
    blogAuthorId
    currentState
    createdById
    currentlyPublished
    tagIds
    featuredImage
    widgets
    name
    language
    archivedInDashboard
    categoryId
    htmlTitle
    id
    updated
    layoutSections
    deletedAt
    widgetContainers
    featuredImageAltText
    rssSummary
    archived
    contentTypeCategory
    attachedStylesheets
  }
}
    `;

export function useHubSpotBlogQuery(options: Omit<Urql.UseQueryArgs<HubSpotBlogQueryVariables>, 'query'>) {
  return Urql.useQuery<HubSpotBlogQuery>({ query: HubSpotBlogDocument, ...options });
};